import React, { useCallback, useEffect, useState, useRef, useMemo } from 'react';
import { View, Text, StyleSheet, Pressable, TextInput, Icon3, ActivityIndicator } from '../lib/react-native-compat';
import { loadUserData, fNum, pNum, loadCostDetailBillings, updateUserDataArray, deleteUserData, loadVariance, loadCostDetailCondensed, loadJobOpenCommitmentsCombined, loadK2Data, loadRelatedBUs } from '../db/company';
import ProjectNotes from './projectNotes';
import { useAtom } from 'jotai';
import { useApiTracker } from '../store/useApiStatus';

import {
    jobDataAtom,
    jobUserDataAtom,
    jobOpenCommitmentsAtom,
    jobCostDetailCondensedAtom,
    selectedJobAtom,
    selectedVersionAtom,
    dataSourceVersionAtom,
    budgetDeltaWipAtom,
    laborDeltaWipAtom,
    equipmentDeltaWipAtom,
    materialsDeltaWipAtom,
    subDeltaWipAtom,
    otherDeltaWipAtom,
    overheadDeltaWipAtom,
    projectCompleteAtom,
    isLiveVersionAtom,
    selectedJobDataAtom,
    overheadDataAtom,
    contingencyDeltaWipAtom,
    selectedWIPAtom,
    selectedVersionLockedAtom,
    equipmentRatesAtom,
    jobPhaseCodesAtom,
    k2DataAtom,
    varianceHistoryAtom,
    incentiveEligibleAtom,
    incentiveEligibleAmountAtom,
    incentiveCalcBreakdownAtom,
    incentiveRateAtom,
    userIdAtom,
    userEmailCheckAtom
} from '../store/company';
import moment from 'moment';
import { fieldBonusRemoved } from '../helpers/fieldBonus';
import { Line } from 'react-chartjs-2';
import { SERIES, alpha } from '../styles/chartColors';

const BidForecast = (a) => {
    const trackApi = useApiTracker('bidForecast');
    const [selectedJob, setSelectedJob] = useAtom(selectedJobAtom);
    const [selectedJobData, setSelectedJobData] = useAtom(selectedJobDataAtom);
    const [selectedVersion, setSelectedVersion] = useAtom(selectedVersionAtom);
    const [ohPercent, setOverheadPercent] = useState()
    const [contPercent, setContPercent] = useState()
    const [contBudgetPercent, setContBudgetPercent] = useState()
    const [selectedWIP, setSelectedWIP] = useAtom(selectedWIPAtom)
    const [lockedVersion, setLockedVersion] = useAtom(selectedVersionLockedAtom)
    const [varianceHistory, setVarianceHistory] = useAtom(varianceHistoryAtom)
    const [k2Data] = useAtom(k2DataAtom)
    const [pressed, setPressed] = useState('LEMSO')
    const [budgetDeltaWip, setBudgetDeltaWip] = useAtom(budgetDeltaWipAtom);
    const [laborDeltaWip, setLaborDeltaWip] = useAtom(laborDeltaWipAtom);
    const [equipmentDeltaWip, setEquipmentDeltaWip] = useAtom(equipmentDeltaWipAtom);
    const [materialsDeltaWip, setMaterialsDeltaWip] = useAtom(materialsDeltaWipAtom);
    const [subcontractorsDeltaWip, setSubsDeltaWip] = useAtom(subDeltaWipAtom);
    const [otherDeltaWip, setOtherDeltaWip] = useAtom(otherDeltaWipAtom);
    const [contingencyDeltaWip, setContingencyDeltaWip] = useAtom(contingencyDeltaWipAtom);
    const [overheadDeltaWip, setOverheadDeltaWip] = useAtom(overheadDeltaWipAtom);

    const [jobData, setJobData] = useAtom(jobDataAtom);
    const [parentJobUserData, setJobUserData] = useAtom(jobUserDataAtom);
    const [parentJobOpenCommitments, setJobOpenCommitments] = useAtom(jobOpenCommitmentsAtom);
    const [parentJobCostDetail] = useAtom(jobCostDetailCondensedAtom);
    const [versions, setVersions] = useAtom(dataSourceVersionAtom)
    const [jobPhaseCodes, setJobPhaseCodes] = useAtom(jobPhaseCodesAtom);
    const [projectComplete, setProjectComplete] = useAtom(projectCompleteAtom)
    const [isLiveVersion, setIsLiveVersion] = useAtom(isLiveVersionAtom)
    const [overheadData, setOverheadData] = useAtom(overheadDataAtom);

    const [percentDeltaWip, setPercentDeltaWip] = useState(0)
    const [grossMarginDeltaWip, setGrossMarginDeltaWip] = useState(0)
    const [grossMarginDeltaWipPercent, setGrossMarginDeltaWipPercent] = useState(0)
    const [etcValueList, setEtcValueList] = useState([])
    const [deletingEtcRows, setDeletingEtcRows] = useState(new Set())

    const [dayZeroBudgetContract, setDayZeroBudgetContract] = useState('-')
    const [dayZeroBudgetLabor, setDayZeroBudgetLabor] = useState('-')
    const [dayZeroBudgetEquipment, setDayZeroBudgetEquipment] = useState('-')
    const [dayZeroBudgetMaterials, setDayZeroBudgetMaterials] = useState('-')
    const [dayZeroBudgetSubcontractors, setDayZeroBudgetSubcontractors] = useState('-')
    const [dayZeroBudgetOtherExpenses, setDayZeroBudgetOtherExpenses] = useState('-')
    const [dayZeroBudgetContingency, setDayZeroBudgetContingency] = useState('-')
    const [dayZeroBudgetTotalCosts, setDayZeroBudgetTotalCosts] = useState('-')
    const [dayZeroBudgetJobProfit, setDayZeroBudgetJobProfit] = useState('-')
    const [dayZeroBudgetJP, setDayZeroBudgetJP] = useState('-')
    const [dayZeroBudgetOH, setDayZeroBudgetOH] = useState('-')
    const [dayZeroBudgetGM, setDayZeroBudgetGM] = useState('-')
    const [dayZeroBudgetGMP, setDayZeroBudgetGMP] = useState('-')

    const [budgetEACContract, setBudgetEACContract] = useState('-')
    const [budgetEACLabor, setBudgetEACLabor] = useState('-')
    const [budgetEACEquipment, setBudgetEACEquipment] = useState('-')
    const [budgetEACMaterials, setBudgetEACMaterials] = useState('-')
    const [budgetEACSubcontractors, setBudgetEACSubcontractors] = useState('-')
    const [budgetEACOtherExpenses, setBudgetEACOtherExpenses] = useState('-')
    const [budgetEACContingency, setBudgetEACContingency] = useState('-')
    const [budgetEACTotalCosts, setBudgetEACTotalCosts] = useState('-')
    const [budgetEACJobProfit, setBudgetEACJobProfit] = useState('-')
    const [budgetEACJP, setBudgetEACJP] = useState('-')
    const [budgetEACOH, setBudgetEACOH] = useState('-')
    const [budgetEACGM, setBudgetEACGM] = useState('-')
    const [budgetEACGMP, setBudgetEACGMP] = useState('-')

    const [JTDRevenuePrevPeriod, setJTDRevenuePrevPeriod] = useState('-')
    const [JTDLabor, setJTDLabor] = useState('-')
    const [JTDEquipment, setJTDEquipment] = useState('-')
    const [JTDMaterials, setJTDMaterials] = useState('-')
    const [JTDSubcontractors, setJTDSubcontractors] = useState('-')
    const [JTDOtherExpenses, setJTDOtherExpenses] = useState('-')
    const [JTDTotalCosts, setJTDTotalCosts] = useState('-')
    const [JTDOH, setJTDOH] = useState('-')

    const [laborSubRows, setLaborSubRows] = useState([])
    const [equipmentSubRows, setEquipmentSubRows] = useState([])
    const [materialsSubRows, setMaterialsSubRows] = useState([])
    const [subcontractorsSubRows, setSubcontractorsSubRows] = useState([])
    const [otherExpensesSubRows, setOtherExpensesSubRows] = useState([])

    const [laborCommitments, setLaborCommitments] = useState('-')
    const [equipmentCommitments, setEquipmentCommitments] = useState('-')
    const [materialsCommitments, setMaterialsCommitments] = useState('-')
    const [subcontractorsCommitments, setSubcontractorsCommitments] = useState('-')
    const [externalSubcontractorsCommitments, setExternalSubcontractorsCommitments] = useState('-')
    const [otherExpensesCommitments, setOtherExpensesCommitments] = useState('-')
    const [totalCommitments, setTotalCommitments] = useState('-')
    const [ohCommitments, setOHCommitments] = useState('')

    const [etcLabor, setEtcLabor] = useState('-')
    const [etcEquipment, setEtcEquipment] = useState('-')
    const [etcMaterials, setEtcMaterials] = useState('-')
    const [etcSubcontractors, setEtcSubcontractors] = useState('-')
    const [etcExternalSubcontractors, setEtcExternalSubcontractors] = useState('-')
    const [etcOtherExpenses, setEtcOtherExpenses] = useState('-')
    const [etcContigency, setEtcContigency] = useState('-')
    const [etcTotal, setEtcTotal] = useState()
    const [etcOHAllocation, setEtcOHAllocation] = useState()

    const [eacRevenue, setEacRevenue] = useState('-')
    const [eacLabor, setEacLabor] = useState('')
    const [eacEquipment, setEacEquipment] = useState('')
    const [eacMaterials, setEacMaterials] = useState('')
    const [eacSubcontractors, setEacSubcontractors] = useState('')
    const [eacExternalSubcontractors, setEacExternalSubcontractors] = useState('')
    const [eacOtherExpenses, setEacOtherExpenses] = useState('')
    const [eacTotal, setEacTotal] = useState('')
    const [eacTotalProfit, setEacTotalProfit] = useState('')
    const [eacTotalProfitPercent, setEacTotalProfitPercent] = useState('')
    const [eacOHAllocation, setEacOHAllocation] = useState('')
    const [eacGM, setEacGM] = useState('')
    const [eacGMP, setEacGMP] = useState('')

    const [coContractValue, setCoContractValue] = useState('-')
    const [coMaterialsValue, setCoMaterialsValue] = useState('-')
    const [coLaborValue, setCoLaborValue] = useState('-')
    const [coEquipmentValue, setCoEquipmentValue] = useState('-')
    const [coSubcontractorsValue, setCoSubcontractorsValue] = useState('-')
    const [coOtherValue, setCoOtherValue] = useState('-')
    const [coContingencyValue, setCoContingencyValue] = useState()
    const [coTotalValue, setCoTotalValue] = useState('-')
    const [coTotalProfit, setCoTotalProfit] = useState('-')
    const [coTotalProfitPercent, setCoTotalProfitPercent] = useState('-')
    const [coOHAllocation, setCoOHAllocation] = useState('-')
    const [coGM, setCoGM] = useState('-')
    const [coGMP, setCoGMP] = useState('-')

    const [phaseRows, setPhaseRows] = useState([])
    const [resourceRows, setResourceRows] = useState([])
    const [serviceOfferingRows, setServiceOfferingRows] = useState([])
    const [serviceOfferingTotals, setServiceOfferingTotals] = useState({ dollarsLastWeek: '', hoursLastWeek: '', hoursRemaining: '' })
    const [expandedServiceOfferings, setExpandedServiceOfferings] = useState({})
    // Service Offering panel is still in progress — limit it to Seth and Steve for now
    // (matches the WIP gating used in laborDashboard.js / sideMenu.js).
    const [userId] = useAtom(userIdAtom)
    const [userEmailCheck] = useAtom(userEmailCheckAtom)
    const canSeeServiceOffering = process.env.NODE_ENV !== 'production'
        || userId === '154045'
        || userEmailCheck === 'seth.bailey@strikeusa.com'
        || userEmailCheck === 'steve.horman@strikeusa.com'
        || userEmailCheck === 'steven.horman@strikeusa.com'

    const [deltaEACLabor, setDeltaEACLabor] = useState('-')
    const [deltaEACEquipment, setDeltaEACEquipment] = useState('-')
    const [deltaEACMaterials, setDeltaEACMaterials] = useState('-')
    const [deltaEACSubcontractors, setDeltaEACSubcontractors] = useState('-')
    const [deltaEACOtherExpenses, setDeltaEACOtherExpenses] = useState('-')
    const [deltaEACContingency, setDeltaEACContingency] = useState('-')
    const [deltaEACTotalCosts, setDeltaEACTotalCosts] = useState('-')
    const [deltaEACJobProfit, setDeltaEACJobProfit] = useState('-')
    const [deltaEACJP, setDeltaEACJP] = useState('-')
    const [deltaEACOH, setDeltaEACOH] = useState('-')
    const [deltaEACGM, setDeltaEACGM] = useState('-')
    const [deltaEACGMP, setDeltaEACGMP] = useState('-')

    const [deltaZeroLabor, setDeltaZeroLabor] = useState('-')
    const [deltaZeroEquipment, setDeltaZeroEquipment] = useState('-')
    const [deltaZeroMaterials, setDeltaZeroMaterials] = useState('-')
    const [deltaZeroSubcontractors, setDeltaZeroSubcontractors] = useState('-')
    const [deltaZeroOtherExpenses, setDeltaZeroOtherExpenses] = useState('-')
    const [deltaZeroContingency, setDeltaZeroContingency] = useState('-')
    const [deltaZeroTotalCosts, setDeltaZeroTotalCosts] = useState('-')
    const [deltaZeroJobProfit, setDeltaZeroJobProfit] = useState('-')
    const [deltaZeroJP, setDeltaZeroJP] = useState('-')
    const [deltaZeroOH, setDeltaZeroOH] = useState('-')
    const [deltaZeroGM, setDeltaZeroGM] = useState('-')
    const [deltaZeroGMP, setDeltaZeroGMP] = useState('-')
    const [notes, setNotes] = useState('')
    const [physicalComplete, setPhysicalComplete] = useState()
    const [wipPhysicalComplete, setWipPhysicalComplete] = useState()
    const [nteAmount, setNteAmount] = useState()

    const [costPercent, setCostPercent] = useState('-')
    const [incentiveEligible] = useAtom(incentiveEligibleAtom)
    const [incentiveEligibleAmount] = useAtom(incentiveEligibleAmountAtom)
    const [incentiveRate, setIncentiveRate] = useAtom(incentiveRateAtom)
    const [incentiveCalcBreakdown] = useAtom(incentiveCalcBreakdownAtom)
    const [fieldBonus, setFieldBonus] = useState('')

    const [billings, setBillings] = useState('-')
    const [leftToBill, setLeftToBill] = useState('-')
    const [laborPercent, setLaborPercent] = useState('-')
    const [billingPercent, setBillingPercent] = useState('-')

    const [commited, setCommited] = useState({})
    const [userValues, setUserValues] = useState({})
    const [coValues, setCoValues] = useState({})
    const [costDate, setCostDate] = useState()
    const [afterCostActual, setAfterCostActual] = useState()
    const [afterCostOHEst, setAfterCostOHEst] = useState()
    const [estEarnedRev, setEstEarnedRev] = useState('-')

    const [versionInfo, setVersionInfo] = useState({})
    // Field Bonus (51800) is retired for versions June 18, 2026 forward — hide
    // the sub-row and drop its ETC from every total for those versions only.
    const hideFieldBonus = fieldBonusRemoved(versionInfo?.Version_Start_DateTime)
    const [varianceWeeks, setVarianceWeeks] = useState([])
    const [weekTotalMaps, setWeekTotalMaps] = useState({})
    const [weekEtcGroupMaps, setWeekEtcGroupMaps] = useState({})
    const [weekJtdGroupMaps, setWeekJtdGroupMaps] = useState({})
    const [weekCommittedGroupMaps, setWeekCommittedGroupMaps] = useState({})
    // Per-phase variance maps so the phase view can show a per-version EAC per phase.
    const [weekEtcPhaseMaps, setWeekEtcPhaseMaps] = useState({})
    const [weekJtdPhaseMaps, setWeekJtdPhaseMaps] = useState({})
    const [weekCommittedPhaseMaps, setWeekCommittedPhaseMaps] = useState({})
    const [weekLoading, setWeekLoading] = useState({})
    const [weekDisplayMode, setWeekDisplayMode] = useState({})
    const [weekCostTypeMaps, setWeekCostTypeMaps] = useState({})
    const [weekCoRevenueMaps, setWeekCoRevenueMaps] = useState({})
    const [openWeekDropdown, setOpenWeekDropdown] = useState(null)
    const getWeekLabel = (guid) => {
        if (selectedWIP && guid === selectedWIP.Version_GUID) return 'WIP ' + moment(selectedWIP.Version_Start_DateTime).format('MMM D');
        if (versions && versions.length) {
            const v = versions.find(v => v.Version_GUID === guid);
            if (v) return moment(v.Version_Start_DateTime).format('MMM D');
        }
        return '';
    }
    const versionOptions = useMemo(() => {
        if (!versions || !versions.length) return [];
        const allowed = ['WIP', 'Regular', 'Reg-locked', 'Unassigned', 'WIP-locked'];
        return versions
            .filter(v => allowed.includes(v.Version_Type) && v.Version_GUID !== selectedVersion)
            .map(v => ({
                guid: v.Version_GUID,
                label: moment(v.Version_Start_DateTime).format('MMM D, YYYY') + (v.Version_Type.includes('WIP') ? ' - WIP' : ''),
                date: v.Version_Start_DateTime,
            }))
            .sort((a, b) => new Date(b.date) - new Date(a.date));
    }, [versions, selectedVersion]);
    const changeWeekVersion = (oldGuid, newGuid) => {
        setVarianceWeeks(prev => prev.map(g => g === oldGuid ? newGuid : g));
        setOpenWeekDropdown(null);
    };
    const removeWeekColumn = (guid) => {
        setVarianceWeeks(prev => prev.filter(g => g !== guid));
    };
    const addWeekColumn = () => {
        const unused = versionOptions.filter(v => !varianceWeeks.includes(v.guid));
        if (unused.length) {
            setVarianceWeeks(prev => [...prev, unused[0].guid]);
        }
    };

    // Variance week columns start empty; users add them via the "+ Week" button.
    const [k2BudgetContract, setK2BudgetContract] = useState('-')
    const [k2BudgetJobProfit, setK2BudgetJobProfit] = useState('-')
    const [k2BudgetTotalCosts, setK2BudgetTotalCosts] = useState('-')
    const [k2BudgetJP, setK2BudgetJP] = useState('-')
    const [k2BudgetOH, setK2BudgetOH] = useState('-')
    const [k2BudgetGM, setK2BudgetGM] = useState('-')
    const [k2BudgetGMP, setK2BudgetGMP] = useState('-')
    const [k2BudgetLabor, setK2BudgetLabor] = useState('-')
    const [k2BudgetEquipment, setK2BudgetEquipment] = useState('-')
    const [k2BudgetMaterials, setK2BudgetMaterials] = useState('-')
    const [k2BudgetSubcontractors, setK2BudgetSubcontractors] = useState('-')
    const [k2BudgetOther, setK2BudgetOther] = useState('-')
    const [k2BudgetContingency, setK2BudgetContingency] = useState('-')

    const [phasedLaborRows, setPhasedLaborRows] = useState([])
    const [phasedEquipmentRows, setPhasedEquipmentRows] = useState([])

    const [equipmentEtcList, setEquipmentEtcList] = useState([])
    const [materialsEtcList, setMaterialsEtcList] = useState([])
    const [subcontractorsEtcList, setSubcontractorsEtcList] = useState([])
    const [otherEtcList, setOtherEtcList] = useState([])
    const [equipmentEtcTotal, setEquipmentEtcTotal] = useState(0)
    const [materialsEtcTotal, setMaterialsEtcTotal] = useState(0)
    const [materialsEtcTotalTwo, setMaterialsEtcTotalTwo] = useState(0)
    const [subcontractorsEtcTotal, setSubcontractorsEtcTotal] = useState(0)
    const [otherEtcTotal, setOtherEtcTotal] = useState(0)
    const changeListRef = useRef([])
    const [showGroup, setShowGroup] = useState(false)

    // Children = BUs whose Related_BU points at the currently selected job.
    // Sourced from Dim_BU_Master via /api/readRelatedBUs so children that fall
    // outside the filtered jobData (JP rows, non-OPS, etc.) still surface the
    // +Group indicator. relatedLoading drives a small spinner in the pill slot
    // while the check is in flight.
    const [childJobIds, setChildJobIds] = useState([])
    const [relatedLoading, setRelatedLoading] = useState(false)

    useEffect(() => {
        if (!selectedJob) { setChildJobIds([]); setRelatedLoading(false); return }
        let cancelled = false
        setRelatedLoading(true)
        setChildJobIds([])
        trackApi('loadRelatedBUs', 'load', () => loadRelatedBUs({ id: selectedJob }))
            .then(res => {
                if (cancelled) return
                const ids = (res?.data || [])
                    .map(r => r?.BU_ID)
                    .filter(b => b != null && String(b) !== String(selectedJob))
                setChildJobIds(ids)
            })
            .catch(() => { if (!cancelled) setChildJobIds([]) })
            .finally(() => { if (!cancelled) setRelatedLoading(false) })
        return () => { cancelled = true }
    }, [selectedJob])

    const isParentJob = childJobIds.length > 0
    const groupMemberIds = useMemo(
        () => (showGroup && isParentJob ? [selectedJob, ...childJobIds] : [selectedJob]),
        [showGroup, isParentJob, selectedJob, childJobIds]
    )

    // Per-child data loaded only when group mode is active. Keyed by BU_ID.
    const [childUserData, setChildUserData] = useState({})
    const [childOpenCommitments, setChildOpenCommitments] = useState({})
    const [childCostDetail, setChildCostDetail] = useState({})
    const [childBillingsTotal, setChildBillingsTotal] = useState(0)
    const [childK2Data, setChildK2Data] = useState({})
    // True while group-mode child fetches are in flight (drives the +Group button spinner).
    const [groupLoading, setGroupLoading] = useState(false)

    // Clear groupMode automatically when switching jobs / when the new job is not a parent.
    // Skip while the related-BU check is in flight so we don't flip off group mode mid-check
    // (childJobIds is briefly [] before the API resolves).
    useEffect(() => {
        if (!isParentJob && showGroup && !relatedLoading) setShowGroup(false)
    }, [selectedJob, isParentJob, relatedLoading])

    // Reset child caches whenever the parent job / version / group toggle changes.
    useEffect(() => {
        setChildUserData({})
        setChildOpenCommitments({})
        setChildCostDetail({})
        setChildBillingsTotal(0)
        setChildK2Data({})
    }, [selectedJob, selectedVersion, showGroup])

    // When group mode is active, fetch each child's user data, open commitments,
    // condensed cost detail, K2 budget, and billings, then expose them via effective* memos.
    // groupLoading stays true until every child fetch settles so the UI can show a spinner
    // rather than letting the aggregated numbers visibly jump as each child resolves.
    useEffect(() => {
        if (!showGroup || !selectedVersion || childJobIds.length === 0) { setGroupLoading(false); return }

        let cancelled = false
        setGroupLoading(true)

        const perChild = childJobIds.map(bu => {
            const pUser = trackApi('loadUserData', 'load', () => loadUserData({ id: bu, forecastGuid: selectedVersion, live: isLiveVersion }))
                .then(res => { if (!cancelled) setChildUserData(prev => ({ ...prev, [bu]: res?.data || [] })) })
                .catch(() => {})

            const pCommit = trackApi('loadJobOpenCommitmentsCombined', 'load', () => loadJobOpenCommitmentsCombined({ id: bu, versionGuid: selectedVersion }))
                .then(res => { if (!cancelled) setChildOpenCommitments(prev => ({ ...prev, [bu]: res?.data || [] })) })
                .catch(() => {})

            const pCost = trackApi('loadCostDetailCondensed', 'load', () => loadCostDetailCondensed({ jobNumber: bu, versionGuid: selectedVersion }))
                .then(res => { if (!cancelled) setChildCostDetail(prev => ({ ...prev, [bu]: res?.data || [] })) })
                .catch(() => {})

            // K2 budget is a per-job header constant; fetch each child's so effectiveK2Data
            // can sum the group's budget (the K2 Budget column was parent-only before this).
            const pK2 = trackApi('loadK2Data', 'load', () => loadK2Data({ id: bu }))
                .then(res => { if (!cancelled) setChildK2Data(prev => ({ ...prev, [bu]: res?.data?.[0] || null })) })
                .catch(() => {})

            return Promise.all([pUser, pCommit, pCost, pK2])
        })

        // loadCostDetailBillings already accepts an array of ids; ask for child billings only here.
        const pBillings = trackApi('loadCostDetailBillings', 'load', () => loadCostDetailBillings({ ids: childJobIds, version: selectedVersion }))
            .then(res => {
                if (cancelled) return
                const total = (res?.data || []).reduce((s, r) => s + pNum(r?.Total_Job_Cost), 0)
                setChildBillingsTotal(total)
            })
            .catch(() => {})

        Promise.all([...perChild, pBillings]).then(() => { if (!cancelled) setGroupLoading(false) })

        return () => { cancelled = true }
    }, [showGroup, selectedVersion, isLiveVersion, childJobIds])

    // Prefix Forecast_Row_ID with the child BU_ID so the existing aggregation maps
    // (keyed by Forecast_Row_ID) don't collide between jobs.
    const prefixRows = (bu, rows) => (rows || []).map(r => ({
        ...r,
        Forecast_Row_ID: r?.Forecast_Row_ID != null ? `${bu}_${r.Forecast_Row_ID}` : r?.Forecast_Row_ID,
    }))

    // Child rows are tagged `${bu}_<originalRowId>` by prefixRows so per-job maps keyed by
    // Forecast_Row_ID don't collide in group mode. But several cost totals PARSE the Row ID
    // positionally — week = split('*')[0], date keys via length === 10 — and the leading
    // numeric `${bu}_` shifts the week/date off the front, so those parses fail and the child
    // job's non-phased burn-tool labor/equipment silently drops out of the group total.
    // Strip the BU tag before any positional parse. No-op for the parent: real Row IDs are
    // dates/`phase=week`/`week*…` and never start with `<digits>_`.
    const stripBuPrefix = (id) => String(id ?? '').replace(/^\d+_/, '')

    // Recover the owning BU_ID from a (possibly prefixed) Forecast_Row_ID. Parent rows are
    // unprefixed and map to the selected job; child rows carry the leading `${bu}_` tag.
    const rowJobId = (id) => {
        const m = String(id ?? '').match(/^(\d+)_/)
        return m ? m[1] : String(selectedJob)
    }

    const jobUserData = useMemo(() => {
        if (!showGroup || childJobIds.length === 0) return parentJobUserData
        const out = [...(parentJobUserData || [])]
        childJobIds.forEach(bu => out.push(...prefixRows(bu, childUserData[bu])))
        return out
    }, [showGroup, childJobIds, parentJobUserData, childUserData])

    // Each job in a group can finish on a different date. The burn-tool ETC loops clip every
    // row to a project-complete window, and Labor is the ONLY category that lives entirely on
    // that windowed path (cost type 51100 is skipped in the non-windowed etcValues path), so a
    // child whose schedule runs past the parent's completion loses its labor in the group total.
    // Build a per-job completion map keyed by BU_ID. Read each job's completionDateForecast from
    // its OWN source rows — NOT the merged, BU-prefixed jobUserData: those rows can carry a null
    // Row_ID that can't be tagged back to a job, which cross-assigns dates between parent & child.
    // Parent keeps the projectComplete atom (no change vs. single-job); only children are added.
    const jobCompletion = useMemo(() => {
        const latestCompletion = (rows) => {
            let v = null
            ;(rows || []).forEach(d => {
                if (d?.Forecast_Field_Name === 'completionDateForecast' && d?.Forecast_Value) v = d.Forecast_Value
            })
            return v
        }
        const m = { [String(selectedJob)]: projectComplete }
        childJobIds.forEach(bu => { m[String(bu)] = latestCompletion(childUserData[bu]) || projectComplete })
        return m
    }, [childUserData, childJobIds, selectedJob, projectComplete])
    const completionFor = (id) => jobCompletion[rowJobId(id)] || projectComplete

    const jobOpenCommitments = useMemo(() => {
        if (!showGroup || childJobIds.length === 0) return parentJobOpenCommitments
        const out = [...(parentJobOpenCommitments || [])]
        childJobIds.forEach(bu => out.push(...(childOpenCommitments[bu] || [])))
        return out
    }, [showGroup, childJobIds, parentJobOpenCommitments, childOpenCommitments])

    const jobCostDetail = useMemo(() => {
        if (!showGroup || childJobIds.length === 0) return parentJobCostDetail
        const out = [...(parentJobCostDetail || [])]
        childJobIds.forEach(bu => out.push(...(childCostDetail[bu] || [])))
        return out
    }, [showGroup, childJobIds, parentJobCostDetail, childCostDetail])

    // Consolidated K2 budget for group mode. K2 fields are additive across jobs
    // (contract, OH, and each cost bucket), so summing parent + children yields the
    // group's budget. Without this the "K2 Budget" column stayed parent-only while
    // costs/EAC aggregated — making the group's JP/GM-vs-budget comparison wrong.
    const effectiveK2Data = useMemo(() => {
        // OH allocation derives from the live Applied_Overhead_Percentage, not the
        // stored Overhead_Allocation dollar column, which can lag the K2 form when a
        // job is edited without re-publishing (the % stays accurate but the dollar
        // figure goes stale). Parse the rate with parseFloat — NOT pNum, which
        // truncates to 2 decimals and would collapse 0.049174 into 0.04 (~20% off).
        // The rate is stored as a fraction (0.049174); the > 1 guard also accepts a
        // percentage form (4.917) if one ever appears. Falls back to the stored
        // dollar column only when the % is missing.
        const computeOH = (o) => {
            if (!o) return 0
            const raw = parseFloat(o.Applied_Overhead_Percentage)
            const rate = raw > 1 ? raw / 100 : raw
            return (rate && pNum(o.Estimated_Project_Amount))
                ? rate * pNum(o.Estimated_Project_Amount)
                : pNum(o.Overhead_Allocation)
        }
        if (!showGroup || childJobIds.length === 0) {
            if (!k2Data || typeof k2Data !== 'object' || Object.keys(k2Data).length === 0) return k2Data
            return { ...k2Data, Overhead_Allocation: computeOH(k2Data) }
        }
        const members = [k2Data, ...childJobIds.map(bu => childK2Data[bu])].filter(o => o && typeof o === 'object')
        if (members.length === 0) return k2Data
        // Overhead_Allocation is summed from per-member computed OH (each job may
        // carry its own %), not from the raw stored column.
        const K2_NUMERIC = ['Estimated_Project_Amount', 'Expected_Cost', 'Cost_Labor', 'Cost_Equipment', 'Cost_Materials', 'Cost_Subcontract', 'Cost_Other', 'Cost_Contingency']
        const summed = { ...(k2Data || {}) }
        K2_NUMERIC.forEach(f => { summed[f] = members.reduce((s, o) => s + pNum(o[f]), 0) })
        summed.Overhead_Allocation = members.reduce((s, o) => s + computeOH(o), 0)
        return summed
    }, [showGroup, childJobIds, k2Data, childK2Data])

    useEffect(() => {
        console.log('varianceHistory updated:', varianceHistory);
    }, [varianceHistory]);

    // Load fusion data for each variance week version
    useEffect(() => {
        if (!selectedJob || !varianceWeeks.length) return;
        const wipGuid = selectedWIP?.Version_GUID;
        if (!varianceWeeks.length) { setWeekLoading({}); return; }

        const loadingState = {};
        varianceWeeks.forEach(g => { loadingState[g] = true; });
        setWeekLoading(loadingState);

        Promise.all(varianceWeeks.map(async guid => {
            const ver = versions?.find(v => v.Version_GUID === guid);
            if (!ver) return { guid, data: null };
            const wip = moment(ver.Version_Start_DateTime).format('YYYY-MM-DD');
            const res = await trackApi('loadVariance', 'load', () => loadVariance({
                id: selectedJob,
                forecastGuid: guid,
                forecastGuidTwo: wipGuid,
                wip
            }));
            return { guid, data: res?.variance || [] };
        })).then(results => {
            const maps = {};
            results.forEach(({ guid, data }) => {
                if (!data) return;
                const vals = {};
                data.forEach(d => {
                    if (d?.Account_Group === '41000') vals.contract = -1 * pNum(d?.Total_Amount);
                    else if (d?.Account_Group === '51000') vals.labor = pNum(d?.Total_Amount);
                    else if (d?.Account_Group === '52000') vals.equipment = pNum(d?.Total_Amount);
                    else if (d?.Account_Group === '53000') vals.materials = pNum(d?.Total_Amount);
                    else if (d?.Account_Group === '54000') vals.subcontractors = pNum(d?.Total_Amount);
                    else if (d?.Account_Group === '55000') vals.other = pNum(d?.Total_Amount);
                    else if (d?.Account_Group === '101101') vals.contingency = pNum(d?.Total_Amount);
                    else if (d?.Account_Group === '60900') vals.overhead = pNum(d?.Total_Amount);
                });
                const totalCosts = (vals.labor || 0) + (vals.equipment || 0) + (vals.materials || 0) + (vals.subcontractors || 0) + (vals.other || 0) + (vals.contingency || 0);
                vals.totalCosts = totalCosts;
                const jobProfit = (vals.contract || 0) - totalCosts;
                vals.jobProfit = jobProfit;
                vals.jpPercent = vals.contract ? (jobProfit / vals.contract * 100).toFixed(2) + '%' : '';
                const gm = jobProfit - (vals.overhead || 0);
                vals.gm = gm;
                vals.gmPercent = vals.contract ? (gm / vals.contract * 100).toFixed(2) + '%' : '';
                maps[guid] = vals;
            });
            setWeekTotalMaps(maps);
            setWeekLoading({});
        });
    }, [varianceWeeks, selectedJob]);

    // Load user data for each variance week to get per-cost-type ETC (sub-row level variance)
    useEffect(() => {
        if (!selectedJob || !varianceWeeks.length || !versions?.length) return;
        Promise.all(varianceWeeks.map(async guid => {
            try {
                const ver = versions.find(v => v.Version_GUID === guid);
                const verStart = ver?.Version_Start_DateTime;
                const userData = await trackApi('loadUserData', 'load', () => loadUserData({ id: selectedJob, forecastGuid: guid, live: false }));
                const data = userData?.data || [];
                const etcByCostType = {};
                const phasedLabor = {};
                const phasedEquipment = {};
                const laborValues = {};
                const equipmentValues = {};
                const chOrValues = {};
                // Find the comparison version's project complete date.
                // Field name must match topMenu.js's 'completionDateForecast' — using 'completion'
                // here silently falls back to the current version's projectComplete, which widens
                // the burn-tool window for older variance weeks and over-counts ETC.
                let compProjectComplete = projectComplete;
                data.forEach(d => {
                    if (d?.Forecast_Field_Name === 'completionDateForecast' && d?.Forecast_Value) {
                        compProjectComplete = d.Forecast_Value;
                    }
                });
                // Parse user data — same logic as main calculation
                data.forEach(d => {
                    // Burn Tool Labor Phased
                    if (d?.Forecast_Tab === 'Burn Tool Labor Phased') {
                        phasedLabor[d?.Forecast_Row_ID] = { id: d?.Forecast_Row_ID, ...d };
                    }
                    // Burn Tool Equipment Phased
                    if (d?.Forecast_Tab === 'Burn Tool Equipment Phased') {
                        phasedEquipment[d?.Forecast_Row_ID] = { id: d?.Forecast_Row_ID, ...d };
                    }
                    // Burn Tool Equipment (non-phased)
                    if (d?.Forecast_Tab === 'Burn Tool Equipment') {
                        equipmentValues[d?.Forecast_Row_ID] = d;
                    }
                    // Burn Tool Labor (non-phased)
                    if (d?.Forecast_Tab === 'Burn Tool Labor') {
                        laborValues[d?.Forecast_Row_ID] = d;
                    }
                    // ETC entries (non-burn-tool items)
                    if (d?.Cost_Type && d?.Forecast_Field_Name === 'etc' && (!d?.Cost_Code || d?.Cost_Code !== '101101')) {
                        if (d.Cost_Type !== '51100') { // 51100 comes from burn tool
                            etcByCostType[d.Cost_Type] = (etcByCostType[d.Cost_Type] || 0) + pNum(d?.Value_Amount);
                        }
                    }
                    // Change Order log — collected to compute the version's approved CO revenue
                    if (d?.Forecast_Tab === 'Change Order') {
                        chOrValues[d?.Forecast_User_Data_GUID || d?.Forecast_Row_ID] = { ...d, [d.Cost_Type]: d.Value_Amount, id: d.Row_Label };
                    }
                });
                // Sum approved CO revenue rows (Cost_Type 41000) — mirrors main view (lines ~1031-1095)
                const coRevenueMap = {};
                Object.values(chOrValues).forEach(row => {
                    const coId = row.Row_Label || row.id || '';
                    const status = (row.Status || row.status || '').toLowerCase();
                    const costType = row.Cost_Type || '';
                    if (status === 'approved' && (costType == 41000 || costType == '41000')) {
                        if (!coRevenueMap[coId]) coRevenueMap[coId] = 0;
                        coRevenueMap[coId] += pNum(row.Value_Amount || 0);
                    }
                });
                let coRevenueTotal = 0;
                Object.values(coRevenueMap).forEach(rev => { coRevenueTotal += rev; });
                // Compute Regular Time (51100) from burn tool labor phased
                let regularTime = 0;
                Object.keys(phasedLabor).forEach(row => {
                    const weekRow = row.includes('=');
                    const week = row.split('=')[1];
                    const entry = phasedLabor[row];
                    const h = entry?.Number_Hours;
                    const bR = entry?.Rate;
                    const cS = entry?.Number_Units;
                    if (weekRow && h && bR && cS && verStart &&
                        moment(week).isAfter(moment(verStart).startOf('week')) &&
                        moment(week).isBefore(moment(compProjectComplete).endOf('week'))) {
                        regularTime += (!isNaN(pNum(h)) && !isNaN(pNum(bR)) && !isNaN(pNum(cS))) ? pNum(h) * pNum(bR) * pNum(cS) : 0;
                    }
                });
                // Burn Tool Labor (non-phased)
                Object.values(laborValues).forEach(row => {
                    const week = row.Forecast_Row_ID?.split('*')[0];
                    if (week && verStart &&
                        moment(week).isAfter(moment(verStart).startOf('week')) &&
                        moment(compProjectComplete).isAfter(week)) {
                        regularTime += (!isNaN(pNum(row.Rate)) && !isNaN(pNum(row.Number_Units)) && !isNaN(pNum(row.Number_Hours))) ? pNum(row.Rate) * pNum(row.Number_Units) * pNum(row.Number_Hours) : 0;
                    }
                });
                etcByCostType['51100'] = (etcByCostType['51100'] || 0) + regularTime;
                // Compute Inside Equipment (52100) from burn tool equipment phased
                // Row IDs use '=' (new) or '*' (legacy) between name and week
                let equipmentETC = 0;
                Object.keys(phasedEquipment).forEach(t => {
                    const r = phasedEquipment[t];
                    const w = t.includes('=') ? t.split('=').pop() : t.split('*')[1];
                    const rate = r?.Rate;
                    const h = r?.Number_Hours;
                    const n = r?.Number_Units;
                    if (w && h && n && rate && verStart &&
                        moment(w).isAfter(moment(verStart).startOf('week')) &&
                        moment(w).isBefore(moment(compProjectComplete).endOf('week'))) {
                        equipmentETC += (!isNaN(pNum(rate)) && !isNaN(pNum(h)) && !isNaN(pNum(n))) ? pNum(rate) * pNum(h) * pNum(n) : 0;
                    }
                });
                // Burn Tool Equipment (non-phased)
                Object.keys(equipmentValues).forEach(key => {
                    if (key.length === 10 && verStart &&
                        moment(key).isAfter(moment(verStart).startOf('week')) &&
                        moment(compProjectComplete).endOf('week').isAfter(key)) {
                        const row = equipmentValues[key];
                        equipmentETC += (isNaN(pNum(row.Rate)) ? 0 : pNum(row.Rate)) * (isNaN(pNum(row.Number_Units)) ? 0 : pNum(row.Number_Units)) * (isNaN(pNum(row.Number_Hours)) ? 0 : pNum(row.Number_Hours));
                    }
                });
                etcByCostType['52100'] = (etcByCostType['52100'] || 0) + equipmentETC;
                // Aggregate ETC by cost group — must match the main view's selective bucketing
                // (lines ~1233-1311). Codes 51200/51300/51400/51500 (overtime/burden/BYOD/per-diem)
                // are intentionally dropped because main view sources those from approved COs, not ETC.
                // Field Bonus (51800) only counts for weeks before its own version's cutoff.
                const weekHideFB = fieldBonusRemoved(verStart);
                const LABOR_CODES = new Set(['51100', '51600', '51700', ...(weekHideFB ? [] : ['51800'])]);
                const EQUIPMENT_CODES = new Set(['52100', '52200', '52300', '52400']);
                const MATERIALS_CODES = new Set(['53100', '53200', '53300', '53400']);
                const SUBS_CODES = new Set(['54100', '54200', '54300']);
                const OTHER_CODES = new Set([
                    '55100', '55200', '55300', '55400', '55900',
                    '56100', '56200', '56300', '56400', '56500', '56600', '56700', '56800',
                    '57100', '57200', '57300', '57900',
                ]);
                let laborEtc = 0, equipmentEtcG = 0, materialsEtc = 0, subsEtc = 0, otherEtc = 0;
                Object.entries(etcByCostType).forEach(([code, val]) => {
                    const c = (code + '');
                    if (LABOR_CODES.has(c)) laborEtc += pNum(val);
                    else if (EQUIPMENT_CODES.has(c)) equipmentEtcG += pNum(val);
                    else if (MATERIALS_CODES.has(c)) materialsEtc += pNum(val);
                    else if (SUBS_CODES.has(c)) subsEtc += pNum(val);
                    else if (OTHER_CODES.has(c)) otherEtc += pNum(val);
                });
                // Contingency ETC is stored on the 'Contingency' forecast tab with per-row Current* fields
                const contingData = {};
                data.forEach(d => {
                    if (d?.Forecast_Tab === 'Contingency') {
                        if (!contingData[d?.Forecast_Row_ID]) contingData[d?.Forecast_Row_ID] = {};
                        contingData[d?.Forecast_Row_ID][d.Forecast_Field_Name] = d.Forecast_Value;
                    }
                });
                let contingencyEtc = 0;
                Object.values(contingData).forEach(row => {
                    contingencyEtc += pNum(row.CurrentLabor) + pNum(row.CurrentEquipment) + pNum(row.CurrentMaterials) + pNum(row.CurrentSubs) + pNum(row.CurrentOther);
                });
                const groupEtc = { labor: laborEtc, equipment: equipmentEtcG, materials: materialsEtc, subcontractors: subsEtc, other: otherEtc, contingency: contingencyEtc };

                // Per-phase ETC for the version, mirroring calculatePhaseAmounts logic so phase
                // variance columns can build a per-phase EAC for this version.
                const etcByPhase = {};
                const inWin = (w) => w && verStart &&
                    moment(w).isAfter(moment(verStart).startOf('week')) &&
                    moment(w).isBefore(moment(compProjectComplete).endOf('week'));
                data.forEach(d => {
                    if (d?.Forecast_Field_Name === 'etc' && d?.Cost_Code && d.Cost_Code !== '101101') {
                        etcByPhase[d.Cost_Code] = (etcByPhase[d.Cost_Code] || 0) + pNum(d?.Value_Amount);
                    }
                    if (d?.Forecast_Tab === 'Burn Tool Labor Phased' && d?.Forecast_Row_ID) {
                        const t = d.Forecast_Row_ID;
                        const sep = t.includes('=') ? '=' : '*';
                        const idx = t.lastIndexOf(sep);
                        const week = idx >= 0 ? t.substring(idx + 1) : '';
                        const phase = idx >= 0 ? t.substring(0, idx) : '';
                        if (phase && inWin(week)) {
                            const h = pNum(d.Number_Hours || 0), r = pNum(d.Rate || 0), n = pNum(d.Number_Units || 0);
                            if (h && r && n) etcByPhase[phase] = (etcByPhase[phase] || 0) + h * r * n;
                        }
                    }
                    if (d?.Forecast_Tab === 'Burn Tool Equipment Phased' && d?.Cost_Code && d?.Forecast_Row_ID) {
                        const t = d.Forecast_Row_ID;
                        const sep = t.includes('=') ? '=' : '*';
                        const idx = t.lastIndexOf(sep);
                        const week = idx >= 0 ? t.substring(idx + 1) : '';
                        if (inWin(week)) {
                            const h = pNum(d.Number_Hours || 0), r = pNum(d.Rate || 0), n = pNum(d.Number_Units || 0);
                            if (h && r && n) etcByPhase[d.Cost_Code] = (etcByPhase[d.Cost_Code] || 0) + h * r * n;
                        }
                    }
                });
                return { guid, etcByCostType, groupEtc, coRevenueTotal, etcByPhase };
            } catch (e) { console.error('weekCostType load error', guid, e); return { guid, etcByCostType: {}, groupEtc: {}, coRevenueTotal: 0, etcByPhase: {} }; }
        })).then(results => {
            const maps = {};
            const etcGroupMaps = {};
            const coRevMaps = {};
            const etcPhaseMaps = {};
            results.forEach(({ guid, etcByCostType, groupEtc, coRevenueTotal, etcByPhase }) => {
                maps[guid] = etcByCostType;
                etcGroupMaps[guid] = groupEtc || {};
                coRevMaps[guid] = coRevenueTotal || 0;
                etcPhaseMaps[guid] = etcByPhase || {};
            });
            setWeekCostTypeMaps(maps);
            setWeekEtcGroupMaps(etcGroupMaps);
            setWeekCoRevenueMaps(coRevMaps);
            setWeekEtcPhaseMaps(etcPhaseMaps);
        });
    }, [varianceWeeks, selectedJob, versions, projectComplete]);

    // Try per-version snapshots: Form_Job_Cost_History and v_Form_Open_PO_Items are keyed by Version_Guid,
    // so for historical variance weeks we should be able to fetch the exact Apr-16 JTD and Committed.
    // Log row counts so we can tell whether the API returns empty for historical guids.
    useEffect(() => {
        if (!selectedJob || !varianceWeeks.length) return;
        Promise.all(varianceWeeks.map(async guid => {
            const jtd = { labor: 0, equipment: 0, materials: 0, subcontractors: 0, other: 0, overhead: 0, revenuePrev: 0, rowCount: 0 };
            const committed = { labor: 0, equipment: 0, materials: 0, subcontractors: 0, other: 0, rowCount: 0 };
            const jtdByPhase = {};
            const committedByPhase = {};
            // revenuePrev cutoff matches main view's logic at line ~2289: GL_Date < (verStart - 1 month).endOf('Month')
            const ver = versions?.find(v => v.Version_GUID === guid);
            const revPrevCutoff = ver?.Version_Start_DateTime
                ? moment(ver.Version_Start_DateTime).add(-1, 'Month').endOf('Month').format('YYYY-MM-DD')
                : null;
            try {
                const cdRes = await trackApi('loadCostDetailCondensed', 'load', () => loadCostDetailCondensed({ jobNumber: selectedJob, versionGuid: guid }));
                const rows = cdRes?.data || [];
                jtd.rowCount = rows.length;
                rows.forEach(row => {
                    const code = (row.Cost_Type_Code || '') + '';
                    const jc = pNum(row.Job_Cost);
                    if (code >= '51000' && code <= '51999') jtd.labor += jc;
                    else if (code >= '52000' && code <= '52999') jtd.equipment += jc;
                    else if (code >= '53000' && code <= '53999') jtd.materials += jc;
                    else if (code >= '54000' && code <= '54999') jtd.subcontractors += jc;
                    else if (code >= '55000' && code <= '58000') jtd.other += jc;
                    else if (code === '60900') jtd.overhead += jc;
                    if (row.Phase_Code && code >= '50000' && code <= '60000') {
                        jtdByPhase[row.Phase_Code] = (jtdByPhase[row.Phase_Code] || 0) + jc;
                    }
                    // Revenue (40000-49999) posts as negative Job_Cost in GL — negate so revenuePrev
                    // is positive, matching the main view's setJTDRevenuePrevPeriod(formN(-revenueJTDPrevPeriod)).
                    if (code >= '40000' && code <= '49999' && revPrevCutoff && row.GL_Date && moment(row.GL_Date).isBefore(revPrevCutoff)) {
                        jtd.revenuePrev += -jc;
                    }
                });
            } catch (e) { console.error('[variance] JTD load error for guid', guid, e); }
            try {
                const coRes = await trackApi('loadJobOpenCommitmentsCombined', 'load', () => loadJobOpenCommitmentsCombined({ id: selectedJob, versionGuid: guid }));
                const rows = coRes?.data || [];
                committed.rowCount = rows.length;
                rows.forEach(row => {
                    const code = (row.Cost_Type_Code || '') + '';
                    const openAmt = pNum(row.PO_True_Open_Amount);
                    if (code >= '51000' && code <= '51999') committed.labor += openAmt;
                    else if (code >= '52000' && code <= '52999') committed.equipment += openAmt;
                    else if (code >= '53000' && code <= '53999') committed.materials += openAmt;
                    else if (code >= '54000' && code <= '54999') committed.subcontractors += openAmt;
                    else if (code >= '55000' && code <= '58000') committed.other += openAmt;
                    if (row.Phase_Code) {
                        committedByPhase[row.Phase_Code] = (committedByPhase[row.Phase_Code] || 0) + openAmt;
                    }
                });
            } catch (e) { console.error('[variance] Committed load error for guid', guid, e); }
            console.log('[variance] guid', guid, 'JTD rows:', jtd.rowCount, 'sums:', { labor: jtd.labor, equipment: jtd.equipment, materials: jtd.materials, subcontractors: jtd.subcontractors, other: jtd.other }, 'Committed rows:', committed.rowCount, 'sums:', { labor: committed.labor, equipment: committed.equipment, materials: committed.materials, subcontractors: committed.subcontractors, other: committed.other });
            return { guid, jtd, committed, jtdByPhase, committedByPhase };
        })).then(results => {
            const jtdMaps = {};
            const coMaps = {};
            const jtdPhaseMaps = {};
            const coPhaseMaps = {};
            results.forEach(({ guid, jtd, committed, jtdByPhase, committedByPhase }) => {
                jtdMaps[guid] = jtd;
                coMaps[guid] = committed;
                jtdPhaseMaps[guid] = jtdByPhase || {};
                coPhaseMaps[guid] = committedByPhase || {};
            });
            setWeekJtdGroupMaps(jtdMaps);
            setWeekJtdPhaseMaps(jtdPhaseMaps);
            setWeekCommittedPhaseMaps(coPhaseMaps);
            setWeekCommittedGroupMaps(coMaps);
        });
    }, [varianceWeeks, selectedJob]);

    // Per-variance-week EAC snapshot: JTD + Committed + ETC, matching how the main view's EAC is built.
    // For non-WIP variance weeks, prefer the per-version snapshot (exact). If that API returns empty
    // (rowCount === 0), fall back to date-filtered jobCostDetail + current jobOpenCommitments.
    const weekEacMaps = React.useMemo(() => {
        const out = {};
        const wipGuid = selectedWIP?.Version_GUID;
        varianceWeeks.forEach(guid => {
            const actuals = weekTotalMaps[guid] || {};
            const etcGroup = weekEtcGroupMaps[guid] || {};

            let laborAct, equipAct, matAct, subAct, otherAct, ohAct;
            let laborCo = 0, equipCo = 0, matCo = 0, subCo = 0, otherCo = 0;
            const perVerJtd = weekJtdGroupMaps[guid];
            const perVerCo = weekCommittedGroupMaps[guid];
            const hasJtdSnapshot = perVerJtd && perVerJtd.rowCount > 0;
            const hasCoSnapshot = perVerCo && perVerCo.rowCount > 0;

            if (hasJtdSnapshot) {
                laborAct = pNum(perVerJtd.labor);
                equipAct = pNum(perVerJtd.equipment);
                matAct = pNum(perVerJtd.materials);
                subAct = pNum(perVerJtd.subcontractors);
                otherAct = pNum(perVerJtd.other);
                ohAct = pNum(perVerJtd.overhead);
            } else {
                const ver = versions?.find(v => v.Version_GUID === guid);
                const verStart = ver?.Version_Start_DateTime;
                const cutoff = verStart ? moment(verStart) : null;
                let l = 0, e = 0, m = 0, s = 0, o = 0, oh = 0;
                if (cutoff) {
                    (jobCostDetail || []).forEach(row => {
                        if (!row.GL_Date) return;
                        if (!moment(row.GL_Date).isBefore(cutoff)) return;
                        const code = row.Cost_Type_Code + '';
                        const jc = pNum(row.Job_Cost);
                        if (code >= '51000' && code <= '51999') l += jc;
                        else if (code >= '52000' && code <= '52999') e += jc;
                        else if (code >= '53000' && code <= '53999') m += jc;
                        else if (code >= '54000' && code <= '54999') s += jc;
                        else if (code >= '55000' && code <= '58000') o += jc;
                        else if (code === '60900') oh += jc;
                    });
                }
                laborAct = l; equipAct = e; matAct = m; subAct = s; otherAct = o; ohAct = oh;
            }

            if (hasCoSnapshot) {
                laborCo = pNum(perVerCo.labor);
                equipCo = pNum(perVerCo.equipment);
                matCo = pNum(perVerCo.materials);
                subCo = pNum(perVerCo.subcontractors);
                otherCo = pNum(perVerCo.other);
            } else {
                (jobOpenCommitments || []).forEach(row => {
                    const code = (row.Cost_Type_Code || '') + '';
                    const openAmt = pNum(row.PO_True_Open_Amount);
                    if (code >= '51000' && code <= '51999') laborCo += openAmt;
                    else if (code >= '52000' && code <= '52999') equipCo += openAmt;
                    else if (code >= '53000' && code <= '53999') matCo += openAmt;
                    else if (code >= '54000' && code <= '54999') subCo += openAmt;
                    else if (code >= '55000' && code <= '58000') otherCo += openAmt;
                });
            }

            const labor = laborAct + laborCo + pNum(etcGroup.labor);
            const equipment = equipAct + equipCo + pNum(etcGroup.equipment);
            const materials = matAct + matCo + pNum(etcGroup.materials);
            const subcontractors = subAct + subCo + pNum(etcGroup.subcontractors);
            const other = otherAct + otherCo + pNum(etcGroup.other);
            const contingency = pNum(etcGroup.contingency);
            const totalCosts = labor + equipment + materials + subcontractors + other + contingency;
            // Contract for the variance-week column comes straight from the variance call's
            // posted revenue (Account_Group 41000, sign-flipped into actuals.contract).
            // Fall back to the main view's Current Budget (budgetEACContract) when the
            // variance call returned nothing — K2 is a stock target for inventory jobs,
            // not a contract value, so K2-based fallback over-states the variance.
            let contract = pNum(actuals.contract);
            if (!contract) {
                contract = pNum(budgetEACContract);
                if (guid === wipGuid && !contract) contract = pNum(budgetDeltaWip);
            }
            const jobProfit = contract - totalCosts;
            const jpPercent = contract ? (jobProfit / contract * 100).toFixed(2) + '%' : '';
            // Overhead: JTD OH + ETC OH allocation, mirroring main view's eacOHAllocation = jOH + eOH + cOH.
            // eOH = (contract - revenuePrev) × ohPercent / 100. Skip ohCommitments for variance for now.
            const revPrev = pNum(perVerJtd?.revenuePrev || 0);
            const etcOH = (contract - revPrev) * pNum(ohPercent) / 100;
            const overhead = ohAct + etcOH;
            const gm = jobProfit - overhead;
            const gmPercent = contract ? (gm / contract * 100).toFixed(2) + '%' : '';
            const verRow = { labor, equipment, materials, subcontractors, other, contingency, totalCosts, contract, jobProfit, jpPercent, overhead, gm, gmPercent };

            // Per-phase EAC for this version. Use the per-version JTD/Committed/ETC by phase
            // when available; fall back to date-filtered jobCostDetail + current jobOpenCommitments
            // if the snapshot APIs returned nothing (matches the LEMSO fallback above).
            const jtdByPhase = weekJtdPhaseMaps[guid] || {};
            const coByPhase = weekCommittedPhaseMaps[guid] || {};
            const etcByPhase = weekEtcPhaseMaps[guid] || {};

            let phaseJtd = jtdByPhase, phaseCo = coByPhase;
            if (!hasJtdSnapshot) {
                const ver = versions?.find(v => v.Version_GUID === guid);
                const cutoff = ver?.Version_Start_DateTime ? moment(ver.Version_Start_DateTime) : null;
                if (cutoff) {
                    phaseJtd = {};
                    (jobCostDetail || []).forEach(row => {
                        if (!row.GL_Date || !row.Phase_Code) return;
                        if (!moment(row.GL_Date).isBefore(cutoff)) return;
                        const code = (row.Cost_Type_Code || '') + '';
                        if (code >= '50000' && code <= '60000') {
                            phaseJtd[row.Phase_Code] = (phaseJtd[row.Phase_Code] || 0) + pNum(row.Job_Cost);
                        }
                    });
                }
            }
            if (!hasCoSnapshot) {
                phaseCo = {};
                (jobOpenCommitments || []).forEach(row => {
                    if (!row.Phase_Code) return;
                    phaseCo[row.Phase_Code] = (phaseCo[row.Phase_Code] || 0) + pNum(row.PO_True_Open_Amount);
                });
            }

            const phaseKeys = new Set([...Object.keys(phaseJtd), ...Object.keys(phaseCo), ...Object.keys(etcByPhase)]);
            phaseKeys.forEach(p => {
                if (!p || p === 'null' || p === 'undefined') return;
                verRow['phase_' + p] = pNum(phaseJtd[p] || 0) + pNum(phaseCo[p] || 0) + pNum(etcByPhase[p] || 0);
            });

            out[guid] = verRow;
        });
        return out;
    }, [varianceWeeks, weekTotalMaps, weekEtcGroupMaps, weekJtdGroupMaps, weekCommittedGroupMaps, weekJtdPhaseMaps, weekCommittedPhaseMaps, weekEtcPhaseMaps, weekCoRevenueMaps, jobCostDetail, jobOpenCommitments, versions, selectedWIP, budgetDeltaWip, budgetEACContract, ohPercent]);

    const debounce = (func, delay) => {
        let timeoutId;
        return (...args) => {
            if (timeoutId) {
                clearTimeout(timeoutId);
            }
            timeoutId = setTimeout(() => {
                func(...args);
            }, delay);
        };
    }

    const debounceSave = useCallback(
        debounce(() => {
            saveObject(changeListRef.current);
            changeListRef.current = [];
        }, 2000),
        []
    );

    const handleInputChange = (value, key) => {
        // Group mode is read-only: edits would only target the parent BU and
        // produce a stale view until the child caches are reloaded.
        if (showGroup) return;
        changeListRef.current.push({ key: key, value: value, buId: selectedJob, lockedVersion: lockedVersion, version: selectedVersion });
        debounceSave();
    };

    const deleteEtcListItem = (data) => {
        setDeletingEtcRows(prev => new Set(prev).add(data.Forecast_Row_ID))
        setTimeout(() => {
            trackApi('deleteUserData', 'save', () => deleteUserData({ id: selectedJob, forecastGuid: selectedVersion, lockedVersion: lockedVersion, rowId: data.Forecast_User_Data_GUID + '', tab: data.Forecast_Tab })).catch(() => {})
            setEtcValueList(prev => prev.filter(d => d.Forecast_Row_ID !== data.Forecast_Row_ID))
            setDeletingEtcRows(prev => { const s = new Set(prev); s.delete(data.Forecast_Row_ID); return s; })
        }, 400)
    }

    const deleteEtcListItemBurnLabor = (data) => {
        setDeletingEtcRows(prev => new Set(prev).add(data.Forecast_Row_ID))
        setTimeout(() => {
            trackApi('deleteUserData', 'save', () => deleteUserData({ id: selectedJob, forecastGuid: selectedVersion, lockedVersion: lockedVersion, rowId: data.Forecast_User_Data_GUID + '', tab: data.Forecast_Tab })).catch(() => {})
            setPhasedLaborRows(prev => prev.filter(d => d.Forecast_Row_ID !== data.Forecast_Row_ID))
            setDeletingEtcRows(prev => { const s = new Set(prev); s.delete(data.Forecast_Row_ID); return s; })
        }, 400)
    }

    const deleteEtcListItemBurnEquipment = (data) => {
        setDeletingEtcRows(prev => new Set(prev).add(data.Forecast_Row_ID))
        setTimeout(() => {
            trackApi('deleteUserData', 'save', () => deleteUserData({ id: selectedJob, forecastGuid: selectedVersion, lockedVersion: lockedVersion, rowId: data.Forecast_User_Data_GUID + '', tab: data.Forecast_Tab })).catch(() => {})
            setPhasedEquipmentRows(prev => prev.filter(d => d.Forecast_Row_ID !== data.Forecast_Row_ID))
            setDeletingEtcRows(prev => { const s = new Set(prev); s.delete(data.Forecast_Row_ID); return s; })
        }, 400)
    }

    const photo = a.photo
    const forecastRef = useRef()
    const jobInfoRef = useRef()
    
    useEffect(() => {
        if (a.photo && a.setJobRef) {
            a.setJobRef(a.job, 'forecast', forecastRef)
            a.setJobRef(a.job, 'jobInfo', jobInfoRef)
        }
        
        if (versions && versions.length > 0) {
            setVersionInfo(versions.find(v => v.Version_GUID === selectedVersion))
        }
    }, [a.photo, a.job, versions, selectedVersion]);

    const [parentBillingsCost, setParentBillingsCost] = useState(0)
    useEffect(() => {
        if (selectedJob && selectedVersion) {
            trackApi('loadUserData', 'load', () => loadUserData({ id: selectedJob, forecastGuid: selectedVersion, live: isLiveVersion })).then((data) => {
                setJobUserData(data?.data);
            }).catch(() => {})

            trackApi('loadCostDetailBillings', 'load', () => loadCostDetailBillings({ ids: [selectedJob], version: selectedVersion })).then((data) => {
                if (data?.data?.[0]) {
                    setParentBillingsCost(pNum(data.data[0].Total_Job_Cost));
                }
            }).catch(() => {})
        }
    }, [selectedJob, selectedVersion])

    // Combine parent + child billings into the displayed value.
    useEffect(() => {
        const total = parentBillingsCost + (showGroup ? childBillingsTotal : 0)
        setBillings(total !== 0 ? fNum(-total, 1) : '-')
    }, [parentBillingsCost, childBillingsTotal, showGroup])

    useEffect(() => {
        if (selectedJob && selectedWIP?.Version_GUID) {
            trackApi('loadUserData', 'load', () => loadUserData({ id: selectedJob, forecastGuid: selectedWIP.Version_GUID, live: false })).then((data) => {
                const wipUserData = data?.data || [];
                const wipPhysical = wipUserData.find(d => d.Forecast_Field_Name === 'physicalComplete');
                if (wipPhysical?.Forecast_Value) {
                    const value = pNum(wipPhysical.Forecast_Value);
                    setWipPhysicalComplete(value < 1 ? value * 100 : value);
                } else {
                    setWipPhysicalComplete(null);
                }
            }).catch(() => {});
        } else {
            setWipPhysicalComplete(null);
        }
    }, [selectedJob, selectedWIP])

    useEffect(() => {
        if (selectedJobData && selectedJobData.Cat_Code_BU_27) {
            setOverheadPercent(overheadData[selectedJobData.Cat_Code_BU_27] ? overheadData[selectedJobData.Cat_Code_BU_27] : '')
        }
    }, [selectedJobData, overheadData])

    useEffect(() => {
        if (effectiveK2Data && typeof effectiveK2Data === 'object' && Object.keys(effectiveK2Data).length > 0) {
            const data = effectiveK2Data;
            setK2BudgetContract(data.Estimated_Project_Amount && pNum(data.Estimated_Project_Amount) !== 0 ? fNum(data.Estimated_Project_Amount, 1) : '')
            setK2BudgetTotalCosts(data.Expected_Cost && pNum(data.Expected_Cost) !== 0 ? fNum(data.Expected_Cost, 1) : '')
            const jp = data.Estimated_Project_Amount && data.Expected_Cost ? pNum(data.Estimated_Project_Amount) - pNum(data.Expected_Cost) : 0
            setK2BudgetJobProfit(data.Estimated_Project_Amount && data.Expected_Cost && jp !== 0 ? fNum(jp, 1) : '')
            setK2BudgetJP(data.Estimated_Project_Amount && data.Expected_Cost && pNum(data.Estimated_Project_Amount) !== 0 ? fNum(100 * jp / pNum(data.Estimated_Project_Amount)) + '%' : '')
            // Recompute OH from the current Applied_Overhead_Percentage instead of
            // reading the stored Overhead_Allocation column, which can lag behind
            // the K2 form when a job is edited without re-publishing (the % stays
            // accurate but the dollar allocation goes stale).
            // NB: parse with parseFloat, NOT pNum — pNum truncates to 2 decimals,
            // which would turn a fractional rate like 0.049174 into 0.04 and skew
            // the allocation by ~20%. The rate is stored as a fraction (0.049174),
            // but accept a percentage form (4.917) too via the > 1 guard.
            const ohPctRaw = parseFloat(data.Applied_Overhead_Percentage)
            const ohRate = ohPctRaw > 1 ? ohPctRaw / 100 : ohPctRaw
            const ohAlloc = ohRate && pNum(data.Estimated_Project_Amount)
                ? ohRate * pNum(data.Estimated_Project_Amount)
                : pNum(data.Overhead_Allocation)
            setK2BudgetOH(ohAlloc !== 0 ? fNum(ohAlloc, 1) : '')
            setK2BudgetGM(jp && (jp - ohAlloc) !== 0 ? fNum(jp - ohAlloc, 1) : '')
            setK2BudgetGMP(data.Estimated_Project_Amount && pNum(data.Estimated_Project_Amount) !== 0 ? fNum(100 * (jp ? jp - ohAlloc : 0) / data.Estimated_Project_Amount) + '%' : '')
            setK2BudgetLabor(data.Cost_Labor && pNum(data.Cost_Labor) !== 0 ? fNum(pNum(data.Cost_Labor), 1) : '')
            setK2BudgetEquipment(data.Cost_Equipment && pNum(data.Cost_Equipment) !== 0 ? fNum(pNum(data.Cost_Equipment), 1) : '')
            setK2BudgetMaterials(data.Cost_Materials && pNum(data.Cost_Materials) !== 0 ? fNum(pNum(data.Cost_Materials), 1) : '')
            setK2BudgetSubcontractors(data.Cost_Subcontract && pNum(data.Cost_Subcontract) !== 0 ? fNum(pNum(data.Cost_Subcontract), 1) : '')
            setK2BudgetOther(data.Cost_Other && pNum(data.Cost_Other) !== 0 ? fNum(pNum(data.Cost_Other), 1) : '')
            setK2BudgetContingency(data.Cost_Contingency && pNum(data.Cost_Contingency) !== 0 ? fNum(pNum(data.Cost_Contingency), 1) : '')
        } else {
            // Reset all k2 values when effectiveK2Data is null or empty
            setK2BudgetContract('')
            setK2BudgetTotalCosts('')
            setK2BudgetJobProfit('')
            setK2BudgetJP('')
            setK2BudgetOH('')
            setK2BudgetGM('')
            setK2BudgetGMP('')
            setK2BudgetLabor('')
            setK2BudgetEquipment('')
            setK2BudgetMaterials('')
            setK2BudgetSubcontractors('')
            setK2BudgetOther('')
            setK2BudgetContingency('')
        }
    }, [effectiveK2Data]);

    useEffect(() => {
        const uValues = {}
        const chOrValues = {
            'Regular Time': 0,
            'Overtime': 0,
            'Burden': 0,
            'BYOD': 0,
            'Per Diem': 0,
            'Truck Pay': 0,
            'Welding Rig Pay': 0,
            'Field Bonus': 0,
            'Inside Equipment Rental': 0,
            'Outside Equipment Rental': 0,
            'Fuel': 0,
            'Repairs': 0,
            'Materials': 0,
            'Mats': 0,
            'Internal Subcontractors': 0,
            'External Subcontractors': 0,
            'Hauling and Transportation': 0,
            'Tools & Supplies': 0,
            'Skids': 0,
            'Personal Meals': 0,
            'Team Meals/Entertain': 0,
            'Airfare': 0,
            'Lodging': 0,
            'Field Office Rent': 0,
            'Field Office Utility': 0,
            'Field Office Expense': 0,
            'Lab Fees & Testing': 0,
            'Safety & PPE': 0,
            'Bonds and Insurance Premiums': 0,
            'Permits': 0,
            'Insurance Claims': 0,
            'Taxes': 0,
            'Accrued Expense': 0,
            'Warranty Reserve': 0,
            'Miscellaneous': 0,
            'Total Revenue': 0,
            'Total Materials Cost': 0,
            'Total Labor Cost': 0,
            'Total Equipment Cost': 0,
            'Total Subcontractors Cost': 0,
            'Total CO Cost': 0,
            'Total Profit': 0,
            'Total Other Cost': 0,

        }
        const matValues = {}
        const rentalValues = {}
        const subValues = {}
        const otherValues = {}
        const laborValues = {}
        const equipmentValues = {}
        const phasedLabor = {}
        const phasedEquipment = {}
        const etcList = []

        if (jobUserData && jobUserData.length > 0) {
            const data = jobUserData
            const rows = []
            const etcValues = {}
            const contingData = {}
            const otherEtcValues = {}
            let forecastedHours = 0

            data.forEach((d) => {
                if (d?.Forecast_Tab === 'Forecast') {
                    rows.push(d)
                    uValues[d?.Forecast_Field_Name] = d?.Forecast_Value
                }

                if (d?.Forecast_Tab === 'Change Order') {
                    chOrValues[d?.Forecast_User_Data_GUID || d?.Forecast_Row_ID] = { ...d, [d.Cost_Type]: d.Value_Amount, id: d.Row_Label }
                }

                if (d?.Forecast_Tab === 'Materials') {
                    if (matValues[d?.Forecast_Row_ID]) {
                        matValues[d?.Forecast_Row_ID][d.Forecast_Field_Name] = d.Forecast_Value
                        matValues[d?.Forecast_Row_ID]['Cost_Type'] = d.Cost_Type
                    } else {
                        matValues[d?.Forecast_Row_ID] = {
                            id: d?.Forecast_Row_ID,
                            [d.Forecast_Field_Name]: d.Forecast_Value,
                            Cost_Type: d.Cost_Type
                        }
                    }
                }

                if (d?.Forecast_Tab === 'Burn Tool Equipment Phased') {
                    phasedEquipment[d?.Forecast_Row_ID] = {
                        id: d?.Forecast_Row_ID,
                        ...d
                    }
                }

                if (d?.Forecast_Tab === 'Burn Tool Labor Phased') {
                    phasedLabor[d?.Forecast_Row_ID] = {
                        id: d?.Forecast_Row_ID,
                        ...d
                    }
                }

                if (d?.Forecast_Tab === 'Burn Tool Equipment') {
                    equipmentValues[d?.Forecast_Row_ID] = d
                }

                if (d?.Forecast_Tab === 'Burn Tool Labor') {
                    if (d.Field_Name === 'Total_Hours') {
                        forecastedHours = forecastedHours + (pNum(d.Forecast_String) ? pNum(d.Forecast_String) : 0)
                    }

                    laborValues[d?.Forecast_Row_ID] = d
                }

                if (d?.Forecast_Tab === 'Rentals') {
                    if (rentalValues[d?.Forecast_Row_ID]) {
                        rentalValues[d?.Forecast_Row_ID][d.Forecast_Field_Name] = d.Forecast_Value
                    } else {
                        rentalValues[d?.Forecast_Row_ID] = {
                            id: d?.Forecast_Row_ID,
                            [d.Forecast_Field_Name]: d.Forecast_Value
                        }
                    }
                }

                if (d?.Forecast_Tab === 'Subcontractors') {
                    if (subValues[d?.Forecast_Row_ID]) {
                        subValues[d?.Forecast_Row_ID][d.Forecast_Field_Name] = d.Forecast_Value
                    } else {
                        subValues[d?.Forecast_Row_ID] = {
                            id: d?.Forecast_Row_ID,
                            [d.Forecast_Field_Name]: d.Forecast_Value
                        }
                    }
                }

                if (d?.Forecast_Tab === 'Other') {
                    if (otherValues[d?.Forecast_Row_ID]) {
                        otherValues[d?.Forecast_Row_ID][d.Forecast_Field_Name] = d.Forecast_Value
                        otherValues[d?.Forecast_Row_ID]['Cost_Type'] = d.Cost_Type
                    } else {
                        otherValues[d?.Forecast_Row_ID] = {
                            id: d?.Forecast_Row_ID,
                            [d.Forecast_Field_Name]: d.Forecast_Value,
                            ['Cost_Type']: d.Cost_Type
                        }
                    }
                }

                if (d?.Forecast_Tab === 'Contingency') {
                    if (contingData[d?.Forecast_Row_ID]) {
                        contingData[d?.Forecast_Row_ID][d.Forecast_Field_Name] = d.Forecast_Value
                    } else {
                        contingData[d?.Forecast_Row_ID] = {
                            id: d?.Forecast_Row_ID,
                            [d.Forecast_Field_Name]: d.Forecast_Value
                        }
                    }
                }

                if (d?.Cost_Type && d?.Forecast_Field_Name == 'etc' && (!d?.Cost_Code || d?.Cost_Code != '101101')) {
                    if (d?.Value_Amount != 0) {
                        etcList.push(d)
                    }
                    if (etcValues[d?.Cost_Type]) {
                        etcValues[d?.Cost_Type] = etcValues[d?.Cost_Type] + pNum(d?.Value_Amount)
                    } else {
                        etcValues[d?.Cost_Type] = pNum(d?.Value_Amount)
                    }
                } else if (d?.Cost_Type && d?.Forecast_Field_Name == 'etc' && d?.Cost_Code == '101101') {
                    if (otherEtcValues[d?.Cost_Type]) {
                        otherEtcValues[d?.Cost_Type] = otherEtcValues[d?.Cost_Type] + pNum(d?.Value_Amount)
                    } else {
                        otherEtcValues[d?.Cost_Type] = pNum(d?.Value_Amount)
                    }
                }
            })

            let totalRegularTime = 0
            let totalOvertime = 0
            let totalRegularTimeHours = 0
            let totalOvertimeHours = 0
            let totalBurden = 0
            let totalByod = 0
            let totalPerDiem = 0
            let totalTruckPay = 0
            let totalWeldingRigPay = 0
            let totalFieldBonus = 0
            let totalTotalEquipmentHours = 0
            let totalInsideEquipmentRentals = 0
            let totalOutsideEquipmentRentals = 0
            let totalFuel = 0
            let totalRepairs = 0
            let totalMaterials = 0
            let totalMats = 0
            let totalToolsSupplies = 0
            let totalSkids = 0
            let totalInternalSubcontractors = 0
            let totalExternalSubcontractors = 0
            let totalHaulingTransportation = 0
            let totalPersonalMeals = 0
            let totalTeamMealsEntertain = 0
            let totalAirfare = 0
            let totalLodging = 0
            let totalOtherTravelExpense = 0
            let totalFieldOfficeRent = 0
            let totalFieldOfficeUtility = 0
            let totalFieldOfficeExpense = 0
            let totalLabFeesTesting = 0
            let totalSafetyPPE = 0
            let totalBondsInsurancePremiums = 0
            let totalPermits = 0
            let totalInsuranceClaims = 0
            let totalTaxes = 0
            let totalAccruedExpenses = 0
            let totalWarrantyReserve = 0
            let totalMisc = 0
            let totalOverhead = 0
            let totalRevenue = 0
            let totalMaterialsCost = 0
            let totalLaborCost = 0
            let totalEquipmentCost = 0
            let totalSubcontractorsCost = 0
            let totalOtherCost = 0

            let totallETC = 0
            let totalmETC = 0
            let totaleETC = 0

            let totalcLabor = 0
            let totalcEquipment = 0
            let totalcMaterials = 0
            let totalcSubcontractors = 0
            let totalcOtherExpenses = 0
            let totalcTotal = 0

            let totalsETC = 0

            let totaloETC = 0
            let totalContingency = 0

            // Calculate revenue from approved Change Order detail rows
            const coRevenueMap = {};
            Object.values(chOrValues).forEach((row) => {
                const coId = row.Row_Label || row.id || '';
                const status = (row.Status || row.status || '').toLowerCase();
                const costType = row.Cost_Type || '';
                const dollars = pNum(row.Value_Amount || 0);

                if (status === 'approved') {
                    // Only sum revenue rows (Cost_Type 41000)
                    if (costType == 41000 || costType == '41000') {
                        if (!coRevenueMap[coId]) coRevenueMap[coId] = 0;
                        coRevenueMap[coId] += dollars;
                    }

                    // Add cost detail from approved rows
                    if (row.Cost_Code == '101101') {
                        totalContingency += dollars
                    } else {
                        // Use row.Value_Amount keyed by row.Cost_Type to avoid DB-column-spread overcounting
                        const ct = String(costType || '')
                        const v = dollars
                        const hrs = pNum(row.Hours || 0)
                        if (ct === '51100') { totalRegularTime += v; totalRegularTimeHours += hrs }
                        else if (ct === '51200') { totalOvertime += v; totalOvertimeHours += hrs }
                        else if (ct === '51300') totalBurden += v
                        else if (ct === '51400') totalByod += v
                        else if (ct === '51500') totalPerDiem += v
                        else if (ct === '51600') totalTruckPay += v
                        else if (ct === '51700') totalWeldingRigPay += v
                        else if (ct === '51800') totalFieldBonus += v
                        else if (ct === '52100') totalInsideEquipmentRentals += v
                        else if (ct === '52200') totalOutsideEquipmentRentals += v
                        else if (ct === '52300') totalFuel += v
                        else if (ct === '52400') totalRepairs += v
                        else if (ct === '53100') totalMaterials += v
                        else if (ct === '53200') totalMats += v
                        else if (ct === '53300') totalToolsSupplies += v
                        else if (ct === '53400') totalSkids += v
                        else if (ct === '54100') totalInternalSubcontractors += v
                        else if (ct === '54200') totalExternalSubcontractors += v
                        else if (ct === '54300') totalHaulingTransportation += v
                        else if (ct === '55100') totalPersonalMeals += v
                        else if (ct === '55200') totalTeamMealsEntertain += v
                        else if (ct === '55300') totalAirfare += v
                        else if (ct === '55400') totalLodging += v
                        else if (ct === '55900') totalOtherTravelExpense += v
                        else if (ct === '56100') totalFieldOfficeRent += v
                        else if (ct === '56200') totalFieldOfficeUtility += v
                        else if (ct === '56300') totalFieldOfficeExpense += v
                        else if (ct === '56400') totalLabFeesTesting += v
                        else if (ct === '56500') totalSafetyPPE += v
                        else if (ct === '56600') totalBondsInsurancePremiums += v
                        else if (ct === '56700') totalPermits += v
                        else if (ct === '56800') totalInsuranceClaims += v
                        else if (ct === '57100') totalTaxes += v
                        else if (ct === '57200') totalAccruedExpenses += v
                        else if (ct === '57300') totalWarrantyReserve += v
                        else if (ct === '57900') totalMisc += v
                    }
                }
            });

            // Sum up total revenue from approved COs
            Object.values(coRevenueMap).forEach(revenue => {
                totalRevenue = totalRevenue + revenue;
            })

            // labor 
            let regularTime = 0
            let regularTimePhases = {}
            let truckPay = 0
            let weldingRigPay = 0
            // equipment 
            let equipment = 0
            // rentals
            let outsideEquipmentRentals = 0
            //materials
            let materials = 0
            let mats = 0
            let toolsSupplies = 0
            let skids = 0
            //subs
            let internalSubs = 0
            let externalSubs = 0
            let haulingTransportation = 0
            //other
            let personalMeals = 0
            let teamMealsEntertain = 0
            let airfare = 0
            let lodging = 0
            let fieldOfficeRent = 0
            let fieldOfficeUtility = 0
            let fieldOfficeExpense = 0
            let labFeesTesting = 0
            let safetyPPE = 0
            let bondsInsurancePremiums = 0
            let permits = 0
            let insuranceClaims = 0
            let taxes = 0
            let accruedExpenses = 0
            let warrantyReserve = 0
            let misc = 0
            let fieldBonus = 0
            let fuel = 0
            let repairs = 0
            let otherTravelExpense = 0


            const pLaborRows = []
            Object.keys(phasedLabor).forEach((row) => {
                const weekRow = row.includes('=')
                const week = row.split('=')[1]
                const phase = row.split('=')[0]
                const phaseDetails = phase ? phasedLabor[phase] : {}

                const withinProject = moment(week).isAfter(moment(versionInfo?.Version_Start_DateTime).startOf('week')) && moment(week).isBefore(moment(completionFor(row)).endOf('week'))
                //const withinStartStop = moment(week).isAfter(moment(phaseDetails?.Phase_Start).startOf('week')) && moment(week).isBefore(moment(phaseDetails?.Phase_End).endOf('week'))
                const h = phasedLabor[row]?.Number_Hours
                const bR = phasedLabor[row]?.Rate
                const cS = phasedLabor[row]?.Number_Units
                if (weekRow && phasedLabor[row] && h && bR && cS && withinProject) {
                    if (!regularTimePhases[phase]) {
                        regularTimePhases[phase] = 0;
                    }
                    regularTimePhases[phase] = regularTimePhases[phase] + (!isNaN(pNum(h)) && !isNaN(pNum(bR)) && !isNaN(pNum(cS)) ? pNum(h) * pNum(bR) * pNum(cS) : 0);
                    regularTime = regularTime + (!isNaN(pNum(h)) && !isNaN(pNum(bR)) && !isNaN(pNum(cS)) ? pNum(h) * pNum(bR) * pNum(cS) : 0)
                    pLaborRows.push({
                        phase: phase,
                        week: week,
                        hoursWeek: h,
                        burnRate: bR,
                        crewSize: cS,
                        estCost: (!isNaN(pNum(h)) && !isNaN(pNum(bR)) && !isNaN(pNum(cS)) ? pNum(h) * pNum(bR) * pNum(cS) : 0),
                        Forecast_Tab: 'Burn Tool Labor Phased',
                        Forecast_Row_ID: row,
                        Cost_Type: '51100',
                        Cost_Code: phase,
                        Supplier_Name: phasedLabor[row].Supplier_Name,
                        PO_Number: phasedLabor[row].PO_Number,
                        row: phasedLabor[row]
                    })
                }
            })
            pLaborRows.sort((a, b) => {
                if (a.phase === b.phase) {
                    return new Date(a.week) - new Date(b.week);
                }
                return a.phase.localeCompare(b.phase);
            });
            setPhasedLaborRows(pLaborRows)

            const pEquipmentRows = []
            const skipped = {}
            const added = {}
            Object.keys(phasedEquipment).sort().forEach((t) => {
                const r = phasedEquipment[t]
                const pC = completionFor(t)
                const v = versionInfo?.Version_Start_DateTime
                // Row IDs use '=' (new) or '*' (legacy) between name and week
                const w = t.includes('=') ? t.split('=').pop() : t.split('*')[1]
                const rate = r?.Rate
                const h = r?.Number_Hours
                const n = r?.Number_Units
                if (w && h && n && rate && moment(w).isAfter(moment(v).startOf('week')) && moment(w).isBefore(moment(pC).endOf('week'))) {
                    equipment = equipment + (!isNaN(pNum(rate)) && !isNaN(pNum(h)) && !isNaN(pNum(n)) ? pNum(rate) * pNum(h) * pNum(n) : 0)
                    pEquipmentRows.push({
                        week: w,
                        equipment: r.equipment,
                        estHours: h,
                        numberEquipment: n,
                        burnRate: rate,
                        estCost: (!isNaN(pNum(rate)) && !isNaN(pNum(h)) && !isNaN(pNum(n)) ? pNum(rate) * pNum(h) * pNum(n) : 0),
                        Forecast_Tab: 'Burn Tool Equipment Phased',
                        Forecast_Row_ID: t,
                        Cost_Type: '52100',
                        Cost_Code: r.Cost_Code,
                        Supplier_Name: r.Supplier_Name,
                        PO_Number: r.PO_Number,
                        row: r
                    })
                    if (!added[r.equipment]) {
                        added[r.equipment] = [{ w: w, cur: equipment, rate: rate, n: n, h: h, values: !isNaN(pNum(rate)) && !isNaN(pNum(h)) && !isNaN(pNum(n)) ? pNum(rate) * pNum(h) * pNum(n) : 0, dates: moment(w).isAfter(moment(v).startOf('week')) && moment(w).isBefore(moment(pC).endOf('week')), row: r }]
                    } else {
                        added[r.equipment].push({ w: w, cur: equipment, rate: rate, n: n, h: h, values: !isNaN(pNum(rate)) && !isNaN(pNum(h)) && !isNaN(pNum(n)) ? pNum(rate) * pNum(h) * pNum(n) : 0, dates: moment(w).isAfter(moment(v).startOf('week')) && moment(w).isBefore(moment(pC).endOf('week')), row: r })
                    }
                } else {
                    if (!skipped[r.equipment]) {
                        skipped[r.equipment] = [{ rate: rate, values: !isNaN(pNum(rate)) && !isNaN(pNum(h)) && !isNaN(pNum(n)) ? pNum(rate) * pNum(h) * pNum(n) : 0, dates: moment(w).isAfter(moment(v).startOf('week')) && moment(w).isBefore(moment(pC).endOf('week')), row: r }]
                    } else {
                        skipped[r.equipment].push({ rate: rate, values: !isNaN(pNum(rate)) && !isNaN(pNum(h)) && !isNaN(pNum(n)) ? pNum(rate) * pNum(h) * pNum(n) : 0, dates: moment(w).isAfter(moment(v).startOf('week')) && moment(w).isBefore(moment(pC).endOf('week')), row: r })
                    }
                }
            })

            pEquipmentRows.sort((a, b) => {
                if (a.equipment === b.equipment) {
                    return new Date(a.week) - new Date(b.week);
                }
                return a.equipment.localeCompare(b.equipment);
            });
            setPhasedEquipmentRows(pEquipmentRows)

            Object.keys(equipmentValues).forEach((key) => {
                const dateKey = stripBuPrefix(key)
                if (dateKey.length == 10 && moment(dateKey).isAfter(moment(versionInfo?.Version_Start_DateTime).startOf('week')) && moment(completionFor(key)).endOf('week').isAfter(dateKey)) {
                    const row = equipmentValues[key]
                    equipment = equipment + ((isNaN(pNum(row.Rate)) ? 0 : pNum(row.Rate)) * (isNaN(pNum(row.Number_Units)) ? 0 : pNum(row.Number_Units)) * (isNaN(pNum(row.Number_Hours)) ? 0 : pNum(row.Number_Hours)))
                }
            })

            Object.values(laborValues).forEach((row) => {
                const week = stripBuPrefix(row.Forecast_Row_ID).split('*')[0]
                if (moment(week).isAfter(moment(versionInfo?.Version_Start_DateTime).startOf('week')) && moment(completionFor(row.Forecast_Row_ID)).isAfter(week)) {
                    regularTime = regularTime + (!isNaN(pNum(row.Rate)) && !isNaN(pNum(row.Number_Units)) && !isNaN(pNum(row.Number_Hours)) ? pNum(row.Rate) * pNum(row.Number_Units) * pNum(row.Number_Hours) : 0)
                }
            })

            Object.keys(etcValues).forEach((row) => {
                //labor
                if (row == '51100') {

                } else if (row == '51600') {
                    truckPay = truckPay + (isNaN(etcValues[row]) ? 0 : etcValues[row])
                } else if (row == '51700') {
                    weldingRigPay = weldingRigPay + (isNaN(etcValues[row]) ? 0 : etcValues[row])
                }
                //equipment
                else if (row == '52100') {
                    equipment = equipment + (isNaN(etcValues[row]) ? 0 : pNum(etcValues[row]))
                }
                //rentals
                else if (row == '52200') {
                    outsideEquipmentRentals = outsideEquipmentRentals + (isNaN(etcValues[row]) ? 0 : etcValues[row])
                }
                //materials
                else if (row == '53100') {
                    materials = materials + (isNaN(etcValues[row]) ? 0 : etcValues[row])
                } else if (row == '53200') {
                    mats = mats + (isNaN(etcValues[row]) ? 0 : etcValues[row])
                } else if (row == '53300') {
                    toolsSupplies = toolsSupplies + (isNaN(etcValues[row]) ? 0 : etcValues[row])
                } else if (row == '53400') {
                    skids = skids + (isNaN(etcValues[row]) ? 0 : etcValues[row])
                }
                //subs
                else if (row == '54100') {
                    internalSubs = internalSubs + (isNaN(etcValues[row]) ? 0 : etcValues[row])
                } else if (row == '54200') {
                    //console.log('external subs', internalSubs, etcValues[row])
                    externalSubs = externalSubs + (isNaN(etcValues[row]) ? 0 : etcValues[row])
                } else if (row == '54300') {
                    haulingTransportation = haulingTransportation + (isNaN(etcValues[row]) ? 0 : etcValues[row])
                }
                //other
                else if (row == '55100') {
                    personalMeals = personalMeals + (isNaN(etcValues[row]) ? 0 : etcValues[row])
                } else if (row == '55200') {
                    teamMealsEntertain = teamMealsEntertain + (isNaN(etcValues[row]) ? 0 : etcValues[row])
                } else if (row == '55300') {
                    airfare = airfare + (isNaN(etcValues[row]) ? 0 : etcValues[row])
                } else if (row == '55400') {
                    lodging = lodging + (isNaN(etcValues[row]) ? 0 : etcValues[row])
                } else if (row == '55900') {
                    otherTravelExpense = otherTravelExpense + (isNaN(etcValues[row]) ? 0 : etcValues[row])
                } else if (row == '56100') {
                    fieldOfficeRent = fieldOfficeRent + (isNaN(etcValues[row]) ? 0 : etcValues[row])
                } else if (row == '56200') {
                    fieldOfficeUtility = fieldOfficeUtility + (isNaN(etcValues[row]) ? 0 : etcValues[row])
                } else if (row == '56300') {
                    fieldOfficeExpense = fieldOfficeExpense + (isNaN(etcValues[row]) ? 0 : etcValues[row])
                } else if (row == '56400') {
                    labFeesTesting = labFeesTesting + (isNaN(etcValues[row]) ? 0 : etcValues[row])
                } else if (row == '56500') {
                    safetyPPE = safetyPPE + (isNaN(etcValues[row]) ? 0 : etcValues[row])
                } else if (row == '56600') {
                    bondsInsurancePremiums = bondsInsurancePremiums + (isNaN(etcValues[row]) ? 0 : etcValues[row])
                } else if (row == '56700') {
                    permits = permits + (isNaN(etcValues[row]) ? 0 : etcValues[row])
                } else if (row == '56800') {
                    insuranceClaims = insuranceClaims + (isNaN(etcValues[row]) ? 0 : etcValues[row])
                } else if (row == '57100') {
                    taxes = taxes + (isNaN(etcValues[row]) ? 0 : etcValues[row])
                } else if (row == '57200') {
                    accruedExpenses = accruedExpenses + (isNaN(etcValues[row]) ? 0 : etcValues[row])
                } else if (row == '57300') {
                    warrantyReserve = warrantyReserve + (isNaN(etcValues[row]) ? 0 : etcValues[row])
                } else if (row == '57900') {
                    misc = misc + (isNaN(etcValues[row]) ? 0 : etcValues[row])
                } else if (row == '51800') {
                    // Field Bonus ETC no longer counts for versions past the cutoff
                    if (!hideFieldBonus) fieldBonus = fieldBonus + (isNaN(etcValues[row]) ? 0 : etcValues[row])
                } else if (row == '52300') {
                    fuel = fuel + (isNaN(etcValues[row]) ? 0 : etcValues[row])
                } else if (row == '52400') {
                    repairs = repairs + (isNaN(etcValues[row]) ? 0 : etcValues[row])
                }
            })
            totaloETC = personalMeals + teamMealsEntertain + airfare + lodging + fieldOfficeRent + fieldOfficeUtility + fieldOfficeExpense + labFeesTesting + safetyPPE + bondsInsurancePremiums + permits + insuranceClaims + taxes + accruedExpenses + warrantyReserve + misc + otherTravelExpense
            totallETC = regularTime + truckPay + weldingRigPay + fieldBonus
            totaleETC = equipment + outsideEquipmentRentals + fuel + repairs
            totalmETC = materials + mats + toolsSupplies + skids
            totalsETC = internalSubs + externalSubs + haulingTransportation

            setFieldBonus(fieldBonus)

            Object.values(contingData).forEach((row) => {
                totalcLabor = totalcLabor + (isNaN(pNum(row.CurrentLabor)) ? 0 : pNum(row.CurrentLabor))
                totalcEquipment = totalcEquipment + (isNaN(pNum(row.CurrentEquipment)) ? 0 : pNum(row.CurrentEquipment))
                totalcMaterials = totalcMaterials + (isNaN(pNum(row.CurrentMaterials)) ? 0 : pNum(row.CurrentMaterials))
                totalcSubcontractors = totalcSubcontractors + (isNaN(pNum(row.CurrentSubs)) ? 0 : pNum(row.CurrentSubs))
                totalcOtherExpenses = totalcOtherExpenses + (isNaN(pNum(row.CurrentOther)) ? 0 : pNum(row.CurrentOther))
            })
            totalcTotal = totalcLabor + totalcEquipment + totalcMaterials + totalcSubcontractors + totalcOtherExpenses
            let totalETC = totallETC + totalmETC + totaleETC + totalsETC + totaloETC + totalcTotal

            chOrValues['Regular Time'] = totalRegularTime
            chOrValues['Regular Time Hours'] = totalRegularTimeHours
            chOrValues['Overtime'] = totalOvertime
            chOrValues['Overtime Hours'] = totalOvertimeHours
            chOrValues['Burden'] = totalBurden
            chOrValues['BYOD'] = totalByod
            chOrValues['Per Diem'] = totalPerDiem
            chOrValues['Truck Pay'] = totalTruckPay
            chOrValues['Welding Rig Pay'] = totalWeldingRigPay
            chOrValues['Field Bonus'] = totalFieldBonus
            chOrValues['Inside Equipment Rental'] = totalInsideEquipmentRentals
            chOrValues['Outside Equipment Rental'] = totalOutsideEquipmentRentals
            chOrValues['Fuel'] = totalFuel
            chOrValues['Repairs'] = totalRepairs
            chOrValues['Materials'] = totalMaterials
            chOrValues['Mats'] = totalMats
            chOrValues['Internal Subcontractors'] = totalInternalSubcontractors
            chOrValues['External Subcontractors'] = totalExternalSubcontractors
            chOrValues['Hauling and Transportation'] = totalHaulingTransportation
            chOrValues['Tools & Supplies'] = totalToolsSupplies
            chOrValues['Skids'] = totalSkids
            chOrValues['Personal Meals'] = totalPersonalMeals
            chOrValues['Team Meals/Entertain'] = totalTeamMealsEntertain
            chOrValues['Airfare'] = totalAirfare
            chOrValues['Lodging'] = totalLodging
            chOrValues['Other Travel Expense'] = totalOtherTravelExpense
            chOrValues['Field Office Rent'] = totalFieldOfficeRent
            chOrValues['Field Office Utility'] = totalFieldOfficeUtility
            chOrValues['Field Office Expense'] = totalFieldOfficeExpense
            chOrValues['Lab Fees & Testing'] = totalLabFeesTesting
            chOrValues['Safety & PPE'] = totalSafetyPPE
            chOrValues['Bonds and Insurance Premiums'] = totalBondsInsurancePremiums
            chOrValues['Permits'] = totalPermits
            chOrValues['Insurance Claims'] = totalInsuranceClaims
            chOrValues['Taxes'] = totalTaxes
            chOrValues['Accrued Expense'] = totalAccruedExpenses
            chOrValues['Warranty Reserve'] = totalWarrantyReserve
            chOrValues['Miscellaneous'] = totalMisc
            chOrValues['Contingency'] = totalContingency

            totalMaterialsCost = totalMaterials + totalMats + totalToolsSupplies + totalSkids
            totalEquipmentCost = totalInsideEquipmentRentals + totalOutsideEquipmentRentals + totalFuel + totalRepairs
            totalLaborCost = totalRegularTime + totalOvertime + totalBurden + totalByod + totalPerDiem + totalTruckPay + totalWeldingRigPay + totalFieldBonus
            totalSubcontractorsCost = totalInternalSubcontractors + totalExternalSubcontractors + totalHaulingTransportation
            totalOtherCost = totalPersonalMeals + totalTeamMealsEntertain + totalAirfare + totalLodging + totalOtherTravelExpense + totalFieldOfficeRent + totalFieldOfficeUtility + totalFieldOfficeExpense + totalLabFeesTesting + totalSafetyPPE + totalBondsInsurancePremiums + totalPermits + totalInsuranceClaims + totalTaxes + totalAccruedExpenses + totalWarrantyReserve + totalMisc

            totalOverhead = totalRevenue * pNum(ohPercent) / 100

            setCoContingencyValue(formN(totalContingency))
            //console.log('setting totalRevenue co', totalRevenue)
            setCoContractValue(formN(totalRevenue))
            setCoMaterialsValue(formN(totalMaterialsCost))
            setCoLaborValue(formN(totalLaborCost))
            setCoEquipmentValue(formN(totalEquipmentCost))
            setCoSubcontractorsValue(formN(totalSubcontractorsCost))
            setCoOtherValue(formN(totalOtherCost))
            setCoTotalValue(formN(totalMaterialsCost + totalLaborCost + totalEquipmentCost + totalSubcontractorsCost + totalOtherCost + totalContingency))
            setCoTotalProfit(formN(totalRevenue - (totalMaterialsCost + totalLaborCost + totalEquipmentCost + totalSubcontractorsCost + totalOtherCost + totalContingency)))
            setCoTotalProfitPercent(totalRevenue ? (((totalRevenue - (totalMaterialsCost + totalLaborCost + totalEquipmentCost + totalSubcontractorsCost + totalOtherCost + totalContingency)) / totalRevenue) * 100).toFixed(2) + '%' : '')
            setCoOHAllocation(formN(totalOverhead))
            setCoGM(formN((totalRevenue - (totalMaterialsCost + totalLaborCost + totalEquipmentCost + totalSubcontractorsCost + totalOtherCost + totalContingency)) - (totalRevenue * pNum(ohPercent) / 100)))
            setCoGMP(totalRevenue ? (100 * ((totalRevenue - (totalMaterialsCost + totalLaborCost + totalEquipmentCost + totalSubcontractorsCost + totalOtherCost + totalContingency)) - (totalRevenue * pNum(ohPercent) / 100)) / totalRevenue).toFixed(2) + '%' : '')

            setEtcLabor(formN(totallETC))
            uValues['Regular Time'] = regularTime
            uValues['Truck Pay'] = truckPay
            uValues['Welding Rig Pay'] = weldingRigPay
            uValues['Field Bonus'] = fieldBonus
            setEtcMaterials(formN(totalmETC))
            uValues['Materials'] = materials
            uValues['Mats'] = mats
            uValues['Tools & Supplies'] = toolsSupplies
            uValues['Skids'] = skids
            setEtcSubcontractors(formN(totalsETC))
            setEtcExternalSubcontractors(externalSubs)
            uValues['Internal Subcontractors'] = internalSubs
            uValues['Hauling and Transportation'] = haulingTransportation
            uValues['External Subcontractors'] = externalSubs
            setEtcEquipment(formN(totaleETC))
            uValues['Inside Equipment Rental'] = equipment
            uValues['Outside Equipment Rental'] = outsideEquipmentRentals
            uValues['Fuel'] = fuel
            uValues['Repairs'] = repairs
            setEtcOtherExpenses(formN(totaloETC))
            uValues['Personal Meals'] = personalMeals
            uValues['Team Meals/Entertain'] = teamMealsEntertain
            uValues['Airfare'] = airfare
            uValues['Lodging'] = lodging
            uValues['Field Office Rent'] = fieldOfficeRent
            uValues['Field Office Utility'] = fieldOfficeUtility
            uValues['Field Office Expense'] = fieldOfficeExpense
            uValues['Other Travel Expense'] = otherTravelExpense
            uValues['Lab Fees & Testing'] = labFeesTesting
            uValues['Safety & PPE'] = safetyPPE
            uValues['Bonds and Insurance Premiums'] = bondsInsurancePremiums
            uValues['Permits'] = permits
            uValues['Insurance Claims'] = insuranceClaims
            uValues['Taxes'] = taxes
            uValues['Accrued Expense'] = accruedExpenses
            uValues['Warranty Reserve'] = warrantyReserve
            uValues['Miscellaneous'] = misc

            setEtcContigency(formN(totalcTotal))

            setEtcTotal(formN(totalETC))


            chOrValues['Total Revenue'] = totalRevenue
            chOrValues['Total Materials Cost'] = totalMaterialsCost
            chOrValues['Total Labor Cost'] = totalLaborCost
            chOrValues['Total Equipment Cost'] = totalEquipmentCost
            chOrValues['Total Subcontractors Cost'] = totalSubcontractorsCost
            chOrValues['Total Other Cost'] = totalOtherCost
            chOrValues['Total CO Cost'] = totalMaterialsCost + totalLaborCost + totalEquipmentCost + totalSubcontractorsCost + totalOtherCost + totalContingency
            chOrValues['Total Profit'] = totalRevenue - (totalMaterialsCost + totalLaborCost + totalEquipmentCost + totalSubcontractorsCost + totalOtherCost + totalContingency)

            setNotes(uValues?.notes)
            setPhysicalComplete(uValues?.physicalComplete && pNum(uValues?.physicalComplete) < 1 ? pNum(uValues?.physicalComplete) * 100 : uValues?.physicalComplete)

            setNteAmount(uValues?.nteAmount ? fNum(pNum(uValues?.nteAmount), 1) : '')
            if (uValues?.incentiveRate != null && uValues?.incentiveRate !== '') setIncentiveRate(uValues.incentiveRate)
            setCoValues(chOrValues)
            setUserValues(uValues)

            etcList.sort((a, b) => a.Cost_Type.localeCompare(b.Cost_Type));
            setEtcValueList(etcList)
            
            // Process ETC list immediately to avoid cascading useEffect
            if (etcList && etcList.length > 0) {
                const groupedEtcValues = {
                    "Labor": [],
                    "Equipment": [],
                    "Materials": [],
                    "MaterialsTwo": [],
                    "Subcontractors": [],
                    "Other Expenses": [],
                    "LaborTotal": 0,
                    "EquipmentTotal": 0,
                    "MaterialsTotal": 0,
                    "MaterialsTwoTotal": 0,
                    "SubcontractorsTotal": 0,
                    "Other ExpensesTotal": 0
                };

                const materialitems = []
                etcList.forEach((item) => {
                    for (const section in costSections) {
                        if (costSections[section].includes(item.Cost_Type)) {
                            groupedEtcValues[section].push(item);
                            groupedEtcValues[`${section}Total`] += pNum(item.Value_Amount);
                            if (section === "Materials" && item.Forecast_Tab == 'Materials') {
                                materialitems.push(item);
                                groupedEtcValues["MaterialsTwo"].push(item);
                                groupedEtcValues["MaterialsTwoTotal"] += pNum(item.Value_Amount);
                            }
                            break;
                        }
                    }
                });

                setEquipmentEtcList(groupedEtcValues["Equipment"]);
                setMaterialsEtcList(groupedEtcValues["Materials"]);
                setSubcontractorsEtcList(groupedEtcValues["Subcontractors"]);
                setOtherEtcList(groupedEtcValues["Other Expenses"]);
                setEquipmentEtcTotal(fNum(groupedEtcValues["EquipmentTotal"]));
                setMaterialsEtcTotal(fNum(groupedEtcValues["MaterialsTotal"]));
                setMaterialsEtcTotalTwo(fNum(groupedEtcValues["MaterialsTwoTotal"]));
                setSubcontractorsEtcTotal(fNum(groupedEtcValues["SubcontractorsTotal"]));
                setOtherEtcTotal(fNum(groupedEtcValues["Other ExpensesTotal"]));
            }
        }
    }, [jobUserData, projectComplete, hideFieldBonus])

    useEffect(() => {
        setEtcOHAllocation(formN((pNum(budgetEACContract) - pNum(JTDRevenuePrevPeriod)) * pNum(ohPercent) / 100))
    }, [budgetEACContract, JTDRevenuePrevPeriod, ohPercent])

    useEffect(() => {
        const calculatedCommitments = calculateCommitmentAmounts(jobOpenCommitments)
        setCommited(calculatedCommitments)

        calculateContractAmounts(calculatedCommitments)
        calculatePhaseAmounts()
    }, [jobData, userValues, coValues, jobCostDetail, ohPercent, jobUserData, jobOpenCommitments, projectComplete, hideFieldBonus])

    // Resource view reads the LEMSO category state values (dayZeroBudgetLabor,
    // etcLabor, coLaborValue, etc.), which are set asynchronously by
    // calculateContractAmounts. Run it after those values land.
    useEffect(() => {
        calculateResourceAmounts()
    }, [
        jobCostDetail, jobOpenCommitments,
        dayZeroBudgetLabor, dayZeroBudgetEquipment, dayZeroBudgetMaterials,
        dayZeroBudgetSubcontractors, dayZeroBudgetOtherExpenses,
        etcLabor, etcEquipment, etcMaterials, etcSubcontractors, etcOtherExpenses,
        coLaborValue, coEquipmentValue, coMaterialsValue, coSubcontractorsValue, coOtherValue
    ])

    const saveObject = (listItems) => {
        if (!Array.isArray(listItems)) return;
        const lastByKey = {};
        listItems.forEach(item => {
            lastByKey[item.key] = item;
        });
        const entries = Object.values(lastByKey).filter(e => e.value !== undefined);
        if (!entries.length) return;
        // Track the whole batch as one save so the per-page panel shows a single
        // most-recent save status rather than N individual entries.
        trackApi('saveForecastFields', 'save', () => Promise.all(entries.map(({ key, value, buId, lockedVersion, version }) => {
            const data = {
                userId: '154045',
                userName: 'Seth Bailey',
                fieldName: key,
                tab: "Forecast",
                rowId: 1,
                version: version,
                value: value + '',
                id: buId,
                lockedVersion: lockedVersion
            };
            return updateUserDataArray(data);
        }))).catch(() => {});
    }

    useEffect(() => {
        // Labor
        const JTDL = pNum(JTDLabor ? JTDLabor.replace(/\(/g, '-').replace(/\)|,/g, '') : 0)
        const lCom = pNum(laborCommitments ? laborCommitments.replace(/\(/g, '-').replace(/\)|,/g, '') : 0)
        const lEtc = pNum(etcLabor ? etcLabor.replace(/\(/g, '-').replace(/\)|,/g, '') : 0)
        setEacLabor(formN((isNaN(lEtc) ? 0 : lEtc) + (isNaN(JTDL) ? 0 : JTDL) + (isNaN(lCom) ? 0 : lCom)))
        
        // Equipment
        const JTDE = pNum(JTDEquipment ? JTDEquipment.replace(/\(/g, '-').replace(/\)|,/g, '') : 0)
        const eCom = pNum(equipmentCommitments ? equipmentCommitments.replace(/\(/g, '-').replace(/\)|,/g, '') : 0)
        const eETC = pNum(etcEquipment ? etcEquipment.replace(/\(/g, '-').replace(/\)|,/g, '') : 0)
        setEacEquipment(formN((isNaN(eETC) ? 0 : eETC) + (isNaN(JTDE) ? 0 : JTDE) + (isNaN(eCom) ? 0 : eCom)))
        
        // Materials
        const JTDM = pNum(JTDMaterials ? JTDMaterials.replace(/\(/g, '-').replace(/\)|,/g, '') : 0)
        const mCom = pNum(materialsCommitments ? materialsCommitments.replace(/\(/g, '-').replace(/\)|,/g, '') : 0)
        const mEtc = pNum(etcMaterials ? etcMaterials.replace(/\(/g, '-').replace(/\)|,/g, '') : 0)
        setEacMaterials(formN((isNaN(mEtc) ? 0 : mEtc) + (isNaN(JTDM) ? 0 : JTDM) + (isNaN(mCom) ? 0 : mCom)))
        
        // Subcontractors
        const JTDS = pNum(JTDSubcontractors ? JTDSubcontractors.replace(/\(/g, '-').replace(/\)|,/g, '') : 0)
        const sCom = pNum(subcontractorsCommitments ? subcontractorsCommitments.replace(/\(/g, '-').replace(/\)|,/g, '') : 0)
        const sEtc = pNum(etcSubcontractors ? etcSubcontractors.replace(/\(/g, '-').replace(/\)|,/g, '') : 0)
        setEacSubcontractors(formN((isNaN(sEtc) ? 0 : sEtc) + (isNaN(JTDS) ? 0 : JTDS) + (isNaN(sCom) ? 0 : sCom)))
        
        // External Subcontractors
        const extSubJTD = pNum(etcExternalSubcontractors)
        const extSubCom = pNum(externalSubcontractorsCommitments)
        const extSubETC = pNum(etcExternalSubcontractors)
        setEacExternalSubcontractors(formN(extSubJTD + extSubCom + extSubETC, 1))
        
        const JTDO = pNum(JTDOtherExpenses ? JTDOtherExpenses.replace(/\(/g, '-').replace(/\)|,/g, '') : 0)
        const oCom = pNum(otherExpensesCommitments ? otherExpensesCommitments.replace(/\(/g, '-').replace(/\)|,/g, '') : 0)
        const oEtc = pNum(etcOtherExpenses ? etcOtherExpenses.replace(/\(/g, '-').replace(/\)|,/g, '') : 0)
        setEacOtherExpenses(formN(oEtc + oCom + JTDO))
    }, [etcLabor, JTDLabor, laborCommitments, etcEquipment, JTDEquipment, equipmentCommitments, 
        etcMaterials, JTDMaterials, materialsCommitments, etcSubcontractors, JTDSubcontractors, 
        subcontractorsCommitments, etcExternalSubcontractors, externalSubcontractorsCommitments, 
        etcOtherExpenses, JTDOtherExpenses, otherExpensesCommitments])

    useEffect(() => {
        const eLabor = pNum(etcLabor ? etcLabor.replace(/\(/g, '-').replace(/\)|,/g, '') : 0)
        const eMaterials = pNum(etcMaterials ? etcMaterials.replace(/\(/g, '-').replace(/\)|,/g, '') : 0)
        const eEquipment = pNum(etcEquipment ? etcEquipment.replace(/\(/g, '-').replace(/\)|,/g, '') : 0)
        const eSubcontractors = pNum(etcSubcontractors ? etcSubcontractors.replace(/\(/g, '-').replace(/\)|,/g, '') : 0)
        const eOtherExpenses = pNum(etcOtherExpenses ? etcOtherExpenses.replace(/\(/g, '-').replace(/\)|,/g, '') : 0)
        const eContingency = pNum(etcContigency ? etcContigency.replace(/\(/g, '-').replace(/\)|,/g, '') : 0)
        const eTotal = (isNaN(eLabor) ? 0 : eLabor) + (isNaN(eMaterials) ? 0 : eMaterials) + (isNaN(eEquipment) ? 0 : eEquipment) + (isNaN(eSubcontractors) ? 0 : eSubcontractors) + (isNaN(eOtherExpenses) ? 0 : eOtherExpenses) + (isNaN(eContingency) ? 0 : eContingency)
        setEtcTotal(formN(eTotal))
        
        const jTotal = pNum(JTDTotalCosts ? JTDTotalCosts.replace(/\(/g, '-').replace(/\)|,/g, '') : 0)
        const tCom = pNum(totalCommitments ? totalCommitments.replace(/\(/g, '-').replace(/\)|,/g, '') : 0)
        setEacTotal(formN(eTotal + jTotal + tCom))
        setContPercent((pNum(etcContigency) / (eTotal + tCom) * 100).toFixed(1))
        setCostPercent((jTotal / (jTotal + tCom + eTotal) * 100).toFixed() + '%')
    }, [etcLabor, etcMaterials, etcEquipment, etcSubcontractors, etcOtherExpenses, etcContigency, JTDTotalCosts, totalCommitments])

    useEffect(() => {
        const prevWIPTotal = pNum(laborDeltaWip) + pNum(equipmentDeltaWip) + pNum(materialsDeltaWip) + pNum(subcontractorsDeltaWip) + pNum(otherDeltaWip) + pNum(contingencyDeltaWip)
        const prevPercent = pNum(budgetDeltaWip) ? 100 * (pNum(budgetDeltaWip) - pNum(prevWIPTotal)) / pNum(budgetDeltaWip) : 0
        const percentDeltaWIP = pNum(eacTotalProfitPercent) - prevPercent
        if (prevWIPTotal > 0) {
            setPercentDeltaWip(fNum(percentDeltaWIP) + '%')
            const prevWIPGrossMargin = pNum(budgetDeltaWip) - pNum(prevWIPTotal) - pNum(overheadDeltaWip)
            setGrossMarginDeltaWip(fNum(pNum(eacGM) - pNum(prevWIPGrossMargin), 1))
            setGrossMarginDeltaWipPercent(fNum(pNum(eacGMP) - pNum(prevWIPGrossMargin) / pNum(budgetDeltaWip) * 100) + '%')
        }
    }, [eacTotalProfitPercent, eacRevenue, eacGMP, eacGM, budgetDeltaWip, laborDeltaWip, equipmentDeltaWip, materialsDeltaWip, subcontractorsDeltaWip, otherDeltaWip, contingencyDeltaWip])

    useEffect(() => {
        // Calculate overhead allocation
        const jOH = pNum(JTDOH)
        const eOH = pNum(etcOHAllocation ? etcOHAllocation.replace(/\(/g, '-').replace(/\)|,/g, '') : 0)
        const cOH = pNum(ohCommitments ? ohCommitments.replace(/\(/g, '-').replace(/\)|,/g, '') : 0)
        const totalOH = jOH + eOH + cOH
        setEacOHAllocation(formN(totalOH))
        
        // Calculate total profit
        const eTotal = pNum(eacTotal ? eacTotal.replace(/\(/g, '-').replace(/\)|,/g, '') : 0)
        const eacRevenue = pNum(budgetEACContract ? budgetEACContract.replace(/\(/g, '-').replace(/\)|,/g, '') : 0)
        const profit = eacRevenue - eTotal
        setEacTotalProfit(formN(profit))
        setEacTotalProfitPercent((((eacRevenue - eTotal) / eacRevenue) * 100).toFixed(2) + '%')
        
        // Calculate gross margin
        const gm = profit - totalOH
        setEacGM(formN(gm))
        setEacGMP((((profit - totalOH) / eacRevenue) * 100).toFixed(2) + '%')
    }, [JTDOH, etcOHAllocation, ohCommitments, afterCostOHEst, eacTotal, budgetEACContract])

    useEffect(() => {
        const cont = pNum(dayZeroBudgetContingency ? dayZeroBudgetContingency.replace(/\(/g, '-').replace(/\)|,/g, '') : 0)
        const contCo = pNum(coContingencyValue ? coContingencyValue.replace(/\(/g, '-').replace(/\)|,/g, '') : 0)
        setBudgetEACContingency(formN(cont + contCo))
        setContBudgetPercent((pNum(cont + contCo) / pNum(budgetEACTotalCosts) * 100).toFixed(1))
        setEstEarnedRev(formN(pNum(budgetEACContract) * pNum(JTDTotalCosts) / pNum(eacTotal)))
    }, [dayZeroBudgetContingency, coContingencyValue, budgetEACTotalCosts, eacTotal, budgetEACContract])

    useEffect(() => {
        const labor = pNum(eacLabor ? eacLabor.replace(/\(/g, '-').replace(/\)|,/g, '') : 0)
        const equipment = pNum(eacEquipment ? eacEquipment.replace(/\(/g, '-').replace(/\)|,/g, '') : 0)
        const materials = pNum(eacMaterials ? eacMaterials.replace(/\(/g, '-').replace(/\)|,/g, '') : 0)
        const subcontractors = pNum(eacSubcontractors ? eacSubcontractors.replace(/\(/g, '-').replace(/\)|,/g, '') : 0)
        const otherExpenses = pNum(eacOtherExpenses ? eacOtherExpenses.replace(/\(/g, '-').replace(/\)|,/g, '') : 0)
        const contingency = pNum(etcContigency ? etcContigency.replace(/\(/g, '-').replace(/\)|,/g, '') : 0)
        const total = pNum(eacTotal ? eacTotal.replace(/\(/g, '-').replace(/\)|,/g, '') : 0)
        const profit = pNum(eacTotalProfit ? eacTotalProfit.replace(/\(/g, '-').replace(/\)|,/g, '') : 0)
        const profitPercent = pNum(eacTotalProfitPercent ? eacTotalProfitPercent.replace(/\(/g, '-').replace(/\)|,/g, '') : 0)
        const oh = pNum(eacOHAllocation ? eacOHAllocation.replace(/\(/g, '-').replace(/\)|,/g, '') : 0)
        const gm = pNum(eacGM ? eacGM.replace(/\(/g, '-').replace(/\)|,/g, '') : 0)
        const gmPercent = pNum(eacGMP ? eacGMP.replace(/\(/g, '-').replace(/\)|,/g, '') : 0)

        const bLabor = pNum(budgetEACLabor ? budgetEACLabor.replace(/\(/g, '-').replace(/\)|,/g, '') : 0)
        const bEquipment = pNum(budgetEACEquipment ? budgetEACEquipment.replace(/\(/g, '-').replace(/\)|,/g, '') : 0)
        const bMaterials = pNum(budgetEACMaterials ? budgetEACMaterials.replace(/\(/g, '-').replace(/\)|,/g, '') : 0)
        const bSubcontractors = pNum(budgetEACSubcontractors ? budgetEACSubcontractors.replace(/\(/g, '-').replace(/\)|,/g, '') : 0)
        const bOtherExpenses = pNum(budgetEACOtherExpenses ? budgetEACOtherExpenses.replace(/\(/g, '-').replace(/\)|,/g, '') : 0)
        const bContingency = pNum(budgetEACContingency ? budgetEACContingency.replace(/\(/g, '-').replace(/\)|,/g, '') : 0)
        const bTotal = pNum(budgetEACTotalCosts ? budgetEACTotalCosts.replace(/\(/g, '-').replace(/\)|,/g, '') : 0)
        const bProfit = pNum(budgetEACJobProfit ? budgetEACJobProfit.replace(/\(/g, '-').replace(/\)|,/g, '') : 0)
        const bProfitPercent = pNum(budgetEACJP ? budgetEACJP.replace(/\(/g, '-').replace(/\)|,/g, '') : 0)
        const bOH = pNum(budgetEACOH ? budgetEACOH.replace(/\(/g, '-').replace(/\)|,/g, '') : 0)
        const bGM = pNum(budgetEACGM ? budgetEACGM.replace(/\(/g, '-').replace(/\)|,/g, '') : 0)
        const bGMPercent = pNum(budgetEACGMP ? budgetEACGMP.replace(/\(/g, '-').replace(/\)|,/g, '') : 0)

        setDeltaEACLabor(formN(labor - bLabor))
        setDeltaEACEquipment(formN(equipment - bEquipment))
        setDeltaEACMaterials(formN(materials - bMaterials))
        setDeltaEACSubcontractors(formN(subcontractors - bSubcontractors))
        setDeltaEACOtherExpenses(formN(otherExpenses - bOtherExpenses))
        setDeltaEACContingency(formN(contingency - bContingency))
        setDeltaEACTotalCosts(formN(total - bTotal))
        setDeltaEACJobProfit(formN(profit - bProfit))
        setDeltaEACJP(fNum(profitPercent - bProfitPercent) + '%')
        setDeltaEACOH(formN(oh - bOH))
        setDeltaEACGM(formN(gm - bGM))
        setDeltaEACGMP(fNum(gmPercent - bGMPercent) + '%')
    }, [eacLabor, eacEquipment, eacMaterials, eacSubcontractors, eacOtherExpenses, etcContigency, eacTotalProfit, eacGM, budgetEACLabor, budgetEACEquipment, budgetEACMaterials, budgetEACSubcontractors, budgetEACOtherExpenses, budgetEACContingency, budgetEACJobProfit, budgetEACGM])

    useEffect(() => {
        const labor = pNum(eacLabor ? eacLabor.replace(/\(/g, '-').replace(/\)|,/g, '') : 0)
        const equipment = pNum(eacEquipment ? eacEquipment.replace(/\(/g, '-').replace(/\)|,/g, '') : 0)
        const materials = pNum(eacMaterials ? eacMaterials.replace(/\(/g, '-').replace(/\)|,/g, '') : 0)
        const subcontractors = pNum(eacSubcontractors ? eacSubcontractors.replace(/\(/g, '-').replace(/\)|,/g, '') : 0)
        const otherExpenses = pNum(eacOtherExpenses ? eacOtherExpenses.replace(/\(/g, '-').replace(/\)|,/g, '') : 0)
        const contingency = pNum(etcContigency ? etcContigency.replace(/\(/g, '-').replace(/\)|,/g, '') : 0)
        const total = pNum(eacTotal ? eacTotal.replace(/\(/g, '-').replace(/\)|,/g, '') : 0)
        const profit = pNum(eacTotalProfit ? eacTotalProfit.replace(/\(/g, '-').replace(/\)|,/g, '') : 0)
        const profitPercent = pNum(eacTotalProfitPercent ? eacTotalProfitPercent.replace(/\(/g, '-').replace(/\)|,/g, '') : 0)
        const oh = pNum(eacOHAllocation ? eacOHAllocation.replace(/\(/g, '-').replace(/\)|,/g, '') : 0)
        const gm = pNum(eacGM ? eacGM.replace(/\(/g, '-').replace(/\)|,/g, '') : 0)
        const gmPercent = pNum(eacGMP ? eacGMP.replace(/\(/g, '-').replace(/\)|,/g, '') : 0)

        const dLabor = pNum(dayZeroBudgetLabor ? dayZeroBudgetLabor.replace(/\(/g, '-').replace(/\)|,/g, '') : 0)
        const dEquipment = pNum(dayZeroBudgetEquipment ? dayZeroBudgetEquipment.replace(/\(/g, '-').replace(/\)|,/g, '') : 0)
        const dMaterials = pNum(dayZeroBudgetMaterials ? dayZeroBudgetMaterials.replace(/\(/g, '-').replace(/\)|,/g, '') : 0)
        const dSubcontractors = pNum(dayZeroBudgetSubcontractors ? dayZeroBudgetSubcontractors.replace(/\(/g, '-').replace(/\)|,/g, '') : 0)
        const dOtherExpenses = pNum(dayZeroBudgetOtherExpenses ? dayZeroBudgetOtherExpenses.replace(/\(/g, '-').replace(/\)|,/g, '') : 0)
        const dContingency = pNum(dayZeroBudgetContingency ? dayZeroBudgetContingency.replace(/\(/g, '-').replace(/\)|,/g, '') : 0)
        const dTotal = pNum(dayZeroBudgetTotalCosts ? dayZeroBudgetTotalCosts.replace(/\(/g, '-').replace(/\)|,/g, '') : 0)
        const dProfit = pNum(dayZeroBudgetJobProfit ? dayZeroBudgetJobProfit.replace(/\(/g, '-').replace(/\)|,/g, '') : 0)
        const dProfitPercent = pNum(dayZeroBudgetJP ? dayZeroBudgetJP.replace(/\(/g, '-').replace(/\)|,/g, '') : 0)
        const dOH = dayZeroBudgetOH
        const dGM = pNum(dayZeroBudgetGM ? dayZeroBudgetGM.replace(/\(/g, '-').replace(/\)|,/g, '') : 0)
        const dGMPercent = pNum(dayZeroBudgetGMP ? dayZeroBudgetGMP.replace(/\(/g, '-').replace(/\)|,/g, '') : 0)

        setDeltaZeroLabor(formN(labor - dLabor))
        setDeltaZeroEquipment(formN(equipment - dEquipment))
        setDeltaZeroMaterials(formN(materials - dMaterials))
        setDeltaZeroSubcontractors(formN(subcontractors - dSubcontractors))
        setDeltaZeroOtherExpenses(formN(otherExpenses - dOtherExpenses))
        setDeltaZeroContingency(formN(contingency - dContingency))
        setDeltaZeroTotalCosts(formN(total - dTotal))
        setDeltaZeroJobProfit(formN(profit - dProfit))
        setDeltaZeroJP(fNum(profitPercent - dProfitPercent) + '%')
        setDeltaZeroOH(formN(pNum(dOH) - pNum(oh)))
        setDeltaZeroGM(formN(gm - dGM))
        setDeltaZeroGMP(fNum(gmPercent - dGMPercent) + '%')

    }, [eacLabor, eacEquipment, eacMaterials, eacSubcontractors, eacOtherExpenses, etcContigency, eacTotalProfit, eacGM, dayZeroBudgetLabor, dayZeroBudgetEquipment, dayZeroBudgetMaterials, dayZeroBudgetSubcontractors, dayZeroBudgetOtherExpenses, dayZeroBudgetContingency, dayZeroBudgetJobProfit, dayZeroBudgetGM, dayZeroBudgetTotalCosts])

    useEffect(() => {
        const b = pNum(billings ? billings.replace(/\(/g, '-').replace(/\)|,/g, '') : 0)
        const bEAC = pNum(budgetEACContract ? budgetEACContract.replace(/\(/g, '-').replace(/\)|,/g, '') : 0)
        setBillingPercent(isNaN(b) || isNaN(bEAC) ? '-' : (b / bEAC * 100).toFixed() + '%')
    }, [budgetEACContract, billings])

    useEffect(() => {
        const b = pNum(billings ? billings.replace(/\(/g, '-').replace(/\)|,/g, '') : 0)
        const bEAC = pNum(budgetEACContract ? budgetEACContract.replace(/\(/g, '-').replace(/\)|,/g, '') : 0)
        setLeftToBill(formN(bEAC - b))
    }, [billings, budgetEACContract])

    const checkForNegative = (value) => {
        if (value && value.length > 1) {
            if (value[0] === '(' || value[0] === '-') {
                return true
            }
        }
        return false
    }

    const Row = useCallback((rowData) => {
        const [expanded, setExpanded] = useState(false)
        const contPercent = rowData.contPercent
        const ohPercent = rowData.ohPercent
        const contBudgetPercent = rowData.contBudgetPercent
        const c = rowData.title == 'Contract Amount' || rowData.title == 'Total Costs' ? true : false

        return (
            <View style={{ justifyContent: 'center' }}>
                <View style={[s.container, { border: 0 }]}>
                    {rowData.expands ? <Pressable onPress={() => setExpanded(!expanded)} style={{ width: 30, alignItems: 'center', justifyContent: 'center' }}>
                        <Icon3 name={expanded ? "MdKeyboardArrowDown" : "MdArrowForwardIos"} size={16} color={photo ? 'white' : "#lightgrey"} />
                    </Pressable> : <View style={{ width: 30, border: 0 }}></View>}
                    <Text style={[s.span2, { borderColor: "#fff", fontSize: rowData.titleFontSize || 11 }]}>
                        {rowData.title}
                    </Text>
                    <View style={{ width: 40, alignItems: 'center' }}>
                    </View>
                    <Text style={[s.span, { backgroundColor: c ? '#efefef' : '#fff', fontSize: rowData.titleFontSize || 11 }]}>
                        {rowData.k2Budget}
                    </Text>
                    <Text style={[s.span, { backgroundColor: c ? '#efefef' : '#fff', fontSize: rowData.titleFontSize || 11 }]}>
                        {rowData.dayZeroBudget}
                    </Text>
                    <Text style={[s.span, { backgroundColor: c ? '#efefef' : '#fff', fontSize: rowData.titleFontSize || 11 }]}>
                        {rowData.approvedCOs}
                    </Text>
                    <Text
                        style={[s.span, { borderLeftWidth: photo ? 0 : 1, backgroundColor: c ? '#efefef' : '#fff', fontSize: rowData.titleFontSize || 11 }]}>
                        {rowData.budgetEAC}
                    </Text>
                    {rowData.contRows ?
                        <View style={{ flexDirection: 'row', backgroundColor: '#f2f2f2', justifyContent: 'center', alignItems: 'center', width: 50 }}>
                            <Text style={{ fontSize: 10 }}>{contBudgetPercent}%</Text>
                        </View> :
                        <View style={{ width: 50, alignItems: 'center', justifyContent: 'center', borderColor: '#fff' }}>
                        </View>
                    }
                    <Text style={[s.span, { backgroundColor: c ? '#efefef' : '#fff', fontSize: rowData.titleFontSize || 11 }]}>
                        {rowData.JTDActualCost}
                    </Text>
                    <Text style={[s.span, { backgroundColor: c ? '#efefef' : '#fff', fontSize: rowData.titleFontSize || 11 }]}>
                        {rowData.committed}
                    </Text>
                    {rowData.otherRows ?
                        <View style={{ flexDirection: 'row', backgroundColor: '#f2f2f2', justifyContent: 'center', alignItems: 'center', width: 50 }}>
                            <Text style={{ fontSize: 10 }}>{ohPercent}%</Text>
                        </View> :
                        rowData.contRows ?
                            <View style={{ flexDirection: 'row', backgroundColor: '#f2f2f2', justifyContent: 'center', alignItems: 'center', width: 50 }}>
                                <Text style={{ fontSize: 10 }}>{contPercent}%</Text>
                            </View> :
                            <View style={{ width: 50, alignItems: 'center', justifyContent: 'center', borderColor: '#fff' }}>
                            </View>
                    }
                    <Text style={[s.span, { backgroundColor: c ? '#efefef' : '#fff', fontSize: rowData.titleFontSize || 11 }]}>
                        {rowData.ETC}
                    </Text>
                    <Text style={[s.span, { backgroundColor: c ? '#efefef' : '#fff', fontSize: rowData.titleFontSize || 11 }]}>
                        {rowData.EAC}
                    </Text>
                    <Text style={[s.span, { marginLeft: 50, borderLeftWidth: 1, fontSize: rowData.titleFontSize || 11 }]}>
                        {rowData.deltaEAC}
                    </Text>
                    <Text style={[s.span, { fontSize: rowData.titleFontSize || 11 }]}>
                        {rowData.deltaZero}
                    </Text>
                    <Text style={[s.span, { borderLeftWidth: 1, fontSize: rowData.titleFontSize || 11 }]}>
                        {rowData.deltaWip}
                    </Text>
                    {!photo && varianceWeeks.map(guid => {
                        const weekVal = weekEacMaps[guid]?.[rowData.weekField];
                        const mode = weekDisplayMode[guid] || 'var';
                        const isPercent = rowData.weekField === 'jpPercent' || rowData.weekField === 'gmPercent';
                        let displayVal;
                        if (isPercent) {
                            displayVal = mode === 'var' && weekVal != null
                                ? fNum(pNum(rowData.EAC) - pNum(weekVal)) + '%'
                                : weekVal;
                        } else {
                            displayVal = mode === 'var' && weekVal != null
                                ? fNum(pNum(rowData.EAC) - pNum(weekVal), 1)
                                : weekVal != null ? fNum(weekVal, 1) : '';
                        }
                        return (
                            <Text key={guid} style={[s.span, { backgroundColor: mode === 'var' ? '#fef9ee' : '#f8faff', fontSize: rowData.titleFontSize || 11 }]}>
                                {weekLoading[guid] ? '...' : displayVal}
                            </Text>
                        );
                    })}
                </View>
                <View>
                    {expanded && rowData.subRows ? rowData.subRows.map((row, index) => (
                        <SubRow
                            key={index}
                            title={row.title}
                            objectAccountId={row.objectAccountId}
                            dayZeroBudget={row.dayZeroBudget}
                            approvedCOs={row.approvedCOs}
                            budgetEAC={row.budgetEAC}
                            JTDActualCost={row.JTDActualCost}
                            committedCosts={row.committedCosts}
                            ETC={row.ETC}
                            etcEditable={row.etcEditable}
                            EAC={row.EAC}
                            deltaEAC={row.deltaEAC}
                            deltaBid={row.deltaBid}
                            buId={row.buId}
                        ></SubRow>
                    )) : null}
                </View>
            </View>
        )
    }, [weekDisplayMode, weekTotalMaps, weekEacMaps, weekLoading, varianceWeeks, weekCostTypeMaps])

    const SubRow = useCallback((rowData) => {
        return (
            <View style={{ flexDirection: 'row', paddingBottom: 0, fontSize: 10, borderBottomWidth: 2, borderColor: '#F9F8FB' }}>
                <View style={{ width: 30, height: '100%' }}></View>
                <Text style={{ width: 180, alignItems: 'center', fontSize: 10, color: '#161616', fontWeight: 500, padding: 2, backgroundColor: '#f2f2f2' }}>
                    {rowData.title}
                </Text>
                <Text style={[s.span, { width: 40, backgroundColor: '#f2f2f2', fontSize: 9 }]}>
                    {rowData.objectAccountId}
                </Text>
                <Text
                    style={[s.span, { backgroundColor: '#f2f2f2', fontSize: 10 }]}>
                </Text>
                <Text
                    style={[s.span, { backgroundColor: '#f2f2f2', fontSize: 10 }]}>
                    {rowData.dayZeroBudget}
                </Text>
                <Text style={[s.span, { backgroundColor: '#f2f2f2', fontSize: 10 }]}>
                    {rowData.approvedCOs}
                </Text>
                <Text
                    dataSet={{ test: 'dayZeroBudget-' + rowData.objectAccountId }}
                    style={[s.span, { backgroundColor: '#f2f2f2', fontSize: 10 }]}>
                    {rowData.budgetEAC}
                </Text>
                <View style={{ width: 50, alignItems: 'center' }}>
                </View>
                <Text style={[s.span, { backgroundColor: '#f2f2f2', fontSize: 10 }]}>
                    {rowData.JTDActualCost}
                </Text>
                <Text style={[s.span, { backgroundColor: '#f2f2f2', fontSize: 10 }]}>
                    {rowData.committedCosts}
                </Text>
                <View style={{ width: 50, alignItems: 'center' }}>
                </View>
                <Text style={[s.span, { backgroundColor: '#f2f2f2', fontSize: 10 }]}>
                    {rowData.ETC}
                </Text>
                <Text style={[s.span, { backgroundColor: '#f2f2f2', fontSize: 10 }]}>
                    {rowData.EAC}
                </Text>
                <Text style={[checkForNegative(rowData.deltaEAC) ? s.spanR : s.spanG, s.span, { marginLeft: 50, borderLeftWidth: 1, fontSize: 10 }]}>
                    {rowData.deltaEAC}
                </Text>
                <Text style={[checkForNegative(rowData.deltaEAC) ? s.spanR : s.spanG, s.span, { fontSize: 10 }]}>
                    {rowData.deltaBid}
                </Text>
                <Text style={[s.span, { backgroundColor: '#f2f2f2', fontSize: 10, borderLeftWidth: 1 }]}></Text>
                {varianceWeeks.map(guid => {
                    const compETC = weekCostTypeMaps[guid]?.[rowData.objectAccountId];
                    const currentETC = pNum(rowData.ETC);
                    const mode = weekDisplayMode[guid] || 'var';
                    let displayVal;
                    if (compETC == null) {
                        displayVal = '';
                    } else if (mode === 'var') {
                        displayVal = fNum(currentETC - compETC, 1);
                    } else {
                        displayVal = fNum(compETC, 1);
                    }
                    return (
                        <Text key={guid} style={[s.span, { backgroundColor: mode === 'var' ? '#fef9ee' : '#f8faff', fontSize: 10 }]}>
                            {weekLoading[guid] ? '...' : displayVal}
                        </Text>
                    );
                })}
            </View>
        )
    }, [weekCostTypeMaps, weekDisplayMode, weekLoading, varianceWeeks])

    const s = StyleSheet.create({
        topContainer: {
            justifyContent: 'center',
            alignItems: 'center',
            backgroundColor: 'white',
            borderRadius: 5
        },
        container: {
            flexDirection: 'row',
            paddingBottom: 0,
        },
        smallContainer: {

        },
        span2: {
            width: 180,
            alignItems: 'center',
            fontSize: 16,
            fontWeight: 500,
            padding: 2,
            paddingLeft: 10,
            borderLeftWidth: 1,
            borderColor: '#F9F8FB',
            backgroundColor: '#e0e0e0',
            borderBottomWidth: 1

        },
        span: {
            width: 84,
            alignItems: 'center',
            fontSize: 20,
            padding: 2,
            textAlign: 'right',
            borderLeftWidth: 1,
            borderColor: '#e0e0e0',
            borderWidth: 1,
            border: '1px solid #e0e0e0',
        },
        spanG: {
            width: 120,
            alignItems: 'center',
            fontSize: 20,
            padding: 2,
            textAlign: 'right',
            backgroundColor: '#c6efce',
            borderLeftWidth: 1,
            borderColor: '#e0e0e0'
        },
        spanR: {
            width: 120,
            alignItems: 'center',
            fontSize: 20,
            padding: 2,
            textAlign: 'right',
            backgroundColor: '#ffc7ce',
            borderLeftWidth: 1,
            borderColor: '#e0e0e0'
        },
        span3: {
            width: 300,
            alignItems: 'center',
            fontSize: 20,
            padding: 5
        },
        span2T: {
            width: 200,
            alignItems: 'center',
            fontSize: 16,
            padding: 2
        },
        span2TH: {
            width: 200,
            alignItems: 'center',
            fontSize: 16,
            padding: 2,
            backgroundColor: 'yellow'
        },
        spanT: {
            width: 84,
            minWidth: 80,
            alignItems: 'center',
            fontSize: 16,
            padding: 5,
            textAlign: 'right',
            backgroundColor: '#e0e0e0',
            borderRightWidth: 1,
            borderColor: 'white',
            fontWeight: 500,
            color: '#161616'
        },
        span3T: {
            width: 300,
            alignItems: 'center',
            fontSize: 16,
            padding: 2,
            paddingLeft: 20
        },
        card: {
            width: 400,
            borderRadius: 5,
            padding: 10,
            borderWidth: .5,
            borderColor: 'lightgrey',

        },
        tabItem: {
            paddingVertical: 12,
            paddingHorizontal: 16,
            borderBottomWidth: 2,
            borderBottomColor: 'transparent',
        },
        activeTab: {
            borderBottomColor: '#192440',
        },
        tabText: {
            fontSize: 16,
            color: '#888',
        },
        activeText: {
            color: '#000',
            fontWeight: '600',
        },
        content: {
            padding: 20,
        },
        contentText: {
            fontSize: 16,
        },

    })

    const formN = (x) => {
        return x ? (parseInt(x) > 0 ? parseInt(x)?.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",") : '(' + parseInt(-x)?.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",") + ')') : ''
    }
    const costSections = {
        "Labor": ["51100", "51200", "51300", "51350", "51400", "51500", "51600", "51700", "51800"],
        "Equipment": ["52100", "52200", "52300", "52400"],
        "Materials": ["53100", "53200", "53300", "53310", "53400", "53500"],
        "Subcontractors": ["54100", "54200", "54300"],
        "Other Expenses": ["55100", "55200", "55300", "55400", "55900", "56100", "56200", "56300", "56400", "56500", "56600", "56700", "56800", "57100", "57200", "57300", "57900"]// "55900"], "11420", "59899"]
    }

    const costTypes = {
        "51100": { name: "Regular Time", value: 0 },
        "51200": { name: "Overtime", value: 0 },
        "51300": { name: "Burden", value: 0 },
        "51350": { name: "Allocated Ops Support", value: 0 },
        "51400": { name: "BYOD", value: 0 },
        "51500": { name: "Per Diem", value: 0 },
        "51600": { name: "Truck Pay", value: 0 },
        "51700": { name: "Welding Rig Pay", value: 0 },
        "51800": { name: "Field Bonus", value: 0, etcEditable: true, approvedCOs: 0 },
        "52100": { name: "Inside Equipment Rental", value: 0 },
        "52200": { name: "Outside Equipment Rental", value: 0 },
        "52300": { name: "Fuel", value: 0, etcEditable: true },
        "52400": { name: "Repairs", value: 0, etcEditable: true },
        "53100": { name: "Materials", value: 0 },
        "53200": { name: "Mats", value: 0 },
        //"53210": { name: "Mats", value: 0 },
        "53300": { name: "Small Tools – Purchase", value: 0 },
        "53310": { name: "Small Tools – Rent", value: 0 },
        "53400": { name: "Skids", value: 0 },
        "53500": { name: "Consumables", value: 0 },
        "54100": { name: "Internal Subcontractors", value: 0 },
        "54200": { name: "External Subcontractors", value: 0 },
        "54300": { name: "Hauling and Transportation", value: 0 },
        "55100": { name: "Personal Meals", value: 0, etcEditable: true },
        "55200": { name: "Team Meals/Entertain", value: 0, etcEditable: true },
        "55300": { name: "Airfare", value: 0, etcEditable: true },
        "55400": { name: "Lodging", value: 0, etcEditable: true },
        "56100": { name: "Field Office Rent", value: 0, etcEditable: true },
        "56200": { name: "Field Office Utility", value: 0, etcEditable: true },
        "56300": { name: "Field Office Expense", value: 0, etcEditable: true },
        "56400": { name: "Lab Fees & Testing", value: 0, etcEditable: true },
        "56500": { name: "Safety & PPE", value: 0, etcEditable: true },
        "56600": { name: "Bonds and Insurance Premiums", value: 0, etcEditable: true },
        "56700": { name: "Permits", value: 0, etcEditable: true },
        "56800": { name: "Insurance Claims", value: 0, etcEditable: true },
        "57100": { name: "Taxes", value: 0, etcEditable: true },
        "57200": { name: "Accrued Expense", value: 0, etcEditable: true },
        "57300": { name: "Warranty Reserve", value: 0, etcEditable: true },
        "57900": { name: "Miscellaneous", value: 0, etcEditable: true },
        "55900": { name: "Other Travel Expense", value: 0, etcEditable: true },
        "11420": { name: "Miscellaneous", value: 0, etcEditable: true },
        "59899": { name: "Miscellaneous", value: 0, etcEditable: true },
    }

    const calculateCommitmentAmounts = (commitments) => {
        let laborCommitted = 0
        let equipmentCommitted = 0
        let materialsCommitted = 0
        let subcontractorsCommitted = 0
        let externalsSubcontractorsCommitted = 0
        let otherExpensesCommitted = 0
        let totalCommitted = 0
        let ohCommitted = 0
        let commited = {}
        commitments?.forEach((row) => {
            totalCommitted = totalCommitted + row.PO_True_Open_Amount
            if (row.Cost_Type_Code >= '51000' && row.Cost_Type_Code <= '51999') {
                laborCommitted = laborCommitted + row.PO_True_Open_Amount
            }

            if (row.Cost_Type_Code >= '52000' && row.Cost_Type_Code <= '52999') {
                equipmentCommitted = equipmentCommitted + row.PO_True_Open_Amount
            }

            if (row.Cost_Type_Code >= '53000' && row.Cost_Type_Code <= '53999') {
                materialsCommitted = materialsCommitted + row.PO_True_Open_Amount
            }

            if (row.Cost_Type_Code >= '54000' && row.Cost_Type_Code <= '54999') {
                subcontractorsCommitted = subcontractorsCommitted + row.PO_True_Open_Amount
            }

            if (row.Cost_Type_Code >= '54200' && row.Cost_Type_Code <= '54300') {
                externalsSubcontractorsCommitted = externalsSubcontractorsCommitted + row.PO_True_Open_Amount
            }

            if (row.Cost_Type_Code >= '55000' && row.Cost_Type_Code <= '58000') {
                otherExpensesCommitted = otherExpensesCommitted + row.PO_True_Open_Amount
            }

            if (row.Cost_Type_Code >= '60900' && row.Cost_Type_Code <= '61000') {
                ohCommitted = ohCommitted + row.PO_True_Open_Amount
            }

            if (commited[row.Cost_Type_Code]) {
                commited[row.Cost_Type_Code].value = commited[row.Cost_Type_Code].value + row.PO_True_Open_Amount
            } else {
                commited[row.Cost_Type_Code] = { name: row.Cost_Type_Code, value: row.PO_True_Open_Amount }
            }
        })

        setLaborCommitments(formN(laborCommitted))
        setEquipmentCommitments(formN(equipmentCommitted))
        setMaterialsCommitments(formN(materialsCommitted))
        setSubcontractorsCommitments(formN(subcontractorsCommitted))
        setExternalSubcontractorsCommitments(externalsSubcontractorsCommitted)
        setOtherExpensesCommitments(formN(otherExpensesCommitted))
        setTotalCommitments(formN(totalCommitted))
        return commited
    }

    const calculateContractAmounts = (commited = {}) => {
        let contractValues = 0
        let contractValuesRevised = 0
        let laborAsSold = 0
        let laborDayZeroBudget = 0
        let equipmentAsSold = 0
        let equipmentDayZeroBudget = 0
        let materialsAsSold = 0
        let materialsDayZeroBudget = 0
        let subcontractorsAsSold = 0
        let subcontractorsDayZeroBudget = 0
        let otherExpensesAsSold = 0
        let otherExpensesDayZeroBudget = 0
        let contingencyAsSold = 0
        let contingencyDayZeroBudget = 0
        let overheadDayZeroBudget = 0
        let totalCostsAsSold = 0
        let totalCostsDayZeroBudget = 0
        let jobProfitAsSold = 0
        let jobProfitDayZeroBudget = 0
        let jpDayZeroBudget = 0
        let ohAsSold = 0
        let gmAsSold = 0
        let gmDayZeroBudget = 0
        let gmpDayZeroBudget = 0
        let revenueJTD = 0
        let revenueJTDPrevPeriod = 0
        let laborJTD = 0
        let laborHoursJTD = 0
        let equipmentJTD = 0
        let materialsJTD = 0
        let subcontractorsJTD = 0
        let externalSubsJTD = 0
        let otherExpensesJTD = 0
        let contingencyJTD = 0
        let totalCostsJTD = 0
        let ohJTD = 0

        const dayZeroValues = {}
        if (jobUserData && jobUserData.length > 0) {
            jobUserData.forEach((d) => {
                if (d?.Forecast_Tab === 'Day Zero Budget') {
                    dayZeroValues[d?.Forecast_Row_ID] = d
                }
            })
        }

        const actualTypes = {}
        const typeBudgets = {}
        const typeBudgetHours = {}
        Object.values(dayZeroValues).forEach((row) => {
            if (row['Cost_Type'] && row['Cost_Code'] != '101101') {
                // Accumulate budget hours per cost type (use Hours field for labor, not Quantity)
                if (row['Cost_Type'] >= '51000' && row['Cost_Type'] <= '51999') {
                    const hrs = pNum(row.Hours || 0)
                    if (hrs) {
                        typeBudgetHours[row['Cost_Type']] = (typeBudgetHours[row['Cost_Type']] || 0) + hrs
                    }
                }
                if (row['Cost_Type'][0] == '4') {
                    contractValuesRevised = contractValuesRevised + pNum(row.Value_Amount)
                }

                if (row['Cost_Type'] >= '51000' && row['Cost_Type'] <= '51999') {
                    laborDayZeroBudget = laborDayZeroBudget + pNum(row.Value_Amount)
                }

                if (row['Cost_Type'] >= '52000' && row['Cost_Type'] <= '52999') {
                    equipmentDayZeroBudget = equipmentDayZeroBudget + pNum(row.Value_Amount)
                }

                if (row['Cost_Type'] >= '53000' && row['Cost_Type'] <= '53999') {
                    materialsDayZeroBudget = materialsDayZeroBudget + pNum(row.Value_Amount)
                }

                if (row['Cost_Type'] >= '54000' && row['Cost_Type'] <= '54999') {
                    subcontractorsDayZeroBudget = subcontractorsDayZeroBudget + pNum(row.Value_Amount)
                }

                if (row['Cost_Type'] >= '55000' && row['Cost_Type'] <= '58000') {
                    otherExpensesDayZeroBudget = otherExpensesDayZeroBudget + pNum(row.Value_Amount)
                }

                if (row['Cost_Type'] == '60900') {
                    overheadDayZeroBudget = overheadDayZeroBudget + pNum(row.Value_Amount)
                }

                if (typeBudgets[row['Cost_Type']]) {
                    typeBudgets[row['Cost_Type']] = typeBudgets[row['Cost_Type']] + pNum(row.Value_Amount)
                } else {
                    typeBudgets[row['Cost_Type']] = pNum(row.Value_Amount)
                }
            } else {
                if (row['Cost_Type'] && row['Cost_Type'][0] == '5') {
                    contingencyDayZeroBudget = contingencyDayZeroBudget + pNum(row.Value_Amount)
                }
            }
        })

        let lastFoundOHDate = moment('01/01/1900', 'MM/DD/YYYY')
        jobCostDetail?.forEach((row) => {
            if (row.Cost_Type_Code >= '40000' && row.Cost_Type_Code <= '49999') {
                revenueJTD = revenueJTD + row.Job_Cost
                if (moment(row.GL_Date).isBefore(moment(versionInfo?.Version_Start_DateTime).add('-1', 'Month').endOf('Month').format('YYYY-MM-DD'))) {
                    revenueJTDPrevPeriod = revenueJTDPrevPeriod + row.Job_Cost
                }
            }

            if (row.Cost_Type_Code >= '51000' && row.Cost_Type_Code <= '51999') {
                laborJTD = laborJTD + row.Job_Cost
                laborHoursJTD = laborHoursJTD + row.Total_Hours
            }

            if (row.Cost_Type_Code >= '52000' && row.Cost_Type_Code <= '52999') {
                equipmentJTD = equipmentJTD + row.Job_Cost
            }

            if (row.Cost_Type_Code >= '53000' && row.Cost_Type_Code <= '53999') {
                materialsJTD = materialsJTD + row.Job_Cost
            }

            if (row.Cost_Type_Code >= '54000' && row.Cost_Type_Code <= '54999') {
                subcontractorsJTD = subcontractorsJTD + row.Job_Cost
            }

            if (row.Cost_Type_Code >= '54200' && row.Cost_Type_Code <= '54300') {
                externalSubsJTD = externalSubsJTD + row.Job_Cost
            }

            if (row.Cost_Type_Code >= '55000' && row.Cost_Type_Code <= '58000') {
                otherExpensesJTD = otherExpensesJTD + row.Job_Cost
            }

            if (row.Cost_Type_Code == '60900') {
                ohJTD = ohJTD + pNum(row.Job_Cost)
                if (lastFoundOHDate.isBefore(row.GL_Date)) {
                    lastFoundOHDate = moment(row.GL_Date)
                }
            }

            if (actualTypes[row.Cost_Type_Code]) {
                actualTypes[row.Cost_Type_Code].value = actualTypes[row.Cost_Type_Code].value + row.Job_Cost
                actualTypes[row.Cost_Type_Code].hours = (actualTypes[row.Cost_Type_Code].hours || 0) + (row.Total_Hours || 0)
            } else {
                actualTypes[row.Cost_Type_Code] = { name: row.Cost_Type_Code, value: row.Job_Cost, hours: row.Total_Hours || 0 }
            }
        })

        // Calculate ETC hours for labor from burn tool data
        let etcLaborHours = 0
        const phasedLaborLocal = {}
        const laborValuesLocal = {}
        if (jobUserData && jobUserData.length > 0) {
            jobUserData.forEach((d) => {
                if (d?.Forecast_Tab === 'Burn Tool Labor Phased') {
                    phasedLaborLocal[d?.Forecast_Row_ID] = d
                }
                if (d?.Forecast_Tab === 'Burn Tool Labor') {
                    laborValuesLocal[d?.Forecast_Row_ID] = d
                }
            })
        }
        // Phased labor hours
        Object.keys(phasedLaborLocal).forEach((row) => {
            const weekRow = row.includes('=')
            const week = row.split('=')[1]
            if (weekRow && week) {
                const withinProject = moment(week).isAfter(moment(versionInfo?.Version_Start_DateTime).startOf('week')) && moment(week).isBefore(moment(completionFor(row)).endOf('week'))
                const h = pNum(phasedLaborLocal[row]?.Number_Hours || 0)
                const cs = pNum(phasedLaborLocal[row]?.Number_Units || 0)
                if (withinProject && h && cs) {
                    etcLaborHours += h * cs
                }
            }
        })
        // Non-phased labor hours
        Object.values(laborValuesLocal).forEach((row) => {
            const week = stripBuPrefix(row.Forecast_Row_ID || '').split('*')[0]
            if (week && moment(week).isAfter(moment(versionInfo?.Version_Start_DateTime).startOf('week')) && moment(completionFor(row.Forecast_Row_ID)).isAfter(week)) {
                const h = pNum(row.Number_Hours || 0)
                const cs = pNum(row.Number_Units || 0)
                if (h && cs) {
                    etcLaborHours += h * cs
                }
            }
        })

        let totalCostAfterLastOH = 0
        jobCostDetail?.forEach((row) => {
            if (row.Cost_Type_Code >= '50000' && row.Cost_Type_Code <= '60000' && lastFoundOHDate.isBefore(row.GL_Date)) {
                totalCostAfterLastOH = totalCostAfterLastOH + row.Job_Cost
            }
        })

        setCostDate(lastFoundOHDate.format('M/DD'))
        setAfterCostActual(formN(totalCostAfterLastOH))
        setAfterCostOHEst(formN(totalCostAfterLastOH * pNum(ohPercent) / 100))

        totalCostsJTD = laborJTD + equipmentJTD + materialsJTD + subcontractorsJTD + otherExpensesJTD + contingencyJTD
        totalCostsAsSold = laborAsSold + equipmentAsSold + materialsAsSold + subcontractorsAsSold + otherExpensesAsSold + contingencyAsSold
        jobProfitAsSold = -contractValues - totalCostsAsSold
        gmAsSold = jobProfitAsSold - ohAsSold

        totalCostsDayZeroBudget = laborDayZeroBudget + equipmentDayZeroBudget + materialsDayZeroBudget + subcontractorsDayZeroBudget + otherExpensesDayZeroBudget + contingencyDayZeroBudget
        jobProfitDayZeroBudget = contractValuesRevised - totalCostsDayZeroBudget
        jpDayZeroBudget = contractValuesRevised ? pNum((jobProfitDayZeroBudget / contractValuesRevised) * 100).toFixed(2) + '%' : ''
        gmDayZeroBudget = jobProfitDayZeroBudget - overheadDayZeroBudget/*ohDayZeroBudget*/
        gmpDayZeroBudget = contractValuesRevised ? pNum((gmDayZeroBudget / contractValuesRevised) * 100).toFixed(2) + '%' : ''
        setDayZeroBudgetContract(formN(contractValuesRevised))
        setBudgetEACContract(formN(contractValuesRevised + (coValues['Total Revenue'] ? coValues['Total Revenue'] : 0)))
        setBudgetEACOH(formN(pNum(overheadDayZeroBudget) + pNum(coOHAllocation)))
        setBudgetEACJP((contractValuesRevised + (coValues['Total Revenue'] ? coValues['Total Revenue'] : 0)) ? ((jobProfitDayZeroBudget + (coValues['Total Profit'] ? coValues['Total Profit'] : 0)) * 100 / (contractValuesRevised + (coValues['Total Revenue'] ? coValues['Total Revenue'] : 0))).toFixed(2) + '%' : '')
        setBudgetEACGM(formN((jobProfitDayZeroBudget + (coValues['Total Profit'] ? coValues['Total Profit'] : 0)) - (pNum(overheadDayZeroBudget) + pNum(coOHAllocation))))
        setBudgetEACGMP((contractValuesRevised + (coValues['Total Revenue'] ? coValues['Total Revenue'] : 0)) ? (((jobProfitDayZeroBudget + (coValues['Total Profit'] ? coValues['Total Profit'] : 0)) - (pNum(overheadDayZeroBudget) + pNum(coOHAllocation))) / (contractValuesRevised + (coValues['Total Revenue'] ? coValues['Total Revenue'] : 0)) * 100).toFixed(2) + '%' : '')

        setDayZeroBudgetLabor(formN(laborDayZeroBudget))
        setDayZeroBudgetEquipment(formN(equipmentDayZeroBudget))
        setDayZeroBudgetMaterials(formN(materialsDayZeroBudget))
        setDayZeroBudgetSubcontractors(formN(subcontractorsDayZeroBudget))
        setDayZeroBudgetOtherExpenses(formN(otherExpensesDayZeroBudget))
        setDayZeroBudgetContingency(formN(contingencyDayZeroBudget))
        setDayZeroBudgetTotalCosts(formN(totalCostsDayZeroBudget))
        setDayZeroBudgetJobProfit(formN(jobProfitDayZeroBudget))
        setDayZeroBudgetJP(jpDayZeroBudget)
        setDayZeroBudgetOH(overheadDayZeroBudget ? formN(overheadDayZeroBudget) : '')
        setDayZeroBudgetGM(formN(gmDayZeroBudget))
        setDayZeroBudgetGMP(gmpDayZeroBudget)

        setBudgetEACLabor(formN(laborDayZeroBudget + (coValues['Total Labor Cost'] ? coValues['Total Labor Cost'] : 0)))
        setBudgetEACEquipment(formN(equipmentDayZeroBudget + (coValues['Total Equipment Cost'] ? coValues['Total Equipment Cost'] : 0)))
        setBudgetEACMaterials(formN(materialsDayZeroBudget + (coValues['Total Materials Cost'] ? coValues['Total Materials Cost'] : 0)))
        setBudgetEACSubcontractors(formN(subcontractorsDayZeroBudget + (coValues['Total Subcontractors Cost'] ? coValues['Total Subcontractors Cost'] : 0)))
        setBudgetEACOtherExpenses(formN(otherExpensesDayZeroBudget + (coValues['Total Other Cost'] ? coValues['Total Other Cost'] : 0)))
        setBudgetEACTotalCosts(formN(totalCostsDayZeroBudget + (coValues['Total CO Cost'] ? coValues['Total CO Cost'] : 0)))
        setBudgetEACJobProfit(formN(jobProfitDayZeroBudget + (coValues['Total Profit'] ? coValues['Total Profit'] : 0)))

        setJTDRevenuePrevPeriod(formN(-revenueJTDPrevPeriod))
        setJTDLabor(formN(laborJTD))
        setJTDEquipment(formN(equipmentJTD))
        setJTDMaterials(formN(materialsJTD))
        setJTDSubcontractors(formN(subcontractorsJTD))
        setJTDOtherExpenses(formN(otherExpensesJTD))
        setJTDTotalCosts(formN(totalCostsJTD))
        setJTDOH(formN(ohJTD))

        let totalRegularOvertimeHours = 0
        let totalEACRegularOvertimeHours = 0
        Object.keys(costSections).forEach((section) => {
            const subRows = []
            costSections[section].forEach((costType) => {
                // Field Bonus row is gone for versions past the cutoff
                if (hideFieldBonus && costType === '51800') return
                const dayZeroBudget = typeBudgets[costType] ? typeBudgets[costType] : 0
                const approvedCOs = costTypes[costType].name && coValues[costTypes[costType].name] ? coValues[costTypes[costType].name] : 0
                const budgetEAC = dayZeroBudget + approvedCOs
                const JTDActualCost = actualTypes[costType] && actualTypes[costType].value ? actualTypes[costType].value : 0
                const committedCosts = commited[costType] && commited[costType].value ? commited[costType].value : 0
                const ETC = userValues[costTypes[costType].name] ? userValues[costTypes[costType].name] : 0
                const EAC = JTDActualCost + ETC + committedCosts
                const deltaEAC = budgetEAC - EAC
                const deltaBid = dayZeroBudget - EAC

                if (costType == "51100" || costType == "51200") {
                    const actHrs = actualTypes[costType] && actualTypes[costType].hours ? actualTypes[costType].hours : 0
                    totalRegularOvertimeHours = totalRegularOvertimeHours + actHrs
                    // EAC hours = actual + ETC (burn tool forecasted hours are 51100 only)
                    totalEACRegularOvertimeHours = totalEACRegularOvertimeHours + actHrs + (costType === '51100' ? etcLaborHours : 0)
                }

                const d = {
                    title: costTypes[costType].name,
                    objectAccountId: costType,
                    dayZeroBudget: formN(dayZeroBudget),
                    approvedCOs: formN(approvedCOs),
                    budgetEAC: formN(budgetEAC),
                    JTDActualCost: formN(JTDActualCost),
                    committedCosts: formN(committedCosts),
                    ETC: formN(ETC),
                    etcEditable: costTypes[costType].etcEditable,
                    EAC: formN(EAC),
                    jobWithoutInternalSubs: '',
                    deltaEAC: formN(deltaEAC),
                    deltaBid: formN(deltaBid),
                    buId: selectedJob
                }
                //console.log('d', section, d, userValues, costTypes, costType)
                subRows.push(d)

            })

            if (section == "Labor") {
                setLaborSubRows(subRows)
            } else if (section == "Equipment") {
                //console.log('equipment subrows', subRows)
                setEquipmentSubRows(subRows)
            } else if (section == "Materials") {
                setMaterialsSubRows(subRows)
            } else if (section == "Subcontractors") {
                setSubcontractorsSubRows(subRows)
            } else if (section == "Other Expenses") {
                let totalETC = 0
                subRows.forEach(row => {
                    totalETC = totalETC + pNum(row?.ETC ? pNum(row.ETC) : 0)
                })
                setEtcOtherExpenses(formN(totalETC))
                setOtherExpensesSubRows(subRows)
            }

        })
        console.log('laborPercent calc (hours):', { actualHours511_512: totalRegularOvertimeHours, budgetHours511_512: totalEACRegularOvertimeHours, laborPercent: totalEACRegularOvertimeHours ? (100 * totalRegularOvertimeHours / totalEACRegularOvertimeHours) : 0 })
        setLaborPercent(totalEACRegularOvertimeHours ? fNum(100 * (totalRegularOvertimeHours / totalEACRegularOvertimeHours), 1) : '0')
    }

    // ---- Service Offering rollup -------------------------------------------------
    // Service Offering is a higher-level grouping that sits ABOVE the phase code. For now
    // it is derived from the phase-code DESCRIPTION prefix — the text before the first
    // " - " (e.g. "Facility - Civil / Concrete" -> "Facility", "E&I - Cable Tray" -> "E&I").
    // This mirrors how the Productivity view surfaces the service offering by prefix.
    //
    // Forward path (target: standard Excel map, coming in a couple days): populate
    // PHASE_SERVICE_OFFERING_MAP with an explicit phase-code -> service-offering lookup.
    // When a phase code is present in the map it takes precedence over the prefix parse,
    // so the two approaches can coexist during the cutover. See
    // docs/SERVICE_OFFERING_ROLLUP.md.
    const PHASE_SERVICE_OFFERING_MAP = {}
    const serviceOfferingFor = (phaseCode) => {
        if (PHASE_SERVICE_OFFERING_MAP[phaseCode]) return PHASE_SERVICE_OFFERING_MAP[phaseCode]
        const desc = (jobPhaseCodes && jobPhaseCodes[phaseCode]) || ''
        const idx = desc.indexOf(' - ')
        if (idx > 0) return desc.substring(0, idx).trim()
        // No recognisable prefix — keep the description (or phase code) as its own group
        // so it stays visible until the standard map assigns it a service offering.
        return desc.trim() || ('Phase ' + phaseCode)
    }

    const calculatePhaseAmounts = () => {
        const dayZeroValues = {}
        const coByPhase = {}
        const etcByPhase = {}
        const versionStart = versionInfo?.Version_Start_DateTime
        const inProjectWindow = (week, id) =>
            week && moment(week).isAfter(moment(versionStart).startOf('week')) &&
            moment(week).isBefore(moment(completionFor(id)).endOf('week'))

        if (jobUserData && jobUserData.length > 0) {
            jobUserData.forEach((d) => {
                // Day Zero Budget by phase
                if (d?.Forecast_Tab === 'Day Zero Budget' && d?.Cost_Code) {
                    const phase = d.Cost_Code
                    dayZeroValues[phase] = (dayZeroValues[phase] || 0) + pNum(d.Value_Amount)
                }
                // Approved Change Order additions by phase
                if (d?.Forecast_Tab === 'Change Order' && d?.Cost_Code && (d?.Status || '') === 'Approved') {
                    const phase = d.Cost_Code
                    coByPhase[phase] = (coByPhase[phase] || 0) + pNum(d.Value_Amount)
                }
                // Per-phase ETC entries (user-typed)
                if (d?.Forecast_Field_Name === 'etc' && d?.Cost_Code) {
                    const phase = d.Cost_Code
                    etcByPhase[phase] = (etcByPhase[phase] || 0) + pNum(d.Value_Amount)
                }
                // Burn Tool Labor Phased — phase is in Forecast_Row_ID prefix
                if (d?.Forecast_Tab === 'Burn Tool Labor Phased' && d?.Forecast_Row_ID) {
                    const t = d.Forecast_Row_ID
                    const sep = t.includes('=') ? '=' : '*'
                    const idx = t.lastIndexOf(sep)
                    const week = idx >= 0 ? t.substring(idx + 1) : ''
                    const phase = idx >= 0 ? t.substring(0, idx) : ''
                    if (phase && inProjectWindow(week, t)) {
                        const h = pNum(d.Number_Hours || 0), r = pNum(d.Rate || 0), n = pNum(d.Number_Units || 0)
                        if (h && r && n) etcByPhase[phase] = (etcByPhase[phase] || 0) + h * r * n
                    }
                }
                // Burn Tool Equipment Phased — phase is on Cost_Code; week is in Forecast_Row_ID suffix
                if (d?.Forecast_Tab === 'Burn Tool Equipment Phased' && d?.Cost_Code && d?.Forecast_Row_ID) {
                    const t = d.Forecast_Row_ID
                    const sep = t.includes('=') ? '=' : '*'
                    const idx = t.lastIndexOf(sep)
                    const week = idx >= 0 ? t.substring(idx + 1) : ''
                    if (inProjectWindow(week, t)) {
                        const h = pNum(d.Number_Hours || 0), r = pNum(d.Rate || 0), n = pNum(d.Number_Units || 0)
                        if (h && r && n) {
                            const phase = d.Cost_Code
                            etcByPhase[phase] = (etcByPhase[phase] || 0) + h * r * n
                        }
                    }
                }
            })
        }

        // Get actual costs by phase
        const actualCosts = {}
        jobCostDetail?.forEach((row) => {
            if (row.Phase_Code && row.Cost_Type_Code >= '50000' && row.Cost_Type_Code <= '60000') {
                const phase = row.Phase_Code
                actualCosts[phase] = (actualCosts[phase] || 0) + row.Job_Cost
            }
        })

        // Get commitments by phase. PO_True_Open_Amount matches the LEMSO/resource
        // commitment computation; Amount-Billed undercounts retainage on some POs.
        const commitmentsByPhase = {}
        jobOpenCommitments?.forEach((row) => {
            if (row.Phase_Code) {
                const phase = row.Phase_Code
                commitmentsByPhase[phase] = (commitmentsByPhase[phase] || 0) + pNum(row.PO_True_Open_Amount)
            }
        })

        // ---- Labor: dollars/hours spent last week + hours remaining, by phase --------
        // Feeds the Service Offering panel, which mirrors the manual PSR "Labor over/under"
        // block (Dollars spent last week / Hours spent last week / Hours remaining).
        // "Last week" = the isoWeek (Mon–Sun) containing the most recent labor (51xxx) GL
        // posting, so the figures track the latest reported week without depending on the
        // version date. Labor = cost types 51000–51999.
        let maxLaborDate = null
        jobCostDetail?.forEach((row) => {
            if (row.Cost_Type_Code >= '51000' && row.Cost_Type_Code <= '51999' && row.GL_Date) {
                const m = moment(row.GL_Date)
                if (!maxLaborDate || m.isAfter(maxLaborDate)) maxLaborDate = m
            }
        })
        const lastWeekStart = maxLaborDate ? maxLaborDate.clone().startOf('isoWeek') : null
        const lastWeekEnd = maxLaborDate ? maxLaborDate.clone().endOf('isoWeek') : null

        const laborDollarsLastWeekByPhase = {}
        const laborHoursLastWeekByPhase = {}
        jobCostDetail?.forEach((row) => {
            if (!row.Phase_Code) return
            if (!(row.Cost_Type_Code >= '51000' && row.Cost_Type_Code <= '51999')) return
            if (!lastWeekStart || !row.GL_Date) return
            const d = moment(row.GL_Date)
            if (d.isBefore(lastWeekStart) || d.isAfter(lastWeekEnd)) return
            const phase = row.Phase_Code
            laborDollarsLastWeekByPhase[phase] = (laborDollarsLastWeekByPhase[phase] || 0) + pNum(row.Job_Cost)
            laborHoursLastWeekByPhase[phase] = (laborHoursLastWeekByPhase[phase] || 0) + pNum(row.Total_Hours)
        })

        // Remaining labor hours by phase from Burn Tool Labor Phased (hrs/week × crew, per
        // remaining week inside the project window). Mirrors the etcLaborHours calc used for
        // the labor % — but bucketed by phase. Non-phased burn labor carries no phase, so it
        // isn't attributed here (phased crew planning is where remaining hours live).
        const laborHoursRemainingByPhase = {}
        if (jobUserData && jobUserData.length > 0) {
            jobUserData.forEach((d) => {
                if (d?.Forecast_Tab === 'Burn Tool Labor Phased' && d?.Forecast_Row_ID) {
                    const t = d.Forecast_Row_ID
                    const sep = t.includes('=') ? '=' : '*'
                    const idx = t.lastIndexOf(sep)
                    const week = idx >= 0 ? t.substring(idx + 1) : ''
                    const phase = idx >= 0 ? t.substring(0, idx) : ''
                    if (phase && inProjectWindow(week, t)) {
                        const h = pNum(d.Number_Hours || 0), n = pNum(d.Number_Units || 0)
                        if (h && n) laborHoursRemainingByPhase[phase] = (laborHoursRemainingByPhase[phase] || 0) + h * n
                    }
                }
            })
        }

        // Combine all unique phases
        const allPhases = new Set([
            ...Object.keys(dayZeroValues),
            ...Object.keys(laborDollarsLastWeekByPhase),
            ...Object.keys(laborHoursRemainingByPhase),
            ...Object.keys(coByPhase),
            ...Object.keys(actualCosts),
            ...Object.keys(commitmentsByPhase),
            ...Object.keys(etcByPhase)
        ])

        const rows = []
        // Raw (unformatted) per-service-offering accumulators so the rollup totals stay
        // exact; each phase is also kept as an expandable subRow under its offering.
        const soBuckets = {}
        allPhases.forEach(phase => {
            if (phase && phase !== 'null' && phase !== 'undefined') {
                const dayZeroBudget = dayZeroValues[phase] || 0
                const approvedCOs = coByPhase[phase] || 0
                const budgetEAC = dayZeroBudget + approvedCOs
                const JTDActualCost = actualCosts[phase] || 0
                const committed = commitmentsByPhase[phase] || 0
                const ETC = etcByPhase[phase] || 0
                const EAC = JTDActualCost + committed + ETC
                const deltaEAC = budgetEAC - EAC
                const deltaZero = dayZeroBudget - EAC
                const phaseTitle = jobPhaseCodes[phase] ? phase + ' - ' + jobPhaseCodes[phase] : phase

                rows.push({
                    title: phaseTitle,
                    phaseCode: phase,
                    dayZeroBudget: formN(dayZeroBudget),
                    approvedCOs: formN(approvedCOs),
                    budgetEAC: formN(budgetEAC),
                    JTDActualCost: formN(JTDActualCost),
                    committed: formN(committed),
                    ETC: formN(ETC),
                    EAC: formN(EAC),
                    deltaEAC: formN(deltaEAC),
                    deltaZero: formN(deltaZero)
                })

                // Labor-only metrics for the Service Offering panel (mirrors the PSR block).
                const dollarsLastWeek = laborDollarsLastWeekByPhase[phase] || 0
                const hoursLastWeek = laborHoursLastWeekByPhase[phase] || 0
                const hoursRemaining = laborHoursRemainingByPhase[phase] || 0

                const so = serviceOfferingFor(phase)
                if (!soBuckets[so]) {
                    soBuckets[so] = { dayZeroBudget: 0, approvedCOs: 0, JTDActualCost: 0, committed: 0, ETC: 0, dollarsLastWeek: 0, hoursLastWeek: 0, hoursRemaining: 0, subRows: [] }
                }
                const b = soBuckets[so]
                b.dayZeroBudget += dayZeroBudget
                b.approvedCOs += approvedCOs
                b.JTDActualCost += JTDActualCost
                b.committed += committed
                b.ETC += ETC
                b.dollarsLastWeek += dollarsLastWeek
                b.hoursLastWeek += hoursLastWeek
                b.hoursRemaining += hoursRemaining
                b.subRows.push({
                    title: phaseTitle,
                    dayZeroBudget: formN(dayZeroBudget),
                    approvedCOs: formN(approvedCOs),
                    budgetEAC: formN(budgetEAC),
                    JTDActualCost: formN(JTDActualCost),
                    committed: formN(committed),
                    ETC: formN(ETC),
                    EAC: formN(EAC),
                    deltaEAC: formN(deltaEAC),
                    deltaZero: formN(deltaZero),
                    dollarsLastWeek: formN(dollarsLastWeek),
                    hoursLastWeek: formN(hoursLastWeek),
                    hoursRemaining: formN(hoursRemaining)
                })
            }
        })

        setPhaseRows(rows)

        // Roll the per-phase numbers up to service offering. Keep offerings alphabetical
        // for a stable order; each row expands to show its member phases. Offerings (and
        // member phases) with no labor activity are dropped — the panel only shows the
        // three labor columns, so an all-zero row is just noise.
        const totals = { dollarsLastWeek: 0, hoursLastWeek: 0, hoursRemaining: 0 }
        const soRows = Object.keys(soBuckets).sort().filter(so => {
            const b = soBuckets[so]
            return b.dollarsLastWeek || b.hoursLastWeek || b.hoursRemaining
        }).map(so => {
            const b = soBuckets[so]
            const budgetEAC = b.dayZeroBudget + b.approvedCOs
            const EAC = b.JTDActualCost + b.committed + b.ETC
            const deltaEAC = budgetEAC - EAC
            const deltaZero = b.dayZeroBudget - EAC
            totals.dollarsLastWeek += b.dollarsLastWeek
            totals.hoursLastWeek += b.hoursLastWeek
            totals.hoursRemaining += b.hoursRemaining
            return {
                title: so,
                weekField: 'so_' + so,
                dayZeroBudget: formN(b.dayZeroBudget),
                approvedCOs: formN(b.approvedCOs),
                budgetEAC: formN(budgetEAC),
                JTDActualCost: formN(b.JTDActualCost),
                committed: formN(b.committed),
                ETC: formN(b.ETC),
                EAC: formN(EAC),
                deltaEAC: formN(deltaEAC),
                deltaZero: formN(deltaZero),
                dollarsLastWeek: formN(b.dollarsLastWeek),
                hoursLastWeek: formN(b.hoursLastWeek),
                hoursRemaining: formN(b.hoursRemaining),
                subRows: b.subRows.filter(s => s.dollarsLastWeek || s.hoursLastWeek || s.hoursRemaining)
            }
        })
        setServiceOfferingRows(soRows)
        setServiceOfferingTotals({
            dollarsLastWeek: formN(totals.dollarsLastWeek),
            hoursLastWeek: formN(totals.hoursLastWeek),
            hoursRemaining: formN(totals.hoursRemaining)
        })
    }

    const calculateResourceAmounts = () => {
        // Canonical resource fields per category. Mirrors rentals.js / materials.js /
        // costHistoryDetail.js so JTD rows group the same way the dedicated pivot pages do.
        // Equipment: Rental_Equipment_Classification_Tier_Name (rental POs) ||
        //   Equipment_Classification_Tier_Name (cost detail).
        // Labor: Labor_Classification.
        // Materials/Other: Purchasing_Reporting_Code_1, fallback to its description.
        // Subcontractors: Purchasing_Reporting_Code_4, fallback to description.
        const codeFor = (row) => {
            const costType = row.Cost_Type_Code
            if (costType >= '51000' && costType <= '51999') {
                return row.Labor_Classification || row.Labor_Classification_Description || ''
            } else if (costType >= '52000' && costType <= '52999') {
                return row.Rental_Equipment_Classification_Tier_Name
                    || row.Equipment_Classification_Tier_Name
                    || row.Equipment_Classification_Tier_Name_Description
                    || ''
            } else if (costType >= '53000' && costType <= '53999') {
                return row.Purchasing_Reporting_Code_1 || row.Purchasing_Reporting_Code_1_Description || ''
            } else if (costType >= '54000' && costType <= '54999') {
                return row.Purchasing_Reporting_Code_4 || row.Purchasing_Reporting_Code_4_Description || ''
            } else if (costType >= '55000' && costType <= '58000') {
                return row.Purchasing_Reporting_Code_1 || row.Purchasing_Reporting_Code_1_Description || ''
            }
            return ''
        }

        const getCostCategory = (costType) => {
            if (costType >= '51000' && costType <= '51999') return 'Labor'
            if (costType >= '52000' && costType <= '52999') return 'Equipment'
            if (costType >= '53000' && costType <= '53999') return 'Materials'
            if (costType >= '54000' && costType <= '54999') return 'Subcontractors'
            if (costType >= '55000' && costType <= '58000') return 'Other Expenses'
            return null
        }

        const unknownLabel = {
            'Labor': 'Unknown Labor',
            'Equipment': 'Unknown Equipment',
            'Materials': 'Unknown Materials',
            'Subcontractors': 'Unknown Subcontractor',
            'Other Expenses': 'Unknown Other',
        }

        // Vendor+PO → resource code map. jobOpenCommitments tend to carry the resource
        // code reliably; jobCostDetail rows often arrive without it. Materials.js / rentals.js
        // do the same backfill so legacy posted costs land in the right bucket.
        const vendorPoToCode = {}
            ; (jobOpenCommitments || []).forEach(r => {
                const vendor = r.Supplier_Name || r.Supplier_AB_Name || ''
                const po = r.PO_Number || ''
                const c = codeFor(r)
                if (vendor && po && c && !vendorPoToCode[vendor + '^' + po]) {
                    vendorPoToCode[vendor + '^' + po] = c
                }
            })

        const resolveCode = (row, category) => {
            let c = codeFor(row)
            if (!c && row.Supplier_Name && row.PO_Number) {
                c = vendorPoToCode[row.Supplier_Name + '^' + row.PO_Number] || ''
            }
            return c || unknownLabel[category]
        }

        // Parse the formatted strings used by LEMSO category state values
        // (parens for negatives, commas as thousands separators).
        const parseFmt = (s) => pNum(s ? String(s).replace(/\(/g, '-').replace(/\)|,/g, '') : 0)

        const categoryConfig = [
            { name: 'Labor', weekField: 'labor', dayZero: dayZeroBudgetLabor, etc: etcLabor, co: coLaborValue },
            { name: 'Equipment', weekField: 'equipment', dayZero: dayZeroBudgetEquipment, etc: etcEquipment, co: coEquipmentValue },
            { name: 'Materials', weekField: 'materials', dayZero: dayZeroBudgetMaterials, etc: etcMaterials, co: coMaterialsValue },
            { name: 'Subcontractors', weekField: 'subcontractors', dayZero: dayZeroBudgetSubcontractors, etc: etcSubcontractors, co: coSubcontractorsValue },
            { name: 'Other Expenses', weekField: 'other', dayZero: dayZeroBudgetOtherExpenses, etc: etcOtherExpenses, co: coOtherValue },
        ]

        // Per-category, per-resource JTD + committed buckets sourced from the
        // raw cost detail / open commitment rows.
        const subBuckets = {
            'Labor': {},
            'Equipment': {},
            'Materials': {},
            'Subcontractors': {},
            'Other Expenses': {}
        }

        jobCostDetail?.forEach((row) => {
            const category = getCostCategory(row.Cost_Type_Code)
            if (!category) return
            const resourceCode = resolveCode(row, category)
            if (!subBuckets[category][resourceCode]) {
                subBuckets[category][resourceCode] = { JTDActualCost: 0, committed: 0 }
            }
            subBuckets[category][resourceCode].JTDActualCost += row.Job_Cost || 0
        })

        jobOpenCommitments?.forEach((row) => {
            const category = getCostCategory(row.Cost_Type_Code)
            if (!category) return
            const resourceCode = resolveCode(row, category)
            if (!subBuckets[category][resourceCode]) {
                subBuckets[category][resourceCode] = { JTDActualCost: 0, committed: 0 }
            }
            subBuckets[category][resourceCode].committed += row.PO_True_Open_Amount || 0
        })

        const rows = []
        categoryConfig.forEach(cfg => {
            const dayZeroBudget = parseFmt(cfg.dayZero)
            const approvedCOs = parseFmt(cfg.co)
            const ETC = parseFmt(cfg.etc)
            const budgetEAC = dayZeroBudget + approvedCOs

            const codes = Object.keys(subBuckets[cfg.name])
            const subRows = []
            let totalJTD = 0
            let totalCommitted = 0

            codes.forEach(code => {
                const b = subBuckets[cfg.name][code]
                const JTDActualCost = b.JTDActualCost || 0
                const committed = b.committed || 0
                totalJTD += JTDActualCost
                totalCommitted += committed
                if (!JTDActualCost && !committed) return
                subRows.push({
                    title: code,
                    dayZeroBudget: '',
                    approvedCOs: '',
                    budgetEAC: '',
                    JTDActualCost: formN(JTDActualCost),
                    committed: formN(committed),
                    ETC: '',
                    EAC: '',
                    deltaEAC: '',
                    deltaZero: ''
                })
            })

            // Skip empty categories (no budget, no CO, no ETC, no actuals).
            if (
                dayZeroBudget === 0 && approvedCOs === 0 && ETC === 0 &&
                totalJTD === 0 && totalCommitted === 0
            ) return

            const EAC = totalJTD + totalCommitted + ETC
            const deltaEAC = budgetEAC - EAC
            const deltaZero = dayZeroBudget - EAC

            rows.push({
                title: cfg.name,
                weekField: cfg.weekField,
                dayZeroBudget: formN(dayZeroBudget),
                approvedCOs: formN(approvedCOs),
                budgetEAC: formN(budgetEAC),
                JTDActualCost: formN(totalJTD),
                committed: formN(totalCommitted),
                ETC: formN(ETC),
                EAC: formN(EAC),
                deltaEAC: formN(deltaEAC),
                deltaZero: formN(deltaZero),
                subRows: subRows
            })
        })

        setResourceRows(rows)
    }

    // Prepare variance graph data
    const varianceGraphData = useMemo(() => {
        if (!varianceHistory || varianceHistory.length < 1) return null;

        // Calculate GM for each version and filter out zero values
        const gmData = varianceHistory.map(version => {
            const wipTotal = pNum(version.labor) + pNum(version.equipment) + pNum(version.materials) + 
                           pNum(version.subcontractors) + pNum(version.other) + pNum(version.contingency);
            const gm = pNum(version.revenue) - wipTotal - pNum(version.overhead);
            
            return {
                date: version.versionDate,
                versionName: version.versionName,
                gm: gm,
                gmPercent: version.gmPercent
            };
        }).filter(v => v.gm !== 0);

        // Check if current version is newer than the last variance history entry
        const lastHistoryDate = gmData.length > 0 ? moment(gmData[gmData.length - 1].date) : null;
        const currentVersionDate = versionInfo?.Version_Start_DateTime ? moment(versionInfo.Version_Start_DateTime) : null;
        console.log('compare dates', { a: currentVersionDate?.format(), b: lastHistoryDate?.format() });
        // Add current version GM if it's after the last history date
        if (currentVersionDate && lastHistoryDate && currentVersionDate.isAfter(lastHistoryDate) && eacGM) {
            const currentGM = pNum(eacGM ? eacGM.replace(/\(/g, '-').replace(/\)|,/g, '') : 0);
            gmData.push({
                date: currentVersionDate.format('YYYY-MM-DD'),
                versionName: 'Current',
                gm: currentGM,
                gmPercent: null
            });
        }

        return {
            labels: gmData.map(v => moment(v.date).format('MM/DD/YY')),
            datasets: [
                {
                    label: 'Gross Margin ($)',
                    data: gmData.map(v => v.gm),
                    borderColor: SERIES[0],
                    backgroundColor: alpha(SERIES[0], 0.1),
                    borderWidth: 3,
                    fill: true,
                    tension: 0.4,
                    pointRadius: 5,
                    pointHoverRadius: 7,
                    pointBackgroundColor: SERIES[0],
                    pointBorderColor: '#fff',
                    pointBorderWidth: 2,
                    yAxisID: 'y'
                }
            ]
        };
    }, [varianceHistory, selectedWIP, eacGM]);

    const varianceGraphOptions = {
        responsive: true,
        maintainAspectRatio: false,
        interaction: {
            mode: 'index',
            intersect: false,
        },
        plugins: {
            legend: {
                display: true,
                position: 'top',
            },
            title: {
                display: true,
                text: 'Gross Margin Over Time - WIP Versions',
                font: { size: 16, weight: 'bold' }
            },
            tooltip: {
                callbacks: {
                    label: function(context) {
                        const value = context.parsed.y;
                        return 'Gross Margin: $' + value.toLocaleString(undefined, { maximumFractionDigits: 0 });
                    }
                }
            }
        },
        scales: {
            y: {
                type: 'linear',
                display: true,
                position: 'left',
                title: {
                    display: true,
                    text: 'Gross Margin ($)',
                    font: { size: 14 }
                },
                ticks: {
                    callback: function(value) {
                        return '$' + (value / 1000).toFixed(0) + 'K';
                    }
                },
                grid: {
                    color: 'rgba(0, 0, 0, 0.1)',
                    lineWidth: 1
                }
            },
            x: {
                title: {
                    display: true,
                    text: 'WIP Version Date',
                    font: { size: 14 }
                },
                grid: {
                    display: false
                }
            }
        }
    };

    // Export variance data to CSV
    const exportVarianceData = () => {
        if (!varianceHistory || varianceHistory.length === 0) {
            alert('No variance history data available to export');
            return;
        }

        // Prepare CSV header
        const headers = [
            'Version Date',
            'Version Name',
            'Revenue ($)',
            'Labor ($)',
            'Equipment ($)',
            'Materials ($)',
            'Subcontractors ($)',
            'Other Expenses ($)',
            'Overhead ($)',
            'Contingency ($)',
            'Total Costs ($)',
            'Gross Margin ($)',
            'GM %'
        ];

        // Prepare CSV rows
        const rows = varianceHistory.map(version => [
            moment(version.versionDate).format('YYYY-MM-DD'),
            version.versionName || '',
            fNum(pNum(version.revenue)),
            fNum(pNum(version.labor)),
            fNum(pNum(version.equipment)),
            fNum(pNum(version.materials)),
            fNum(pNum(version.subcontractors)),
            fNum(pNum(version.other)),
            fNum(pNum(version.overhead)),
            fNum(pNum(version.contingency)),
            fNum(pNum(version.labor) + pNum(version.equipment) + pNum(version.materials) + pNum(version.subcontractors) + pNum(version.other) + pNum(version.overhead) + pNum(version.contingency)),
            fNum(pNum(version.gm) || (pNum(version.revenue) - (pNum(version.labor) + pNum(version.equipment) + pNum(version.materials) + pNum(version.subcontractors) + pNum(version.other) + pNum(version.overhead) + pNum(version.contingency)))),
            version.gmPercent ? (pNum(version.gmPercent) * 100).toFixed(2) + '%' : ''
        ]);

        // Add hours section if jobUserData exists
        let hoursCSV = '\n\nHOURS DATA BY DISCIPLINE\n';
        hoursCSV += 'Discipline,Estimated Hours,Actual Hours,Budget Hours,Productivity Factor (PF)\n';

        if (jobUserData && jobUserData.length > 0) {
            const disciplineMap = {};
            
            jobUserData.forEach(record => {
                const discipline = record.discipline || 'Unknown';
                if (!disciplineMap[discipline]) {
                    disciplineMap[discipline] = {
                        estimatedHours: 0,
                        actualHours: 0,
                        budgetHours: 0
                    };
                }
                
                disciplineMap[discipline].estimatedHours += pNum(record.ETC_Hours || 0);
                disciplineMap[discipline].actualHours += pNum(record.Actual_Hours || 0);
                disciplineMap[discipline].budgetHours += pNum(record.Budget_Hours || record.Day_Zero_Hours || 0);
            });

            Object.keys(disciplineMap).forEach(discipline => {
                const data = disciplineMap[discipline];
                const pf = data.actualHours > 0 ? (data.budgetHours / data.actualHours).toFixed(3) : '0';
                hoursCSV += `${discipline},${fNum(data.estimatedHours)},${fNum(data.actualHours)},${fNum(data.budgetHours)},${pf}\n`;
            });
        }

        // Create CSV content
        const csvContent = [headers.join(','), ...rows.map(row => row.map(cell => `"${cell}"`).join(','))].join('\n') + hoursCSV;

        // Download CSV
        const element = document.createElement('a');
        element.setAttribute('href', 'data:text/csv;charset=utf-8,' + encodeURIComponent(csvContent));
        element.setAttribute('download', `variance_export_${selectedJob}_${moment().format('YYYY-MM-DD_HHmmss')}.csv`);
        element.style.display = 'none';
        document.body.appendChild(element);
        element.click();
        document.body.removeChild(element);
    };

    return (
        <View style={{ flexDirection: 'row' }}>
            <View ref={forecastRef} style={{ marginLeft: 30 }}>
                <View style={{ marginRight: 'auto' }}>
                    {/* Variance History Graph */}
                    {/* {!a.photo && varianceGraphData && (
                        <View>
                            <View style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: 10 }}>
                                <Pressable
                                    style={{
                                        backgroundColor: '#4CAF50',
                                        borderRadius: 6,
                                        padding: 8,
                                        paddingHorizontal: 16,
                                        alignItems: 'center',
                                        width: 'fit-content',
                                        marginLeft: 'auto'
                                    }}
                                    onPress={exportVarianceData}
                                >
                                    <Text style={{ color: 'white', fontWeight: 'bold', fontSize: 12 }}>Export Variance Data</Text>
                                </Pressable>
                            </View>
                            <View style={{ backgroundColor: 'white', borderRadius: 5, padding: 20, marginTop: 0, marginBottom: 20, height: 400, shadowColor: '#000', shadowOffset: { width: 0, height: 2 }, shadowOpacity: 0.1, shadowRadius: 4, elevation: 3 }}>
                                <Line data={varianceGraphData} options={varianceGraphOptions} />
                            </View>
                        </View>
                    )} */}
                    
                    <View style={{ backgroundColor: 'white', borderRadius: 5, padding: 20, paddingLeft: 0, marginTop: photo ? 0 : 30, position: 'relative', shadowColor: '#000', shadowOffset: { width: 0, height: 2 }, shadowOpacity: 0.1, shadowRadius: 4, elevation: 3 }}>
                        {!a.photo ? <View style={{ flexDirection: 'row', borderRadius: 5, position: 'absolute', top: 20, left: 30 }}>
                            <Pressable
                                style={{
                                    backgroundColor: pressed === 'LEMSO' ? '#e0e0e0' : 'white',
                                    borderRadius: 6,
                                    padding: 6,
                                    paddingHorizontal: 16,
                                    alignItems: 'center',
                                }}
                                onPress={() => setPressed('LEMSO')}
                            >
                                <Text style={{ color: '#192440', fontWeight: pressed === 'LEMSO' ? 'bold' : 'normal', fontSize: 10 }}>LEMSO</Text>
                            </Pressable>
                            <Pressable
                                style={{
                                    backgroundColor: pressed === 'Phases' ? '#e0e0e0' : 'white',
                                    borderRadius: 6,
                                    padding: 6,
                                    paddingHorizontal: 16,
                                    alignItems: 'center',
                                }}
                                onPress={() => setPressed('Phases')}
                            >
                                <Text style={{ color: '#192440', fontWeight: pressed === 'Phases' ? 'bold' : 'normal', fontSize: 10 }}>Phases</Text>
                            </Pressable>
                            <Pressable
                                style={{
                                    backgroundColor: pressed === 'Resource' ? '#e0e0e0' : 'white',
                                    padding: 6,
                                    borderRadius: 6,
                                    paddingHorizontal: 16,
                                    alignItems: 'center',
                                }}
                                onPress={() => setPressed('Resource')}
                            >
                                <Text style={{ color: '#192440', fontWeight: pressed === 'Resource' ? 'bold' : 'normal', fontSize: 10 }}>Resource</Text>
                            </Pressable>
                            {isParentJob && (
                                <Pressable
                                    disabled={groupLoading}
                                    style={{
                                        backgroundColor: showGroup ? '#192440' : 'white',
                                        borderWidth: 1,
                                        borderColor: '#192440',
                                        borderRadius: 6,
                                        padding: 6,
                                        paddingLeft: 10,
                                        paddingRight: 10,
                                        marginLeft: 8,
                                        flexDirection: 'row',
                                        alignItems: 'center',
                                        opacity: groupLoading ? 0.6 : 1,
                                    }}
                                    onPress={() => { if (!groupLoading) setShowGroup(g => !g) }}
                                    title={(() => {
                                        const idList = childJobIds.length ? `\nLinked BU_IDs:\n  ${childJobIds.join('\n  ')}` : ''
                                        if (groupLoading) return `Loading ${childJobIds.length} linked job${childJobIds.length === 1 ? '' : 's'}…${idList}`
                                        if (showGroup) return `Showing combined values for parent + ${childJobIds.length} child job${childJobIds.length === 1 ? '' : 's'}${idList}`
                                        return `Combine parent with ${childJobIds.length} linked job${childJobIds.length === 1 ? '' : 's'}${idList}`
                                    })()}
                                >
                                    {groupLoading && (
                                        <ActivityIndicator size={12} color={showGroup ? 'white' : '#192440'} style={{ marginRight: 6 }} />
                                    )}
                                    <Text style={{ color: showGroup ? 'white' : '#192440', fontWeight: 'bold', fontSize: 10 }}>
                                        {groupLoading ? 'Loading…' : showGroup ? `Group ${groupMemberIds.length}` : `+ Group (${childJobIds.length})`}
                                    </Text>
                                </Pressable>
                            )}
                        </View> : null}
                        <View style={s.container}>
                            <Text style={{ width: 250, minWidth: 250 }}>
                            </Text>
                            <Text style={[s.spanT, { fontSize: 10 }]}>
                                K2 Budget
                            </Text>
                            <Text style={[s.spanT, { fontSize: 10 }]}>
                                Bid Budget
                            </Text>
                            <Text style={[s.spanT, { fontSize: 10 }]}>
                                Approved CO's
                            </Text>
                            <Text style={[s.spanT, { fontSize: 10 }]}>
                                Current Budget
                            </Text>
                            <View style={{ width: 50 }}></View>
                            <Text style={[s.spanT, { fontSize: 10 }]}>
                                JTD Actual Cost
                            </Text>
                            <Text style={[s.spanT, { fontSize: 10 }]}>
                                Committed Costs
                            </Text>
                            <View style={{ width: 50 }}></View>
                            <Text style={[s.spanT, { fontSize: 10 }]}>
                                Estimate To Complete (ETC)
                            </Text>
                            <Text style={[s.spanT, { fontSize: 10 }]}>
                                Estimate At Completion (EAC)
                            </Text>
                            <Text style={[s.spanT, { marginLeft: 50, fontSize: 10 }]}>
                                Delta from Budget EAC
                            </Text>
                            <Text style={[s.spanT, { fontSize: 10 }]}>
                                Delta from Bid Budget
                            </Text>
                            <Text style={[s.spanT, { fontSize: 10 }]}>
                                Delta from Prev WIP
                            </Text>
                            {!photo && varianceWeeks.map((guid, wi) => (
                                <View key={guid} style={[s.spanT, { backgroundColor: '#eef2ff', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 2, position: 'relative' }]}>
                                    <View style={{ flexDirection: 'row', alignItems: 'center', gap: 2 }}>
                                        <Pressable onPress={() => setOpenWeekDropdown(openWeekDropdown === wi ? null : wi)} style={{ cursor: 'pointer', flexDirection: 'row', alignItems: 'center', gap: 2 }}>
                                            <Text style={{ color: '#4338ca', fontSize: 10, fontWeight: '700' }}>{getWeekLabel(guid)}</Text>
                                            <Text style={{ fontSize: 8, color: '#818cf8' }}>▼</Text>
                                        </Pressable>
                                        {weekLoading[guid] ? <Text style={{ fontSize: 10, color: '#818cf8' }}>⟳</Text> : null}
                                        <Pressable onPress={() => removeWeekColumn(guid)} style={{ cursor: 'pointer', marginLeft: 2 }}>
                                            <Text style={{ fontSize: 11, color: '#a5b4fc', fontWeight: 'bold' }}>×</Text>
                                        </Pressable>
                                    </View>
                                    <View style={{ flexDirection: 'row', alignItems: 'center', gap: 2 }}>
                                        <Pressable onPress={() => setWeekDisplayMode(prev => ({ ...prev, [guid]: 'total' }))} style={{ cursor: 'pointer', backgroundColor: (weekDisplayMode[guid] || 'var') === 'total' ? '#4338ca' : '#e0e7ff', borderRadius: 3, padding: '1px 4px' }}>
                                            <Text style={{ fontSize: 8, fontWeight: '700', color: (weekDisplayMode[guid] || 'var') === 'total' ? 'white' : '#6366f1' }}>TOT</Text>
                                        </Pressable>
                                        <Pressable onPress={() => setWeekDisplayMode(prev => ({ ...prev, [guid]: 'var' }))} style={{ cursor: 'pointer', backgroundColor: (weekDisplayMode[guid] || 'var') === 'var' ? '#4338ca' : '#e0e7ff', borderRadius: 3, padding: '1px 4px' }}>
                                            <Text style={{ fontSize: 8, fontWeight: '700', color: (weekDisplayMode[guid] || 'var') === 'var' ? 'white' : '#6366f1' }}>VAR</Text>
                                        </Pressable>
                                    </View>
                                    {openWeekDropdown === wi && (
                                        <View style={{ position: 'absolute', top: '100%', left: 0, zIndex: 100, backgroundColor: 'white', border: '1px solid #e2e8f0', borderRadius: 6, shadowColor: '#000', shadowOffset: { width: 0, height: 2 }, shadowOpacity: 0.15, shadowRadius: 6, maxHeight: 200, overflowY: 'auto', minWidth: 160 }}>
                                            {versionOptions.filter(v => !varianceWeeks.includes(v.guid) || v.guid === guid).map(v => (
                                                <Pressable key={v.guid} onPress={() => changeWeekVersion(guid, v.guid)} style={{ padding: '5px 10px', cursor: 'pointer', borderBottom: '1px solid #f1f5f9', backgroundColor: v.guid === guid ? '#eef2ff' : 'white' }}>
                                                    <Text style={{ fontSize: 11, color: '#334155' }}>{v.label}</Text>
                                                </Pressable>
                                            ))}
                                        </View>
                                    )}
                                </View>
                            ))}
                            {versionOptions.filter(v => !varianceWeeks.includes(v.guid)).length > 0 && !photo && (
                                <Pressable onPress={addWeekColumn} style={[s.spanT, { cursor: 'pointer', backgroundColor: '#eff6ff', borderRadius: 4, border: '1px solid #bfdbfe', alignItems: 'center', justifyContent: 'center' }]}>
                                    <Text style={{ fontSize: 10, color: '#2563eb', fontWeight: '600' }}>+ Week</Text>
                                </Pressable>
                            )}
                        </View>
                        <Row title={"Contract Amount"} weekField="contract" buId={selectedJob} k2Budget={k2BudgetContract} dayZeroBudget={dayZeroBudgetContract} approvedCOs={coContractValue} budgetEAC={budgetEACContract} EAC={budgetEACContract} jobWithoutInternalSubs={budgetDeltaWip} deltaEAC={'-'} deltaZero={coContractValue} deltaWip={budgetDeltaWip != null ? fNum(pNum(budgetEACContract) - pNum(budgetDeltaWip), 1) : ''}></Row>
                        <View style={{ width: '100%', height: 25 }}></View>

                        {/* LEMSO Rows */}
                        {pressed === 'LEMSO' && <Row title={"Labor"} weekField="labor" expands="true" buId={selectedJob} k2Budget={k2BudgetLabor} subRows={laborSubRows} approvedCOs={coLaborValue} dayZeroBudget={dayZeroBudgetLabor} budgetEAC={budgetEACLabor} JTDActualCost={JTDLabor} ETC={etcLabor} EAC={eacLabor} committed={laborCommitments} deltaEAC={deltaEACLabor} deltaZero={deltaZeroLabor} deltaWip={laborDeltaWip ? fNum(pNum(eacLabor) - pNum(laborDeltaWip), 1) : ''}></Row>}
                        {pressed === 'LEMSO' && <Row title={"Equipment"} weekField="equipment" expands="true" buId={selectedJob} k2Budget={k2BudgetEquipment} subRows={equipmentSubRows} approvedCOs={coEquipmentValue} dayZeroBudget={dayZeroBudgetEquipment} budgetEAC={budgetEACEquipment} ETC={etcEquipment} EAC={eacEquipment} JTDActualCost={JTDEquipment} committed={equipmentCommitments} deltaEAC={deltaEACEquipment} deltaZero={deltaZeroEquipment} deltaWip={equipmentDeltaWip ? fNum(pNum(eacEquipment) - pNum(equipmentDeltaWip), 1) : ''}></Row>}
                        {pressed === 'LEMSO' && <Row title={"Materials"} weekField="materials" expands="true" buId={selectedJob} k2Budget={k2BudgetMaterials} subRows={materialsSubRows} approvedCOs={coMaterialsValue} dayZeroBudget={dayZeroBudgetMaterials} budgetEAC={budgetEACMaterials} ETC={etcMaterials} JTDActualCost={JTDMaterials} committed={materialsCommitments} EAC={eacMaterials} deltaEAC={deltaEACMaterials} deltaZero={deltaZeroMaterials} deltaWip={materialsDeltaWip ? fNum(pNum(eacMaterials) - pNum(materialsDeltaWip), 1) : ''}></Row>}
                        {pressed === 'LEMSO' && <Row title={"Subcontractors"} weekField="subcontractors" expands="true" buId={selectedJob} k2Budget={k2BudgetSubcontractors} subRows={subcontractorsSubRows} approvedCOs={coSubcontractorsValue} dayZeroBudget={dayZeroBudgetSubcontractors} budgetEAC={budgetEACSubcontractors} JTDActualCost={JTDSubcontractors} ETC={etcSubcontractors} EAC={eacSubcontractors} committed={subcontractorsCommitments} jobWithoutInternalSubs={fNum(-1 * pNum(eacExternalSubcontractors), 1)} deltaEAC={deltaEACSubcontractors} deltaZero={deltaZeroSubcontractors} deltaWip={subcontractorsDeltaWip ? fNum(pNum(eacSubcontractors) - pNum(subcontractorsDeltaWip), 1) : ''}></Row>}
                        {pressed === 'LEMSO' && <Row title={"Other Expenses"} weekField="other" expands="true" buId={selectedJob} k2Budget={k2BudgetOther} ohPercent={ohPercent} subRows={otherExpensesSubRows} ETC={etcOtherExpenses} EAC={eacOtherExpenses} approvedCOs={coOtherValue} dayZeroBudget={dayZeroBudgetOtherExpenses} budgetEAC={budgetEACOtherExpenses} JTDActualCost={JTDOtherExpenses} committed={otherExpensesCommitments} deltaEAC={deltaEACOtherExpenses} deltaZero={deltaZeroOtherExpenses} deltaWip={otherDeltaWip ? fNum(pNum(eacOtherExpenses) - pNum(otherDeltaWip), 1) : ''}></Row>}

                        {/* Phase Rows */}
                        {pressed === 'Phases' && phaseRows.map((row, idx) => (
                            <Row key={idx} title={row.title} titleFontSize={12} weekField={'phase_' + row.phaseCode} buId={selectedJob} dayZeroBudget={row.dayZeroBudget} approvedCOs={row.approvedCOs} budgetEAC={row.budgetEAC} JTDActualCost={row.JTDActualCost} committed={row.committed} ETC={row.ETC} EAC={row.EAC} deltaEAC={row.deltaEAC} deltaZero={row.deltaZero}></Row>
                        ))}

                        {/* Resource Rows */}
                        {pressed === 'Resource' && resourceRows.map((row, idx) => (
                            <Row key={idx} expands="true" title={row.title} weekField={row.weekField} subRows={row.subRows} buId={selectedJob} dayZeroBudget={row.dayZeroBudget} approvedCOs={row.approvedCOs} budgetEAC={row.budgetEAC} JTDActualCost={row.JTDActualCost} committed={row.committed} ETC={row.ETC} EAC={row.EAC} deltaEAC={row.deltaEAC} deltaZero={row.deltaZero}></Row>
                        ))}


                        <Row title={"Contingency"} weekField="contingency" buId={selectedJob} contPercent={contPercent} contBudgetPercent={contBudgetPercent} contRows={true} k2Budget={k2BudgetContingency} dayZeroBudget={dayZeroBudgetContingency} budgetEAC={budgetEACContingency} approvedCOs={coContingencyValue} ETC={etcContigency} EAC={etcContigency} deltaEAC={deltaEACContingency} deltaZero={deltaZeroContingency} deltaWip={fNum(pNum(etcContigency) - pNum(contingencyDeltaWip), 1)}></Row>
                        <Row title={"Total Costs"} weekField="totalCosts" buId={selectedJob} dayZeroBudget={dayZeroBudgetTotalCosts} approvedCOs={coTotalValue} k2Budget={k2BudgetTotalCosts} budgetEAC={budgetEACTotalCosts} JTDActualCost={JTDTotalCosts} committed={totalCommitments} ETC={etcTotal} EAC={eacTotal} /*jobWithoutInternalSubs={interSubTotal}*/ deltaEAC={deltaEACTotalCosts} deltaZero={deltaZeroTotalCosts} deltaWip={laborDeltaWip || equipmentDeltaWip || materialsDeltaWip || subcontractorsDeltaWip || otherDeltaWip || contingencyDeltaWip ? fNum(pNum(eacTotal) - (pNum(laborDeltaWip) + pNum(equipmentDeltaWip) + pNum(materialsDeltaWip) + pNum(subcontractorsDeltaWip) + pNum(otherDeltaWip) + pNum(contingencyDeltaWip)), 1) : ''}></Row>
                        <div style={{ width: '100%', height: 30, borderBottomWidth: 3, borderColor: '#F9F8FB' }}></div>
                        <Row title={"Job Profit"} weekField="jobProfit" buId={selectedJob} dayZeroBudget={dayZeroBudgetJobProfit} approvedCOs={coTotalProfit} k2Budget={k2BudgetJobProfit} budgetEAC={budgetEACJobProfit} EAC={eacTotalProfit} /*jobWithoutInternalSubs={interSubTotalProfit}*/ deltaEAC={deltaEACJobProfit} deltaZero={deltaZeroJobProfit} deltaWip={laborDeltaWip || equipmentDeltaWip || materialsDeltaWip || subcontractorsDeltaWip || otherDeltaWip || contingencyDeltaWip ? fNum(pNum(eacTotalProfit) - (pNum(budgetDeltaWip) - pNum(laborDeltaWip) - pNum(equipmentDeltaWip) - pNum(materialsDeltaWip) - pNum(subcontractorsDeltaWip) - pNum(otherDeltaWip) - pNum(contingencyDeltaWip)), 1) : ''}></Row>
                        <Row title={"JP %"} weekField="jpPercent" buId={selectedJob} dayZeroBudget={dayZeroBudgetJP} approvedCOs={coTotalProfitPercent} k2Budget={k2BudgetJP} budgetEAC={budgetEACJP} EAC={eacTotalProfitPercent} /*jobWithoutInternalSubs={interSubTotalProfitPercent}*/ deltaEAC={deltaEACJP} deltaZero={deltaZeroJP} deltaWip={percentDeltaWip} ></Row>
                        <div style={{ width: '100%', height: 30, borderBottomWidth: 3, borderColor: '#F9F8FB' }}></div>
                        <Row title={"OH Allocation"} weekField="overhead" ohPercent={ohPercent} otherRows="true" costDate={costDate} actualCostOH={JTDOH} k2Budget={k2BudgetOH} afterCostActual={afterCostActual} afterCostOHEst={afterCostOHEst} buId={selectedJob} dayZeroBudget={dayZeroBudgetOH} approvedCOs={coOHAllocation} budgetEAC={budgetEACOH} JTDActualCost={JTDOH} committed={ohCommitments} ETC={etcOHAllocation} EAC={eacOHAllocation} /*jobWithoutInternalSubs={interSubOHAllocation}*/ deltaEAC={deltaEACOH} deltaZero={deltaZeroOH} deltaWip={overheadDeltaWip ? fNum(pNum(eacOHAllocation) - pNum(overheadDeltaWip), 1) : ''}></Row>
                        <Row title={"Gross Margin"} weekField="gm" buId={selectedJob} dayZeroBudget={dayZeroBudgetGM} approvedCOs={coGM} k2Budget={k2BudgetGM} budgetEAC={budgetEACGM} EAC={eacGM} /*jobWithoutInternalSubs={interSubGM}*/ deltaEAC={deltaEACGM} deltaZero={deltaZeroGM} deltaWip={grossMarginDeltaWip}></Row>
                        <Row title={"GM %"} weekField="gmPercent" buId={selectedJob} dayZeroBudget={dayZeroBudgetGMP} approvedCOs={coGMP} k2Budget={k2BudgetGMP} budgetEAC={budgetEACGMP} EAC={eacGMP} /*jobWithoutInternalSubs={interSubGMP}*/ deltaEAC={deltaEACGMP} deltaZero={deltaZeroGMP} deltaWip={grossMarginDeltaWipPercent}></Row>
                    </View>
                    <View style={{ flexDirection: 'row', marginTop: photo ? 0 : 10 }}>
                        <View style={{ flex: 1, margin: photo ? 0 : 20, marginBottom: photo ? 0 : 20, marginLeft: 0, backgroundColor: 'white', borderRadius: 5, padding: 20, shadowColor: '#000', shadowOffset: { width: 0, height: 2 }, shadowOpacity: 0.1, shadowRadius: 4, elevation: 3 }}>
                            <View style={{ flexDirection: 'row', marginBottom: 10, justifyContent: 'flex-end' }}>
                                <Text style={{ textAlign: 'right', fontSize: 14, fontWeight: '500', marginRight: 40 }}>Prev WIP</Text>
                                <Text style={{ textAlign: 'right', fontSize: 14, fontWeight: '500' }}>% Complete</Text>
                            </View>
                            <View style={{ flexDirection: 'row' }}>
                                <Text style={{ flex: 1, textAlign: 'left', fontSize: 14 }}>Costs</Text>
                                <Text style={{ flex: 1, textAlign: 'right', fontSize: 14 }}>{costPercent}</Text>
                            </View>
                            <View style={{ flexDirection: 'row' }}>
                                <Text style={{ flex: 1, textAlign: 'left', fontSize: 14 }}>Labor</Text>
                                <Text style={{ flex: 1, textAlign: 'right', fontSize: 14 }}>{laborPercent}%</Text>
                            </View>
                            <View style={{ flexDirection: 'row' }}>
                                <Text style={{ flex: 1, textAlign: 'left', fontSize: 14 }}>Physical</Text>
                                <Text style={{ flex: 1, textAlign: 'right', fontSize: 14, paddingRight: 40 }}>{wipPhysicalComplete ? wipPhysicalComplete + '%' : ''}</Text>
                                <View style={{ flexDirection: 'row', position: 'relative' }}>
                                    <View style={{ width: 3, height: 20, backgroundColor: 'grey', left: 5, top: 0, position: 'absolute' }}></View>
                                    <TextInput tabIndex="5" style={{ textAlign: 'right', fontSize: 14, width: 72, height: 20, padding: 0, borderWidth: 0 }}
                                        value={physicalComplete}
                                        onChangeText={(a) => {
                                            setPhysicalComplete(a)
                                            handleInputChange(a, 'physicalComplete')
                                        }} />
                                    <Text style={{ fontSize: 14, width: 15 }}>%</Text>
                                </View>
                            </View>
                            <View style={{ flexDirection: 'row' }}>
                                <Text style={{ flex: 1, textAlign: 'left', fontSize: 14 }}>Billings</Text>
                                <Text style={{ flex: 1, textAlign: 'right', fontSize: 14 }}>{billingPercent}</Text>
                            </View>
                        </View>
                        <View style={{ flex: 1, margin: photo ? 0 :20, marginBottom: photo ? 0 : 20, backgroundColor: 'white', borderRadius: 5, padding: 20, paddingLeft: photo ? 0 : 20, shadowColor: '#000', shadowOffset: { width: 0, height: 2 }, shadowOpacity: 0.1, shadowRadius: 4, elevation: 3 }}>
                            <Text style={{ textAlign: 'right', fontSize: 14, fontWeight: 500, marginBottom: 10 }}>Billings</Text>
                            {/* <View style={{ flexDirection: 'row' }}>
                                <Text style={{ flex: 1, textAlign: 'left', fontSize: 14 }}>Next Billing Date</Text>
                                <Text style={{ textAlign: 'right', fontSize: 14 }}>1</Text>
                            </View> */}
                            <View style={{ flexDirection: 'row' }}>
                                <Text style={{ flex: 1, textAlign: 'left', fontSize: 14 }}>Earned Rev Thru Prev Period</Text>
                                <Text style={{ textAlign: 'right', fontSize: 14 }}>{JTDRevenuePrevPeriod}</Text>
                            </View>
                            <View style={{ flexDirection: 'row' }}>
                                <Text style={{ flex: 1, textAlign: 'left', fontSize: 14 }}>Estimate Earned Rev</Text>
                                <Text style={{ flex: 1, textAlign: 'right', fontSize: 14 }}>{estEarnedRev}</Text>
                            </View>
                            <View style={{ flexDirection: 'row' }}>
                                <Text style={{ flex: 1, textAlign: 'left', fontSize: 14 }}>Billings</Text>
                                <Text style={{ flex: 1, textAlign: 'right', fontSize: 14 }}>{billings}</Text>
                            </View>
                            <View style={{ flexDirection: 'row' }}>
                                <Text style={{ flex: 1, textAlign: 'left', fontSize: 14 }}>Over/(Under)</Text>
                                <Text style={{ flex: 1, textAlign: 'right', fontSize: 14 }}>{fNum(pNum(billings) - pNum(estEarnedRev), 1)}</Text>
                            </View>
                            <View style={{ flexDirection: 'row' }}>
                                <Text style={{ flex: 1, textAlign: 'left', fontSize: 14 }}>Left to Bill</Text>
                                <Text style={{ flex: 1, textAlign: 'right', fontSize: 14 }}>{leftToBill}</Text>
                            </View>
                            {(!photo || pNum(nteAmount) !== 0) && (
                            <View style={{ flexDirection: 'row' }}>
                                <Text style={{ flex: 1, textAlign: 'left', fontSize: 14 }}>NTE Amount</Text>
                                <View style={{ width: 150, flexDirection: 'row', position: 'relative' }}>
                                    <View style={{ width: 3, height: 20, backgroundColor: 'grey', left: 5, top: 0, position: 'absolute' }}></View>
                                    <TextInput tabIndex="5" style={{ textAlign: 'right', fontSize: 14, width: 150, height: 20, padding: 0, borderWidth: 0 }}
                                        value={nteAmount}
                                        onChangeText={(a) => {
                                            setNteAmount(a)
                                            handleInputChange(a, 'nteAmount')
                                        }} />
                                </View>
                            </View>
                            )}
                        </View>
                        {photo ?
                            <View style={{ width: 700, margin: photo ? 0 : 20, marginBottom: 0, marginRight: 0, backgroundColor: 'white', borderRadius: 5, padding: 20 }}>
                                <Text numberOfLines={8} ellipsizeMode="tail" style={{ padding: 10, fontSize: 12, backgroundColor: '#F9F8FB', borderRadius: 5, height: 195, overflow: 'hidden', whiteSpace: 'pre-wrap' }}>{notes}
                                </Text>
                            </View> :
                            /* Incentive Eligible box hidden for now — flip `false` to re-enable */
                            false && <View style={{ flex: 1, margin: 20, marginRight: 0, backgroundColor: 'white', borderRadius: 5, padding: 20, shadowColor: '#000', shadowOffset: { width: 0, height: 2 }, shadowOpacity: 0.1, shadowRadius: 4, elevation: 3 }}>
                                <Text style={{ textAlign: 'right', fontSize: 14, fontWeight: 500, marginBottom: 10 }}>Incentive Eligible</Text>
                                <View style={{ flexDirection: 'row' }}>
                                    <Text style={{ flex: 1, textAlign: 'left', fontSize: 14 }}>Eligible</Text>
                                    <Text style={{ flex: 1, textAlign: 'right', fontSize: 14 }}>{incentiveEligible}</Text>
                                </View>
                                <View style={{ flexDirection: 'row' }}>
                                    <Text style={{ flex: 1, textAlign: 'left', fontSize: 14 }}>{incentiveEligible == 'Yes' ? 'Eligible Amount' : ''}</Text>
                                    <Text style={{ flex: 1, textAlign: 'right', fontSize: 14 }}>{incentiveEligibleAmount}</Text>
                                </View>
                                {incentiveEligible == 'Yes' && incentiveCalcBreakdown ? <View style={{ flexDirection: 'row', marginTop: 6, alignItems: 'center', flexWrap: 'wrap' }}>
                                    <Text style={{ fontSize: 11, color: '#666', fontStyle: 'italic' }}>Calc: </Text>
                                    <View style={{ flexDirection: 'row', alignItems: 'center', borderBottomWidth: 1, borderBottomColor: '#ccc', marginHorizontal: 1 }}>
                                        <TextInput tabIndex="5" style={{ textAlign: 'center', fontSize: 11, fontStyle: 'italic', color: '#444', width: 24, height: 16, padding: 0, borderWidth: 0, backgroundColor: 'transparent' }}
                                            value={incentiveRate}
                                            onChangeText={(a) => {
                                                setIncentiveRate(a)
                                                handleInputChange(a, 'incentiveRate')
                                            }} />
                                        <Text style={{ fontSize: 11, color: '#666', fontStyle: 'italic' }}>%</Text>
                                    </View>
                                    <Text style={{ fontSize: 11, color: '#666', fontStyle: 'italic' }}> {incentiveCalcBreakdown.split('%').slice(1).join('%')}</Text>
                                </View> : null}
                                <View style={{ flexDirection: 'row' }}>
                                    <Text style={{ flex: 1, textAlign: 'left', fontSize: 11, color: '#999', marginTop: 4 }}>{incentiveEligible == 'Yes' ? '*only calculates if field bonus ETC is zero' : ''}</Text>
                                </View>
                            </View>}
                    </View>
                    {photo ? null : <View style={{ marginTop: 10, backgroundColor: 'white', borderRadius: 5, padding: 20, height: 400, shadowColor: '#000', shadowOffset: { width: 0, height: 2 }, shadowOpacity: 0.1, shadowRadius: 4, elevation: 3 }}>
                        <Text style={{ textAlign: 'right', fontSize: 14, fontWeight: 500, marginBottom: 10 }}>Notes</Text>
                        <TextInput
                            value={notes}
                            onChangeText={(n) => {
                                setNotes(n)
                                handleInputChange(n, 'notes')
                            }}
                            placeholder="Major Cost/Gross Profit Variance Explanations this month"
                            multiline={true}
                            style={{ flex: 1, padding: 20, fontSize: 14, backgroundColor: '#F9F8FB', borderRadius: 5 }}>
                        </TextInput>
                    </View>}
                    {photo ? null : <View style={{ marginTop: 10, backgroundColor: 'white', borderRadius: 5, padding: 20, shadowColor: '#000', shadowOffset: { width: 0, height: 2 }, shadowOpacity: 0.1, shadowRadius: 4, elevation: 3 }}>
                        <ProjectNotes />
                    </View>}
                </View>
                {photo ? null : <div style={{ backgroundColor: 'white', borderRadius: 5, padding: 20, marginTop: 20, marginBottom: 200, display: 'flex', flexWrap: 'wrap', gap: 24 }}>
                    {equipmentEtcList && equipmentEtcList.length ? <div>
                        <div style={{ fontSize: 13, fontWeight: 600, marginBottom: 8, color: '#333' }}>Equipment ETC</div>
                        <table style={{ borderCollapse: 'collapse', fontSize: 12 }}>
                            <thead>
                                <tr style={{ backgroundColor: '#f0f4f8' }}>
                                    <th style={{ border: '1px solid #d0d5dd', padding: '4px 8px', textAlign: 'left', fontWeight: 600 }}>Tab</th>
                                    <th style={{ border: '1px solid #d0d5dd', padding: '4px 8px', textAlign: 'left', fontWeight: 600 }}>GUID</th>
                                    <th style={{ border: '1px solid #d0d5dd', padding: '4px 8px', textAlign: 'left', fontWeight: 600 }}>Cost Type</th>
                                    <th style={{ border: '1px solid #d0d5dd', padding: '4px 8px', textAlign: 'left', fontWeight: 600 }}>Vendor / PO</th>
                                    <th style={{ border: '1px solid #d0d5dd', padding: '4px 8px', textAlign: 'right', fontWeight: 600 }}>ETC</th>
                                    <th style={{ border: '1px solid transparent', padding: '4px 4px', width: 32 }}></th>
                                </tr>
                            </thead>
                            <tbody>
                                {equipmentEtcList.map((row, i) => (
                                    <tr key={i} style={{ backgroundColor: deletingEtcRows.has(row.Forecast_Row_ID) ? '#fee2e2' : (i % 2 === 0 ? '#fff' : '#fafbfc'), opacity: deletingEtcRows.has(row.Forecast_Row_ID) ? 0.5 : 1, transition: 'opacity 0.3s, background-color 0.3s' }}>
                                        <td style={{ border: '1px solid #d0d5dd', padding: '4px 8px' }}>{row.Forecast_Tab}</td>
                                        <td style={{ border: '1px solid #d0d5dd', padding: '4px 8px', fontSize: 10, color: '#888' }}>{row.Forecast_User_Data_GUID}</td>
                                        <td style={{ border: '1px solid #d0d5dd', padding: '4px 8px' }}>{row.Cost_Type}</td>
                                        <td style={{ border: '1px solid #d0d5dd', padding: '4px 8px' }}>{row.Supplier_Name + ' ' + row.PO_Number}</td>
                                        <td style={{ border: '1px solid #d0d5dd', padding: '4px 8px', textAlign: 'right' }}>{row.Value_Amount ? fNum(pNum(row.Value_Amount)) : ''}</td>
                                        <td style={{ padding: '0 4px', textAlign: 'center' }}>
                                            {deletingEtcRows.has(row.Forecast_Row_ID)
                                                ? <span style={{ display: 'inline-block', width: 14, height: 14, border: '2px solid rgba(0,0,0,0.1)', borderTop: '2px solid #d32f2f', borderRadius: '50%', animation: 'spin 0.8s linear infinite' }} />
                                                : <Pressable onPress={() => deleteEtcListItem(row)} style={{ cursor: 'pointer', display: 'inline-flex', alignItems: 'center' }}>
                                                    <Icon3 name="MdDeleteOutline" color="#d32f2f" size={16} />
                                                </Pressable>}
                                        </td>
                                    </tr>
                                ))}
                                <tr style={{ backgroundColor: '#f0f4f8', fontWeight: 'bold' }}>
                                    <td style={{ border: '1px solid #d0d5dd', padding: '4px 8px' }}>Total</td>
                                    <td style={{ border: '1px solid #d0d5dd', padding: '4px 8px' }}></td>
                                    <td style={{ border: '1px solid #d0d5dd', padding: '4px 8px' }}></td>
                                    <td style={{ border: '1px solid #d0d5dd', padding: '4px 8px' }}></td>
                                    <td style={{ border: '1px solid #d0d5dd', padding: '4px 8px', textAlign: 'right' }}>{equipmentEtcTotal}</td>
                                    <td></td>
                                </tr>
                            </tbody>
                        </table>
                    </div> : null}
                    {materialsEtcList && materialsEtcList.length ? <div>
                        <div style={{ fontSize: 13, fontWeight: 600, marginBottom: 8, color: '#333' }}>Materials ETC</div>
                        <table style={{ borderCollapse: 'collapse', fontSize: 12 }}>
                            <thead>
                                <tr style={{ backgroundColor: '#f0f4f8' }}>
                                    <th style={{ border: '1px solid #d0d5dd', padding: '4px 8px', textAlign: 'left', fontWeight: 600 }}>Tab</th>
                                    <th style={{ border: '1px solid #d0d5dd', padding: '4px 8px', textAlign: 'left', fontWeight: 600 }}>GUID</th>
                                    <th style={{ border: '1px solid #d0d5dd', padding: '4px 8px', textAlign: 'left', fontWeight: 600 }}>Cost Type</th>
                                    <th style={{ border: '1px solid #d0d5dd', padding: '4px 8px', textAlign: 'left', fontWeight: 600 }}>Vendor / PO</th>
                                    <th style={{ border: '1px solid #d0d5dd', padding: '4px 8px', textAlign: 'right', fontWeight: 600 }}>ETC</th>
                                    <th style={{ border: '1px solid transparent', padding: '4px 4px', width: 32 }}></th>
                                </tr>
                            </thead>
                            <tbody>
                                {materialsEtcList.map((row, i) => (
                                    <tr key={i} style={{ backgroundColor: deletingEtcRows.has(row.Forecast_Row_ID) ? '#fee2e2' : (i % 2 === 0 ? '#fff' : '#fafbfc'), opacity: deletingEtcRows.has(row.Forecast_Row_ID) ? 0.5 : 1, transition: 'opacity 0.3s, background-color 0.3s' }}>
                                        <td style={{ border: '1px solid #d0d5dd', padding: '4px 8px' }}>{row.Forecast_Tab}</td>
                                        <td style={{ border: '1px solid #d0d5dd', padding: '4px 8px', fontSize: 10, color: '#888' }}>{row.Forecast_User_Data_GUID}</td>
                                        <td style={{ border: '1px solid #d0d5dd', padding: '4px 8px' }}>{row.Cost_Type}</td>
                                        <td style={{ border: '1px solid #d0d5dd', padding: '4px 8px' }}>{row.Supplier_Name + ' ' + row.PO_Number}</td>
                                        <td style={{ border: '1px solid #d0d5dd', padding: '4px 8px', textAlign: 'right' }}>{row.Value_Amount ? fNum(pNum(row.Value_Amount)) : ''}</td>
                                        <td style={{ padding: '0 4px', textAlign: 'center' }}>
                                            {deletingEtcRows.has(row.Forecast_Row_ID)
                                                ? <span style={{ display: 'inline-block', width: 14, height: 14, border: '2px solid rgba(0,0,0,0.1)', borderTop: '2px solid #d32f2f', borderRadius: '50%', animation: 'spin 0.8s linear infinite' }} />
                                                : <Pressable onPress={() => deleteEtcListItem(row)} style={{ cursor: 'pointer', display: 'inline-flex', alignItems: 'center' }}>
                                                    <Icon3 name="MdDeleteOutline" color="#d32f2f" size={16} />
                                                </Pressable>}
                                        </td>
                                    </tr>
                                ))}
                                <tr style={{ backgroundColor: '#f0f4f8', fontWeight: 'bold' }}>
                                    <td style={{ border: '1px solid #d0d5dd', padding: '4px 8px' }}>Total (Mat Tab)</td>
                                    <td style={{ border: '1px solid #d0d5dd', padding: '4px 8px' }}></td>
                                    <td style={{ border: '1px solid #d0d5dd', padding: '4px 8px' }}></td>
                                    <td style={{ border: '1px solid #d0d5dd', padding: '4px 8px' }}></td>
                                    <td style={{ border: '1px solid #d0d5dd', padding: '4px 8px', textAlign: 'right' }}>{materialsEtcTotalTwo}</td>
                                    <td></td>
                                </tr>
                                <tr style={{ backgroundColor: '#f0f4f8', fontWeight: 'bold' }}>
                                    <td style={{ border: '1px solid #d0d5dd', padding: '4px 8px' }}>Total</td>
                                    <td style={{ border: '1px solid #d0d5dd', padding: '4px 8px' }}></td>
                                    <td style={{ border: '1px solid #d0d5dd', padding: '4px 8px' }}></td>
                                    <td style={{ border: '1px solid #d0d5dd', padding: '4px 8px' }}></td>
                                    <td style={{ border: '1px solid #d0d5dd', padding: '4px 8px', textAlign: 'right' }}>{materialsEtcTotal}</td>
                                    <td></td>
                                </tr>
                            </tbody>
                        </table>
                    </div> : null}
                    {subcontractorsEtcList && subcontractorsEtcList.length ? <div>
                        <div style={{ fontSize: 13, fontWeight: 600, marginBottom: 8, color: '#333' }}>Subcontractors ETC</div>
                        <table style={{ borderCollapse: 'collapse', fontSize: 12 }}>
                            <thead>
                                <tr style={{ backgroundColor: '#f0f4f8' }}>
                                    <th style={{ border: '1px solid #d0d5dd', padding: '4px 8px', textAlign: 'left', fontWeight: 600 }}>Tab</th>
                                    <th style={{ border: '1px solid #d0d5dd', padding: '4px 8px', textAlign: 'left', fontWeight: 600 }}>GUID</th>
                                    <th style={{ border: '1px solid #d0d5dd', padding: '4px 8px', textAlign: 'left', fontWeight: 600 }}>Cost Type</th>
                                    <th style={{ border: '1px solid #d0d5dd', padding: '4px 8px', textAlign: 'left', fontWeight: 600 }}>Vendor / PO</th>
                                    <th style={{ border: '1px solid #d0d5dd', padding: '4px 8px', textAlign: 'right', fontWeight: 600 }}>ETC</th>
                                    <th style={{ border: '1px solid transparent', padding: '4px 4px', width: 32 }}></th>
                                </tr>
                            </thead>
                            <tbody>
                                {subcontractorsEtcList.map((row, i) => (
                                    <tr key={i} style={{ backgroundColor: deletingEtcRows.has(row.Forecast_Row_ID) ? '#fee2e2' : (i % 2 === 0 ? '#fff' : '#fafbfc'), opacity: deletingEtcRows.has(row.Forecast_Row_ID) ? 0.5 : 1, transition: 'opacity 0.3s, background-color 0.3s' }}>
                                        <td style={{ border: '1px solid #d0d5dd', padding: '4px 8px' }}>{row.Forecast_Tab}</td>
                                        <td style={{ border: '1px solid #d0d5dd', padding: '4px 8px', fontSize: 10, color: '#888' }}>{row.Forecast_User_Data_GUID}</td>
                                        <td style={{ border: '1px solid #d0d5dd', padding: '4px 8px' }}>{row.Cost_Type}</td>
                                        <td style={{ border: '1px solid #d0d5dd', padding: '4px 8px' }}>{row.Supplier_Name + ' ' + row.PO_Number}</td>
                                        <td style={{ border: '1px solid #d0d5dd', padding: '4px 8px', textAlign: 'right' }}>{row.Value_Amount ? fNum(pNum(row.Value_Amount)) : ''}</td>
                                        <td style={{ padding: '0 4px', textAlign: 'center' }}>
                                            {deletingEtcRows.has(row.Forecast_Row_ID)
                                                ? <span style={{ display: 'inline-block', width: 14, height: 14, border: '2px solid rgba(0,0,0,0.1)', borderTop: '2px solid #d32f2f', borderRadius: '50%', animation: 'spin 0.8s linear infinite' }} />
                                                : <Pressable onPress={() => deleteEtcListItem(row)} style={{ cursor: 'pointer', display: 'inline-flex', alignItems: 'center' }}>
                                                    <Icon3 name="MdDeleteOutline" color="#d32f2f" size={16} />
                                                </Pressable>}
                                        </td>
                                    </tr>
                                ))}
                                <tr style={{ backgroundColor: '#f0f4f8', fontWeight: 'bold' }}>
                                    <td style={{ border: '1px solid #d0d5dd', padding: '4px 8px' }}>Total</td>
                                    <td style={{ border: '1px solid #d0d5dd', padding: '4px 8px' }}></td>
                                    <td style={{ border: '1px solid #d0d5dd', padding: '4px 8px' }}></td>
                                    <td style={{ border: '1px solid #d0d5dd', padding: '4px 8px' }}></td>
                                    <td style={{ border: '1px solid #d0d5dd', padding: '4px 8px', textAlign: 'right' }}>{subcontractorsEtcTotal}</td>
                                    <td></td>
                                </tr>
                            </tbody>
                        </table>
                    </div> : null}
                    {otherEtcList && otherEtcList.length ? <div>
                        <div style={{ fontSize: 13, fontWeight: 600, marginBottom: 8, color: '#333' }}>Other Expenses ETC</div>
                        <table style={{ borderCollapse: 'collapse', fontSize: 12 }}>
                            <thead>
                                <tr style={{ backgroundColor: '#f0f4f8' }}>
                                    <th style={{ border: '1px solid #d0d5dd', padding: '4px 8px', textAlign: 'left', fontWeight: 600 }}>Tab</th>
                                    <th style={{ border: '1px solid #d0d5dd', padding: '4px 8px', textAlign: 'left', fontWeight: 600 }}>GUID</th>
                                    <th style={{ border: '1px solid #d0d5dd', padding: '4px 8px', textAlign: 'left', fontWeight: 600 }}>Cost Type</th>
                                    <th style={{ border: '1px solid #d0d5dd', padding: '4px 8px', textAlign: 'left', fontWeight: 600 }}>Vendor / PO</th>
                                    <th style={{ border: '1px solid #d0d5dd', padding: '4px 8px', textAlign: 'right', fontWeight: 600 }}>ETC</th>
                                    <th style={{ border: '1px solid transparent', padding: '4px 4px', width: 32 }}></th>
                                </tr>
                            </thead>
                            <tbody>
                                {otherEtcList.map((row, i) => (
                                    <tr key={i} style={{ backgroundColor: deletingEtcRows.has(row.Forecast_Row_ID) ? '#fee2e2' : (i % 2 === 0 ? '#fff' : '#fafbfc'), opacity: deletingEtcRows.has(row.Forecast_Row_ID) ? 0.5 : 1, transition: 'opacity 0.3s, background-color 0.3s' }}>
                                        <td style={{ border: '1px solid #d0d5dd', padding: '4px 8px' }}>{row.Forecast_Tab}</td>
                                        <td style={{ border: '1px solid #d0d5dd', padding: '4px 8px', fontSize: 10, color: '#888' }}>{row.Forecast_User_Data_GUID}</td>
                                        <td style={{ border: '1px solid #d0d5dd', padding: '4px 8px' }}>{row.Cost_Type}</td>
                                        <td style={{ border: '1px solid #d0d5dd', padding: '4px 8px' }}>{row.Supplier_Name + ' ' + row.PO_Number}</td>
                                        <td style={{ border: '1px solid #d0d5dd', padding: '4px 8px', textAlign: 'right' }}>{row.Value_Amount ? fNum(pNum(row.Value_Amount)) : ''}</td>
                                        <td style={{ padding: '0 4px', textAlign: 'center' }}>
                                            {deletingEtcRows.has(row.Forecast_Row_ID)
                                                ? <span style={{ display: 'inline-block', width: 14, height: 14, border: '2px solid rgba(0,0,0,0.1)', borderTop: '2px solid #d32f2f', borderRadius: '50%', animation: 'spin 0.8s linear infinite' }} />
                                                : <Pressable onPress={() => deleteEtcListItem(row)} style={{ cursor: 'pointer', display: 'inline-flex', alignItems: 'center' }}>
                                                    <Icon3 name="MdDeleteOutline" color="#d32f2f" size={16} />
                                                </Pressable>}
                                        </td>
                                    </tr>
                                ))}
                                <tr style={{ backgroundColor: '#f0f4f8', fontWeight: 'bold' }}>
                                    <td style={{ border: '1px solid #d0d5dd', padding: '4px 8px' }}>Total</td>
                                    <td style={{ border: '1px solid #d0d5dd', padding: '4px 8px' }}></td>
                                    <td style={{ border: '1px solid #d0d5dd', padding: '4px 8px' }}></td>
                                    <td style={{ border: '1px solid #d0d5dd', padding: '4px 8px' }}></td>
                                    <td style={{ border: '1px solid #d0d5dd', padding: '4px 8px', textAlign: 'right' }}>{otherEtcTotal}</td>
                                    <td></td>
                                </tr>
                            </tbody>
                        </table>
                    </div> : null}
                    {phasedLaborRows?.length ? <div>
                        <div style={{ fontSize: 13, fontWeight: 600, marginBottom: 8, color: '#333' }}>All Phased Labor ETC <span style={{ fontWeight: 400, fontSize: 11, color: '#888' }}>(resets crew size)</span></div>
                        <table style={{ borderCollapse: 'collapse', fontSize: 12 }}>
                            <thead>
                                <tr style={{ backgroundColor: '#f0f4f8' }}>
                                    <th style={{ border: '1px solid #d0d5dd', padding: '4px 8px', textAlign: 'left', fontWeight: 600 }}>Phase</th>
                                    <th style={{ border: '1px solid #d0d5dd', padding: '4px 8px', textAlign: 'left', fontWeight: 600 }}>Week</th>
                                    <th style={{ border: '1px solid #d0d5dd', padding: '4px 8px', textAlign: 'right', fontWeight: 600 }}>Hrs/Wk</th>
                                    <th style={{ border: '1px solid #d0d5dd', padding: '4px 8px', textAlign: 'right', fontWeight: 600 }}>Burn Rate</th>
                                    <th style={{ border: '1px solid #d0d5dd', padding: '4px 8px', textAlign: 'right', fontWeight: 600 }}>Crew</th>
                                    <th style={{ border: '1px solid #d0d5dd', padding: '4px 8px', textAlign: 'right', fontWeight: 600 }}>ETC</th>
                                    <th style={{ border: '1px solid transparent', padding: '4px 4px', width: 32 }}></th>
                                </tr>
                            </thead>
                            <tbody>
                                {phasedLaborRows.map((row, i) => (
                                    <tr key={i} style={{ backgroundColor: deletingEtcRows.has(row.Forecast_Row_ID) ? '#fee2e2' : (i % 2 === 0 ? '#fff' : '#fafbfc'), opacity: deletingEtcRows.has(row.Forecast_Row_ID) ? 0.5 : 1, transition: 'opacity 0.3s, background-color 0.3s' }}>
                                        <td style={{ border: '1px solid #d0d5dd', padding: '4px 8px' }}>{row.phase}</td>
                                        <td style={{ border: '1px solid #d0d5dd', padding: '4px 8px' }}>{row.week}</td>
                                        <td style={{ border: '1px solid #d0d5dd', padding: '4px 8px', textAlign: 'right' }}>{fNum(row.hoursWeek)}</td>
                                        <td style={{ border: '1px solid #d0d5dd', padding: '4px 8px', textAlign: 'right' }}>{fNum(row.burnRate)}</td>
                                        <td style={{ border: '1px solid #d0d5dd', padding: '4px 8px', textAlign: 'right' }}>{fNum(row.crewSize)}</td>
                                        <td style={{ border: '1px solid #d0d5dd', padding: '4px 8px', textAlign: 'right' }}>{fNum(row.estCost)}</td>
                                        <td style={{ padding: '0 4px', textAlign: 'center' }}>
                                            {deletingEtcRows.has(row.Forecast_Row_ID)
                                                ? <span style={{ display: 'inline-block', width: 14, height: 14, border: '2px solid rgba(0,0,0,0.1)', borderTop: '2px solid #d32f2f', borderRadius: '50%', animation: 'spin 0.8s linear infinite' }} />
                                                : <Pressable onPress={() => deleteEtcListItemBurnLabor(row)} style={{ cursor: 'pointer', display: 'inline-flex', alignItems: 'center' }}>
                                                    <Icon3 name="MdDeleteOutline" color="#d32f2f" size={16} />
                                                </Pressable>}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div> : null}
                    {phasedEquipmentRows?.length ? <div>
                        <div style={{ fontSize: 13, fontWeight: 600, marginBottom: 8, color: '#333' }}>All Phased Equipment ETC <span style={{ fontWeight: 400, fontSize: 11, color: '#888' }}>(resets number of equipment)</span></div>
                        <table style={{ borderCollapse: 'collapse', fontSize: 12 }}>
                            <thead>
                                <tr style={{ backgroundColor: '#f0f4f8' }}>
                                    <th style={{ border: '1px solid #d0d5dd', padding: '4px 8px', textAlign: 'left', fontWeight: 600 }}>Equipment</th>
                                    <th style={{ border: '1px solid #d0d5dd', padding: '4px 8px', textAlign: 'left', fontWeight: 600 }}>Week</th>
                                    <th style={{ border: '1px solid #d0d5dd', padding: '4px 8px', textAlign: 'right', fontWeight: 600 }}>Hrs/Wk</th>
                                    <th style={{ border: '1px solid #d0d5dd', padding: '4px 8px', textAlign: 'right', fontWeight: 600 }}>Burn Rate</th>
                                    <th style={{ border: '1px solid #d0d5dd', padding: '4px 8px', textAlign: 'right', fontWeight: 600 }}>Number</th>
                                    <th style={{ border: '1px solid #d0d5dd', padding: '4px 8px', textAlign: 'right', fontWeight: 600 }}>ETC</th>
                                    <th style={{ border: '1px solid transparent', padding: '4px 4px', width: 32 }}></th>
                                </tr>
                            </thead>
                            <tbody>
                                {phasedEquipmentRows.map((row, i) => (
                                    <tr key={i} style={{ backgroundColor: deletingEtcRows.has(row.Forecast_Row_ID) ? '#fee2e2' : (i % 2 === 0 ? '#fff' : '#fafbfc'), opacity: deletingEtcRows.has(row.Forecast_Row_ID) ? 0.5 : 1, transition: 'opacity 0.3s, background-color 0.3s' }}>
                                        <td style={{ border: '1px solid #d0d5dd', padding: '4px 8px' }}>{row.equipment}</td>
                                        <td style={{ border: '1px solid #d0d5dd', padding: '4px 8px' }}>{row.week}</td>
                                        <td style={{ border: '1px solid #d0d5dd', padding: '4px 8px', textAlign: 'right' }}>{fNum(row.estHours)}</td>
                                        <td style={{ border: '1px solid #d0d5dd', padding: '4px 8px', textAlign: 'right' }}>{fNum(row.burnRate)}</td>
                                        <td style={{ border: '1px solid #d0d5dd', padding: '4px 8px', textAlign: 'right' }}>{fNum(row.numberEquipment)}</td>
                                        <td style={{ border: '1px solid #d0d5dd', padding: '4px 8px', textAlign: 'right' }}>{fNum(row.estCost)}</td>
                                        <td style={{ padding: '0 4px', textAlign: 'center' }}>
                                            {deletingEtcRows.has(row.Forecast_Row_ID)
                                                ? <span style={{ display: 'inline-block', width: 14, height: 14, border: '2px solid rgba(0,0,0,0.1)', borderTop: '2px solid #d32f2f', borderRadius: '50%', animation: 'spin 0.8s linear infinite' }} />
                                                : <Pressable onPress={() => deleteEtcListItemBurnEquipment(row)} style={{ cursor: 'pointer', display: 'inline-flex', alignItems: 'center' }}>
                                                    <Icon3 name="MdDeleteOutline" color="#d32f2f" size={16} />
                                                </Pressable>}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div> : null}
                </div>}
            </View>
            {/* Service Offering panel — labor rolled up one level above phase code, mirroring the
                manual PSR "Labor over/under" block. Lives on the right, always visible next to the
                cost table (not in the LEMSO/Phases/Resource tab strip). See docs/SERVICE_OFFERING_ROLLUP.md. */}
            {canSeeServiceOffering && !photo && serviceOfferingRows.length > 0 && (
                <View style={{ width: 360, marginLeft: 20, marginTop: 30, marginRight: 30 }}>
                    <View style={{ backgroundColor: 'white', borderRadius: 5, padding: 16, shadowColor: '#000', shadowOffset: { width: 0, height: 2 }, shadowOpacity: 0.1, shadowRadius: 4, elevation: 3, position: 'sticky', top: 20 }}>
                        <Text style={{ fontSize: 14, fontWeight: '700', color: '#192440', marginBottom: 2 }}>Service Offering — Labor</Text>
                        <Text style={{ fontSize: 10, color: '#888', marginBottom: 12 }}>Phase rollup · grouped by prefix</Text>

                        {/* Column header */}
                        <View style={{ flexDirection: 'row', borderBottomWidth: 2, borderColor: '#eef2f6', paddingBottom: 4, marginBottom: 2 }}>
                            <Text style={{ flex: 1, fontSize: 9, fontWeight: '600', color: '#667085' }}>Offering</Text>
                            <Text style={{ width: 74, fontSize: 9, fontWeight: '600', color: '#667085', textAlign: 'right' }}>$ Spent{'\n'}Last Wk</Text>
                            <Text style={{ width: 64, fontSize: 9, fontWeight: '600', color: '#667085', textAlign: 'right' }}>Hrs{'\n'}Last Wk</Text>
                            <Text style={{ width: 64, fontSize: 9, fontWeight: '600', color: '#667085', textAlign: 'right' }}>Hrs{'\n'}Remaining</Text>
                        </View>

                        {/* Combined total */}
                        <View style={{ flexDirection: 'row', alignItems: 'center', paddingVertical: 6, borderBottomWidth: 2, borderColor: '#eef2f6', backgroundColor: '#f7f9fb' }}>
                            <Text style={{ flex: 1, fontSize: 11, fontWeight: '700', color: '#192440' }}>Combined</Text>
                            <Text style={{ width: 74, fontSize: 11, fontWeight: '700', color: '#192440', textAlign: 'right' }}>{serviceOfferingTotals.dollarsLastWeek || '-'}</Text>
                            <Text style={{ width: 64, fontSize: 11, fontWeight: '700', color: '#192440', textAlign: 'right' }}>{serviceOfferingTotals.hoursLastWeek || '-'}</Text>
                            <Text style={{ width: 64, fontSize: 11, fontWeight: '700', color: '#192440', textAlign: 'right' }}>{serviceOfferingTotals.hoursRemaining || '-'}</Text>
                        </View>

                        {serviceOfferingRows.map((row, idx) => {
                            const expanded = expandedServiceOfferings[row.title]
                            return (
                                <View key={idx}>
                                    <Pressable
                                        onPress={() => setExpandedServiceOfferings(prev => ({ ...prev, [row.title]: !prev[row.title] }))}
                                        style={{ flexDirection: 'row', alignItems: 'center', paddingVertical: 5, borderBottomWidth: 1, borderColor: '#f4f6f8', cursor: 'pointer' }}
                                    >
                                        <Text style={{ flex: 1, fontSize: 11, fontWeight: '600', color: '#192440' }} numberOfLines={1}>
                                            {(expanded ? '▾ ' : '▸ ') + row.title}
                                        </Text>
                                        <Text style={{ width: 74, fontSize: 11, color: '#344054', textAlign: 'right' }}>{row.dollarsLastWeek || '-'}</Text>
                                        <Text style={{ width: 64, fontSize: 11, color: '#344054', textAlign: 'right' }}>{row.hoursLastWeek || '-'}</Text>
                                        <Text style={{ width: 64, fontSize: 11, color: '#344054', textAlign: 'right' }}>{row.hoursRemaining || '-'}</Text>
                                    </Pressable>
                                    {expanded && row.subRows.map((sub, sidx) => (
                                        <View key={sidx} style={{ flexDirection: 'row', alignItems: 'center', paddingVertical: 3, paddingLeft: 12, backgroundColor: '#fbfcfd' }}>
                                            <Text style={{ flex: 1, fontSize: 10, color: '#667085' }} numberOfLines={1}>{sub.title}</Text>
                                            <Text style={{ width: 74, fontSize: 10, color: '#667085', textAlign: 'right' }}>{sub.dollarsLastWeek || '-'}</Text>
                                            <Text style={{ width: 64, fontSize: 10, color: '#667085', textAlign: 'right' }}>{sub.hoursLastWeek || '-'}</Text>
                                            <Text style={{ width: 64, fontSize: 10, color: '#667085', textAlign: 'right' }}>{sub.hoursRemaining || '-'}</Text>
                                        </View>
                                    ))}
                                </View>
                            )
                        })}
                    </View>
                </View>
            )}
        </View>
    );
};

export default BidForecast;



